import ir from "swr";
import V, { forwardRef as ye, useState as D, useMemo as Bn, useRef as Q, useEffect as W, Fragment as Te, useCallback as Xt, createContext as mt, useContext as zn, useLayoutEffect as Fn, createElement as Dt } from "react";
import Hn from "deepmerge";
import { clsx as ar } from "clsx";
import { twMerge as or } from "tailwind-merge";
import { RadioGroup as Nt, Switch as lr, Transition as oe, Dialog as gn, Disclosure as de, Menu as he, Popover as Re } from "@headlessui/react";
import { useInView as cr } from "react-intersection-observer";
import { nanoid as dr } from "nanoid";
import { useIdleTimer as ur } from "react-idle-timer";
var Bt = { exports: {} }, He = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vn;
function fr() {
  if (vn)
    return He;
  vn = 1;
  var e = V, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, o, d) {
    var u, f = {}, h = null, m = null;
    d !== void 0 && (h = "" + d), o.key !== void 0 && (h = "" + o.key), o.ref !== void 0 && (m = o.ref);
    for (u in o)
      s.call(o, u) && !i.hasOwnProperty(u) && (f[u] = o[u]);
    if (c && c.defaultProps)
      for (u in o = c.defaultProps, o)
        f[u] === void 0 && (f[u] = o[u]);
    return { $$typeof: t, type: c, key: h, ref: m, props: f, _owner: r.current };
  }
  return He.Fragment = n, He.jsx = l, He.jsxs = l, He;
}
var Ve = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wn;
function pr() {
  return wn || (wn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = V, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = Symbol.iterator, g = "@@iterator";
    function y(p) {
      if (p === null || typeof p != "object")
        return null;
      var w = v && p[v] || p[g];
      return typeof w == "function" ? w : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(p) {
      {
        for (var w = arguments.length, T = new Array(w > 1 ? w - 1 : 0), O = 1; O < w; O++)
          T[O - 1] = arguments[O];
        j("error", p, T);
      }
    }
    function j(p, w, T) {
      {
        var O = x.ReactDebugCurrentFrame, z = O.getStackAddendum();
        z !== "" && (w += "%s", T = T.concat([z]));
        var F = T.map(function(R) {
          return String(R);
        });
        F.unshift("Warning: " + w), Function.prototype.apply.call(console[p], console, F);
      }
    }
    var C = !1, N = !1, M = !1, _ = !1, L = !1, S;
    S = Symbol.for("react.module.reference");
    function B(p) {
      return !!(typeof p == "string" || typeof p == "function" || p === s || p === i || L || p === r || p === d || p === u || _ || p === m || C || N || M || typeof p == "object" && p !== null && (p.$$typeof === h || p.$$typeof === f || p.$$typeof === l || p.$$typeof === c || p.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      p.$$typeof === S || p.getModuleId !== void 0));
    }
    function E(p, w, T) {
      var O = p.displayName;
      if (O)
        return O;
      var z = w.displayName || w.name || "";
      return z !== "" ? T + "(" + z + ")" : T;
    }
    function k(p) {
      return p.displayName || "Context";
    }
    function I(p) {
      if (p == null)
        return null;
      if (typeof p.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof p == "function")
        return p.displayName || p.name || null;
      if (typeof p == "string")
        return p;
      switch (p) {
        case s:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case r:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case c:
            var w = p;
            return k(w) + ".Consumer";
          case l:
            var T = p;
            return k(T._context) + ".Provider";
          case o:
            return E(p, p.render, "ForwardRef");
          case f:
            var O = p.displayName || null;
            return O !== null ? O : I(p.type) || "Memo";
          case h: {
            var z = p, F = z._payload, R = z._init;
            try {
              return I(R(F));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, re = 0, Ce, Oe, Ie, Y, Z, ze, Ke;
    function Ze() {
    }
    Ze.__reactDisabledLog = !0;
    function Ls() {
      {
        if (re === 0) {
          Ce = console.log, Oe = console.info, Ie = console.warn, Y = console.error, Z = console.group, ze = console.groupCollapsed, Ke = console.groupEnd;
          var p = {
            configurable: !0,
            enumerable: !0,
            value: Ze,
            writable: !0
          };
          Object.defineProperties(console, {
            info: p,
            log: p,
            warn: p,
            error: p,
            group: p,
            groupCollapsed: p,
            groupEnd: p
          });
        }
        re++;
      }
    }
    function As() {
      {
        if (re--, re === 0) {
          var p = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, p, {
              value: Ce
            }),
            info: H({}, p, {
              value: Oe
            }),
            warn: H({}, p, {
              value: Ie
            }),
            error: H({}, p, {
              value: Y
            }),
            group: H({}, p, {
              value: Z
            }),
            groupCollapsed: H({}, p, {
              value: ze
            }),
            groupEnd: H({}, p, {
              value: Ke
            })
          });
        }
        re < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var wt = x.ReactCurrentDispatcher, bt;
    function Je(p, w, T) {
      {
        if (bt === void 0)
          try {
            throw Error();
          } catch (z) {
            var O = z.stack.trim().match(/\n( *(at )?)/);
            bt = O && O[1] || "";
          }
        return `
` + bt + p;
      }
    }
    var yt = !1, Qe;
    {
      var $s = typeof WeakMap == "function" ? WeakMap : Map;
      Qe = new $s();
    }
    function nn(p, w) {
      if (!p || yt)
        return "";
      {
        var T = Qe.get(p);
        if (T !== void 0)
          return T;
      }
      var O;
      yt = !0;
      var z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var F;
      F = wt.current, wt.current = null, Ls();
      try {
        if (w) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (fe) {
              O = fe;
            }
            Reflect.construct(p, [], R);
          } else {
            try {
              R.call();
            } catch (fe) {
              O = fe;
            }
            p.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (fe) {
            O = fe;
          }
          p();
        }
      } catch (fe) {
        if (fe && O && typeof fe.stack == "string") {
          for (var A = fe.stack.split(`
`), K = O.stack.split(`
`), U = A.length - 1, q = K.length - 1; U >= 1 && q >= 0 && A[U] !== K[q]; )
            q--;
          for (; U >= 1 && q >= 0; U--, q--)
            if (A[U] !== K[q]) {
              if (U !== 1 || q !== 1)
                do
                  if (U--, q--, q < 0 || A[U] !== K[q]) {
                    var ie = `
` + A[U].replace(" at new ", " at ");
                    return p.displayName && ie.includes("<anonymous>") && (ie = ie.replace("<anonymous>", p.displayName)), typeof p == "function" && Qe.set(p, ie), ie;
                  }
                while (U >= 1 && q >= 0);
              break;
            }
        }
      } finally {
        yt = !1, wt.current = F, As(), Error.prepareStackTrace = z;
      }
      var Ae = p ? p.displayName || p.name : "", xn = Ae ? Je(Ae) : "";
      return typeof p == "function" && Qe.set(p, xn), xn;
    }
    function Rs(p, w, T) {
      return nn(p, !1);
    }
    function Ds(p) {
      var w = p.prototype;
      return !!(w && w.isReactComponent);
    }
    function et(p, w, T) {
      if (p == null)
        return "";
      if (typeof p == "function")
        return nn(p, Ds(p));
      if (typeof p == "string")
        return Je(p);
      switch (p) {
        case d:
          return Je("Suspense");
        case u:
          return Je("SuspenseList");
      }
      if (typeof p == "object")
        switch (p.$$typeof) {
          case o:
            return Rs(p.render);
          case f:
            return et(p.type, w, T);
          case h: {
            var O = p, z = O._payload, F = O._init;
            try {
              return et(F(z), w, T);
            } catch {
            }
          }
        }
      return "";
    }
    var tt = Object.prototype.hasOwnProperty, sn = {}, rn = x.ReactDebugCurrentFrame;
    function nt(p) {
      if (p) {
        var w = p._owner, T = et(p.type, p._source, w ? w.type : null);
        rn.setExtraStackFrame(T);
      } else
        rn.setExtraStackFrame(null);
    }
    function Bs(p, w, T, O, z) {
      {
        var F = Function.call.bind(tt);
        for (var R in p)
          if (F(p, R)) {
            var A = void 0;
            try {
              if (typeof p[R] != "function") {
                var K = Error((O || "React class") + ": " + T + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K.name = "Invariant Violation", K;
              }
              A = p[R](w, R, O, T, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (U) {
              A = U;
            }
            A && !(A instanceof Error) && (nt(z), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", O || "React class", T, R, typeof A), nt(null)), A instanceof Error && !(A.message in sn) && (sn[A.message] = !0, nt(z), b("Failed %s type: %s", T, A.message), nt(null));
          }
      }
    }
    var zs = Array.isArray;
    function jt(p) {
      return zs(p);
    }
    function Fs(p) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, T = w && p[Symbol.toStringTag] || p.constructor.name || "Object";
        return T;
      }
    }
    function Hs(p) {
      try {
        return an(p), !1;
      } catch {
        return !0;
      }
    }
    function an(p) {
      return "" + p;
    }
    function on(p) {
      if (Hs(p))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Fs(p)), an(p);
    }
    var Fe = x.ReactCurrentOwner, Vs = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ln, cn, St;
    St = {};
    function Gs(p) {
      if (tt.call(p, "ref")) {
        var w = Object.getOwnPropertyDescriptor(p, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return p.ref !== void 0;
    }
    function Us(p) {
      if (tt.call(p, "key")) {
        var w = Object.getOwnPropertyDescriptor(p, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return p.key !== void 0;
    }
    function Ws(p, w) {
      if (typeof p.ref == "string" && Fe.current && w && Fe.current.stateNode !== w) {
        var T = I(Fe.current.type);
        St[T] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', I(Fe.current.type), p.ref), St[T] = !0);
      }
    }
    function Ys(p, w) {
      {
        var T = function() {
          ln || (ln = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        T.isReactWarning = !0, Object.defineProperty(p, "key", {
          get: T,
          configurable: !0
        });
      }
    }
    function qs(p, w) {
      {
        var T = function() {
          cn || (cn = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        T.isReactWarning = !0, Object.defineProperty(p, "ref", {
          get: T,
          configurable: !0
        });
      }
    }
    var Xs = function(p, w, T, O, z, F, R) {
      var A = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: p,
        key: w,
        ref: T,
        props: R,
        // Record the component responsible for creating this element.
        _owner: F
      };
      return A._store = {}, Object.defineProperty(A._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(A, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: O
      }), Object.defineProperty(A, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z
      }), Object.freeze && (Object.freeze(A.props), Object.freeze(A)), A;
    };
    function Ks(p, w, T, O, z) {
      {
        var F, R = {}, A = null, K = null;
        T !== void 0 && (on(T), A = "" + T), Us(w) && (on(w.key), A = "" + w.key), Gs(w) && (K = w.ref, Ws(w, z));
        for (F in w)
          tt.call(w, F) && !Vs.hasOwnProperty(F) && (R[F] = w[F]);
        if (p && p.defaultProps) {
          var U = p.defaultProps;
          for (F in U)
            R[F] === void 0 && (R[F] = U[F]);
        }
        if (A || K) {
          var q = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
          A && Ys(R, q), K && qs(R, q);
        }
        return Xs(p, A, K, z, O, Fe.current, R);
      }
    }
    var Ct = x.ReactCurrentOwner, dn = x.ReactDebugCurrentFrame;
    function Le(p) {
      if (p) {
        var w = p._owner, T = et(p.type, p._source, w ? w.type : null);
        dn.setExtraStackFrame(T);
      } else
        dn.setExtraStackFrame(null);
    }
    var Tt;
    Tt = !1;
    function Et(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function un() {
      {
        if (Ct.current) {
          var p = I(Ct.current.type);
          if (p)
            return `

Check the render method of \`` + p + "`.";
        }
        return "";
      }
    }
    function Zs(p) {
      {
        if (p !== void 0) {
          var w = p.fileName.replace(/^.*[\\\/]/, ""), T = p.lineNumber;
          return `

Check your code at ` + w + ":" + T + ".";
        }
        return "";
      }
    }
    var fn = {};
    function Js(p) {
      {
        var w = un();
        if (!w) {
          var T = typeof p == "string" ? p : p.displayName || p.name;
          T && (w = `

Check the top-level render call using <` + T + ">.");
        }
        return w;
      }
    }
    function pn(p, w) {
      {
        if (!p._store || p._store.validated || p.key != null)
          return;
        p._store.validated = !0;
        var T = Js(w);
        if (fn[T])
          return;
        fn[T] = !0;
        var O = "";
        p && p._owner && p._owner !== Ct.current && (O = " It was passed a child from " + I(p._owner.type) + "."), Le(p), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', T, O), Le(null);
      }
    }
    function mn(p, w) {
      {
        if (typeof p != "object")
          return;
        if (jt(p))
          for (var T = 0; T < p.length; T++) {
            var O = p[T];
            Et(O) && pn(O, w);
          }
        else if (Et(p))
          p._store && (p._store.validated = !0);
        else if (p) {
          var z = y(p);
          if (typeof z == "function" && z !== p.entries)
            for (var F = z.call(p), R; !(R = F.next()).done; )
              Et(R.value) && pn(R.value, w);
        }
      }
    }
    function Qs(p) {
      {
        var w = p.type;
        if (w == null || typeof w == "string")
          return;
        var T;
        if (typeof w == "function")
          T = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        w.$$typeof === f))
          T = w.propTypes;
        else
          return;
        if (T) {
          var O = I(w);
          Bs(T, p.props, "prop", O, p);
        } else if (w.PropTypes !== void 0 && !Tt) {
          Tt = !0;
          var z = I(w);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function er(p) {
      {
        for (var w = Object.keys(p.props), T = 0; T < w.length; T++) {
          var O = w[T];
          if (O !== "children" && O !== "key") {
            Le(p), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", O), Le(null);
            break;
          }
        }
        p.ref !== null && (Le(p), b("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    function hn(p, w, T, O, z, F) {
      {
        var R = B(p);
        if (!R) {
          var A = "";
          (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (A += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var K = Zs(z);
          K ? A += K : A += un();
          var U;
          p === null ? U = "null" : jt(p) ? U = "array" : p !== void 0 && p.$$typeof === t ? (U = "<" + (I(p.type) || "Unknown") + " />", A = " Did you accidentally export a JSX literal instead of a component?") : U = typeof p, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", U, A);
        }
        var q = Ks(p, w, T, z, F);
        if (q == null)
          return q;
        if (R) {
          var ie = w.children;
          if (ie !== void 0)
            if (O)
              if (jt(ie)) {
                for (var Ae = 0; Ae < ie.length; Ae++)
                  mn(ie[Ae], p);
                Object.freeze && Object.freeze(ie);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              mn(ie, p);
        }
        return p === s ? er(q) : Qs(q), q;
      }
    }
    function tr(p, w, T) {
      return hn(p, w, T, !0);
    }
    function nr(p, w, T) {
      return hn(p, w, T, !1);
    }
    var sr = nr, rr = tr;
    Ve.Fragment = s, Ve.jsx = sr, Ve.jsxs = rr;
  }()), Ve;
}
process.env.NODE_ENV === "production" ? Bt.exports = fr() : Bt.exports = pr();
var a = Bt.exports;
const mr = {
  error(...e) {
    console.error("[acm:error]", ...e);
  },
  warn(...e) {
    console.warn("[acm:warning]", ...e);
  },
  info(...e) {
    console.info("[acm:info]", ...e);
  },
  debug(...e) {
    console.debug("[acm:debug]", ...e);
  }
}, je = mr;
function Ne(e) {
  globalThis.window !== void 0 && (window.dataLayer === void 0 && (je.warn("GTM container not loaded"), window.dataLayer = []), window.dataLayer.push(e));
}
function hr(e) {
  return typeof e == "object" && e !== null && "response" in e;
}
function xr(e) {
  return hr(e) && typeof e.response == "object" && // `response` should be a non-null object
  e.response !== null && "errors" in e.response && // `errors` array should exist
  Array.isArray(e.response.errors) && e.response.errors.length === 1 && // `errors` array can only contain one element
  e.response.errors[0].errorCode !== void 0;
}
function gr(e) {
  return xr(e) ? e.response.errors[0] : null;
}
async function zt(e, t) {
  const n = await fetch(e, {
    ...t,
    headers: {
      ...t == null ? void 0 : t.headers,
      "Content-Type": "application/json"
    }
  }), s = await n.json();
  if (!n.ok) {
    const i = gr(s);
    throw new Error(i ? `${i.errorTitle} [${i.errorCode}]` : "Unknown error");
  }
  const { response: r } = s;
  return r;
}
function vr(e) {
  var t;
  window.sendToCIChatbot && ((t = window.sendToCIChatbot) == null || t.call(window, {
    name: "logged-in",
    value: {
      firstName: e,
      lastName: ""
    }
  }));
}
function Ft() {
  var e;
  window.sendToCIChatbot && ((e = window.sendToCIChatbot) == null || e.call(window, { name: "logged-out" }));
}
function wr(e) {
  return e.trim().toLowerCase().replace(/[\W_]/g, "-").replace(/--+/g, "-");
}
function Kt(e, ...t) {
  return [e, ...t].filter(Boolean).map(wr).join("__");
}
function J(e, t) {
  let n = e;
  for (const [s, r] of Object.entries(t)) {
    const i = RegExp(`{${s}}`, "g");
    let l;
    for (; (l = i.exec(n)) !== null; )
      n = n.replace(l[0], `${r ?? ""}`);
  }
  return n;
}
function ue(e) {
  if (globalThis.document === void 0)
    return null;
  try {
    const n = decodeURIComponent(document.cookie).split(";").map((s) => s.trimStart()).find((s) => s.startsWith(`${e}=`));
    return (n == null ? void 0 : n.split("=")[1]) ?? null;
  } catch {
    return null;
  }
}
function Ye(e) {
  const t = e.match(/(astro\.com\.my|pink\.cat)/);
  return t ? `.${t[0]}` : void 0;
}
function bn(e, t) {
  globalThis.document !== void 0 && (document.cookie = [`${e}=`, "expires=Thu, 01 Jan 1970 00:00:01 GMT", "path=/", t && `domain=${t}`].filter(Boolean).join(";"));
}
function Ht(e, t) {
  e.forEach((n) => {
    typeof n == "string" ? bn(n, t) : bn(n.name, n.domain ?? t);
  });
}
function br(e) {
  return new Date(Date.now() + e * 60 * 1e3).toUTCString();
}
function ve(e, t, n, s = !1, r, i) {
  if (globalThis.document !== void 0) {
    const l = typeof n == "number" ? br(n) : n;
    document.cookie = [
      `${e}=${s ? btoa(String(t)) : t}`,
      `expires=${l}`,
      "path=/",
      r && `domain=${r}`,
      i && "secure"
    ].filter(Boolean).join(";");
  }
}
function yn(e, t) {
  var n;
  return ((n = t.config.find(({ key: s }) => s === e)) == null ? void 0 : n.value) ?? null;
}
function Vn(e, t, n) {
  const s = e.slice();
  return t.forEach((r, i) => {
    typeof s[i] > "u" ? s[i] = n.cloneUnlessOtherwiseSpecified(r, n) : s[i] = n.isMergeableObject(r) ? Hn(e[i], r, { arrayMerge: Vn }) : r;
  }), s;
}
function at(e, t = {}) {
  return Hn(e, t, { arrayMerge: Vn });
}
const yr = ["en", "bm"], qe = "en", Gn = "acm_locale", $e = "acm_ulm_access_token", Ge = "acm_ulm_refresh_token", Ue = "acm_ulm_uuid", Un = "AstroUlmEPUID", ot = "acm_ulm_payload", vc = "acm_ulm_handler_triggered", Wn = "acm_banner_dismissed", Yn = "acm_modal_banner_dismissed", jr = "ci-user-info", Sr = "login_url", Vt = "ulm_profile", Gt = "acm_locale";
function Zt(e) {
  return typeof e == "string" && yr.includes(e);
}
function qn(e) {
  return Zt(e) ? (window.dispatchEvent(new CustomEvent(Gt, { detail: e })), ve(Gn, e, 5e5, !1, Ye(window.location.hostname)), e) : null;
}
function wc(e, t) {
  const n = Object.entries(t).map(([s, r]) => `${s}-${r}`);
  return `https://resizer-acm.eco.astro.com.my${n.length ? `/tr:${n.join(",")}` : ""}/${e}`;
}
function Xn(e) {
  window.dispatchEvent(new CustomEvent(Vt, { detail: e }));
}
function Kn() {
  const e = ue($e), t = ue(Ge);
  return !!(e || t);
}
function Cr(e, t = "") {
  const { endpoint: n, queryParams: s = {} } = e, r = Object.entries(s).reduce((l, [c, o]) => {
    if (c === "state") {
      const d = ue(Ue) ?? t, u = encodeURIComponent(o).replace("DEVICE_ID_REPLACER", d).replace("LOCATION_REPLACER", "{location}");
      l.push(`state=${u}`);
    } else
      l.push(`${c}=${encodeURIComponent(o)}`);
    return l;
  }, []), i = n + (r.length ? `?${r.join("&")}` : "");
  return window.dispatchEvent(new CustomEvent(Sr, { detail: i })), i;
}
function Tr(e) {
  return typeof e == "object" && e !== null && "ulmProfileToken" in e;
}
function Er() {
  const e = Ye(window.location.hostname);
  Ht(
    [$e, Ge, ot, Ue, Un],
    e
  ), Xn();
}
const Nr = (e) => {
  const t = e.split(".")[1];
  if (!t)
    return null;
  const n = t.replace(/-/g, "+").replace(/_/g, "/"), s = JSON.parse(window.atob(n));
  return "exp" in s ? s.exp : null;
}, Pr = Nr;
async function _r({ client: e, endpoints: t, payload: n, refreshSessionExpiry: s = 3600, startSessionExpiry: r }, i = !0, l = "") {
  const c = Ye(window.location.hostname), o = ue($e), d = ue(Ge), u = ue(Ue), f = u ?? l;
  u || ve(Ue, l, s, !1, c, !0);
  let h = null;
  const m = [ot, Ue, Un];
  try {
    if (o && t.getUser) {
      m.push($e);
      const { ulm: v, ulmProfileToken: g = "" } = await zt(t.getUser, {
        method: "POST",
        headers: { Authorization: o }
      });
      ve(ot, n, s, !1, c, !0), h = { ...v, ulmProfileToken: g };
    } else if (d && t.refresh) {
      m.push(Ge);
      const {
        token: v = "",
        refreshToken: g = "",
        ulm: y,
        ulmProfileToken: x = ""
      } = await zt(t.refresh, {
        method: "POST",
        headers: {
          Authorization: d,
          Client: e,
          "Device-Id": f,
          "Ulm-Redirect-Uri": window.location.href
        }
      }), b = Pr(g), j = new Date(b * 1e3).toUTCString();
      ve(Ge, g, j, !1, c, !0), ve($e, v, r, !1, c, !0), ve(ot, n, s, !1, c, !0), h = { ...y, ulmProfileToken: x }, m.push($e);
    } else
      Ht(m, c), i && Ft();
  } catch (v) {
    je.error(v), Ht(m, c), i && Ft();
  }
  return Xn(h ?? void 0), h;
}
function P(...e) {
  return or(ar(e));
}
const kr = ({ children: e, className: t, size: n = "small", variant: s = "magenta1", ...r }) => /* @__PURE__ */ a.jsx(
  "span",
  {
    className: P(
      "inline-flex items-center rounded-full px-2 align-middle text-xs font-bold",
      n === "medium" && "px-3 py-[3px]",
      n === "large" && "px-4 py-[6px] text-sm",
      s === "magenta1" && "bg-gradient-magenta1 text-white",
      s === "magenta2" && "bg-gradient-magenta2 text-white",
      s === "gray" && "bg-neutral-200 text-neutral-600",
      s === "yellow" && "bg-yellow text-black",
      t
    ),
    ...r,
    children: e
  }
), ht = kr, Mr = ({ children: e, className: t, icon: n, ...s }) => /* @__PURE__ */ a.jsxs("div", { className: P("flex items-center rounded bg-gradient-lime p-4", t), ...s, children: [
  n && /* @__PURE__ */ a.jsx("span", { className: "mr-4", children: n }),
  e
] }), bc = Mr, Or = ({ as: e = "p", text: t, ...n }) => (
  // eslint-disable-next-line react/no-danger
  /* @__PURE__ */ a.jsx(e, { dangerouslySetInnerHTML: { __html: t }, ...n })
), ae = Or, Ir = ({ children: e, className: t, icon: n, status: s, ...r }) => /* @__PURE__ */ a.jsx(
  "div",
  {
    className: P(
      "py-4 lg:py-6",
      s === "error" && "bg-red-200 text-red",
      s === "warning" && "bg-yellow-200 text-orange",
      s === "success" && "bg-lime-200 text-green",
      t
    ),
    ...r,
    children: /* @__PURE__ */ a.jsxs("p", { className: "container flex items-center", children: [
      n && /* @__PURE__ */ a.jsx("span", { className: "mr-4", children: n }),
      e
    ] })
  }
), yc = Ir, Lr = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, ...e, children: [
  /* @__PURE__ */ a.jsx("path", { fill: "none", d: "M0 0h20v20H0z" }),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fill: "currentcolor",
      d: "M17.2 18a.8.8 0 01-.795-.706l-.009-.235a2.4 2.4 0 00-2.255-2.259H6a2.4 2.4 0 00-2.4 2.4.8.8 0 01-1.6 0 4 4 0 013.827-4H14a4 4 0 014 4 .8.8 0 01-.8.8zM10 11.6a4.8 4.8 0 114.8-4.8 4.805 4.805 0 01-4.8 4.8zm0-8a3.2 3.2 0 103.2 3.2A3.2 3.2 0 0010 3.6z"
    }
  )
] }), jn = Lr, Ar = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, ...e, children: [
  /* @__PURE__ */ a.jsx("path", { fill: "none", d: "M0 0h20v20H0z" }),
  /* @__PURE__ */ a.jsx("rect", { fill: "currentcolor", width: "16", height: "2", rx: "1", transform: "translate(2 4)" }),
  /* @__PURE__ */ a.jsx("rect", { fill: "currentcolor", width: "12", height: "2", rx: "1", transform: "translate(2 9)" }),
  /* @__PURE__ */ a.jsx("rect", { fill: "currentcolor", width: "16", height: "2", rx: "1", transform: "translate(2 14)" })
] }), $r = Ar, Rr = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, fill: "currentcolor", ...e, children: [
  /* @__PURE__ */ a.jsx(
    "path",
    {
      d: "M4.67 15.36h-.42A2.25 2.25 0 0 1 2 13.14V4.22A2.23 2.23 0 0 1 4.25 2h11.51A2.23 2.23 0 0 1 18 4.22v8.92a2.23 2.23 0 0 1-2.24 2.22h-6a2.25 2.25 0 0 0-1.72.8L6.49 18",
      fill: "none",
      stroke: "currentcolor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ a.jsx("path", { d: "m10.046 7.29-.72 1.789h1.45l-.73-1.79Zm0-3h.33l.13.07h.06l.09.069.08.09v.05l.07.14 2 4.84 1 2.42a.83.83 0 0 1-.11.82.85.85 0 0 1-1.18.14.858.858 0 0 1-.13-.14l-.07-.11-.05-.1-.78-1.9h-2.77l-.77 1.9a.83.83 0 0 1-.44.46h-.209a.84.84 0 0 1-.913-.583.78.78 0 0 1-.026-.307v-.24l1-2.39 2-4.81.08-.15.1-.12.1-.08.12-.07h.29Z" })
] }), Dr = Rr, Br = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, ...e, children: [
  /* @__PURE__ */ a.jsx("path", { fill: "none", d: "M0 0h20v20H0z" }),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M18.1 19a.9.9 0 01-.552-.189l-.085-.075-3.308-3.307A8.012 8.012 0 019.1 17.2a8.1 8.1 0 118.1-8.1 8.011 8.011 0 01-1.771 5.055l3.307 3.308A.9.9 0 0118.1 19zm-9-16.2a6.3 6.3 0 106.3 6.3 6.307 6.307 0 00-6.3-6.3z"
    }
  )
] }), Zn = Br, zr = ({ className: e, direction: t, ...n }) => /* @__PURE__ */ a.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    className: P(
      {
        "rotate-90": t === "right",
        "-rotate-90": t === "left",
        "rotate-180": t === "down"
      },
      e
    ),
    ...n,
    children: /* @__PURE__ */ a.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7071 11.7071C14.3166 12.0976 13.6834 12.0976 13.2929 11.7071L8 6.41421L2.70711 11.7071C2.31658 12.0976 1.68342 12.0976 1.29289 11.7071C0.902369 11.3166 0.902369 10.6834 1.29289 10.2929L7.29289 4.29289C7.68342 3.90237 8.31658 3.90237 8.70711 4.29289L14.7071 10.2929C15.0976 10.6834 15.0976 11.3166 14.7071 11.7071Z",
        fill: "currentcolor"
      }
    )
  }
), De = zr, Fr = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: 16, height: 16, fill: "none", ...e, children: [
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.707 2.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414-1.414l10-10a1 1 0 0 1 1.414 0Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.293 2.293a1 1 0 0 1 1.414 0l10 10a1 1 0 0 1-1.414 1.414l-10-10a1 1 0 0 1 0-1.414Z",
      fill: "currentcolor"
    }
  )
] }), Hr = Fr, Vr = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: 16, height: 16, fill: "none", ...e, children: [
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 8C1 7.44772 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H2C1.44772 9 1 8.55228 1 8Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 1C8.55228 1 9 1.44772 9 2V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V2C7 1.44772 7.44772 1 8 1Z",
      fill: "currentcolor"
    }
  )
] }), Gr = Vr, Ur = (e) => /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: 16, height: 16, fill: "none", ...e, children: /* @__PURE__ */ a.jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.647 3.238a1 1 0 0 1 .115 1.41l-7.075 8.336a1 1 0 0 1-1.516.01L2.247 9.648A1 1 0 1 1 3.753 8.33l2.16 2.473 6.325-7.451a1 1 0 0 1 1.41-.115Z",
    fill: "currentcolor"
  }
) }), xt = Ur, Wr = (e) => /* @__PURE__ */ a.jsxs("svg", { viewBox: "0 0 24 24", width: "24", height: "24", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ a.jsx(
    "path",
    {
      d: "M19.8098 10.75H15.4398C14.2398 10.75 13.2598 9.77001 13.2598 8.57001V4.19001C13.2598 2.99001 14.2398 2.01001 15.4398 2.01001H19.8098C21.0198 2.01001 21.9898 2.99001 21.9898 4.19001V8.56001C21.9898 9.76001 21.0098 10.74 19.8098 10.74V10.75ZM15.4398 3.88001C15.2698 3.88001 15.1298 4.02001 15.1298 4.19001V8.56001C15.1298 8.73001 15.2698 8.87001 15.4398 8.87001H19.8098C19.9798 8.87001 20.1298 8.73001 20.1298 8.56001V4.19001C20.1298 4.02001 19.9898 3.88001 19.8098 3.88001H15.4398Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      d: "M8.55977 10.75H4.18977C2.97977 10.75 2.00977 9.77001 2.00977 8.57001V4.19001C2.00977 2.99001 2.98977 2.01001 4.18977 2.01001H8.55977C9.76977 2.01001 10.7398 2.99001 10.7398 4.19001V8.56001C10.7398 9.76001 9.75977 10.74 8.55977 10.74V10.75ZM4.18977 3.88001C4.01977 3.88001 3.86977 4.02001 3.86977 4.19001V8.56001C3.86977 8.73001 4.00977 8.87001 4.18977 8.87001H8.55977C8.72977 8.87001 8.87977 8.73001 8.87977 8.56001V4.19001C8.87977 4.02001 8.73977 3.88001 8.55977 3.88001H4.18977Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      d: "M8.55977 22H4.18977C2.97977 22 2.00977 21.02 2.00977 19.82V15.45C2.00977 14.25 2.98977 13.27 4.18977 13.27H8.55977C9.76977 13.27 10.7398 14.25 10.7398 15.45V19.82C10.7398 21.02 9.75977 22 8.55977 22ZM4.18977 15.13C4.01977 15.13 3.86977 15.27 3.86977 15.44V19.81C3.86977 19.98 4.00977 20.12 4.18977 20.12H8.55977C8.72977 20.12 8.87977 19.98 8.87977 19.81V15.44C8.87977 15.27 8.73977 15.13 8.55977 15.13H4.18977Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      d: "M18.54 22H15.43C14.23 22 13.25 21.02 13.25 19.82V15.45C13.25 14.25 14.23 13.27 15.43 13.27H19.8C21.01 13.27 21.98 14.25 21.98 15.45V18.04C21.98 18.56 21.56 18.98 21.05 18.98C20.54 18.98 20.12 18.56 20.12 18.04V15.45C20.12 15.28 19.98 15.14 19.8 15.14H15.43C15.26 15.14 15.12 15.28 15.12 15.45V19.82C15.12 19.99 15.26 20.13 15.43 20.13H18.54C19.06 20.13 19.47 20.55 19.47 21.07C19.47 21.59 19.05 22.01 18.54 22.01V22Z",
      fill: "currentcolor"
    }
  )
] }), Yr = Wr, qr = ye(
  ({ children: e, className: t, disabled: n, endIcon: s, size: r = "medium", startIcon: i, variant: l = "primary", ...c }, o) => /* @__PURE__ */ a.jsxs(
    "button",
    {
      ref: o,
      type: "button",
      disabled: n,
      className: P(
        "flex h-12 cursor-pointer items-center space-x-2 rounded-sm px-4 text-base font-bold focus-visible:outline focus-visible:outline-1 focus-visible:outline-blue disabled:cursor-default disabled:select-none",
        r === "small" && "h-8 space-x-1 text-sm",
        r === "large" && "h-14 text-xl font-extrabold",
        l === "primary" && "bg-gradient-magenta1 text-white hover:bg-[linear-gradient(135deg,_#cf0071,_#d0283a)] disabled:bg-neutral-100 disabled:bg-none disabled:text-neutral-400 disabled:outline disabled:outline-1 disabled:-outline-offset-1 disabled:outline-neutral-300",
        l === "secondary" && "bg-white text-magenta outline outline-1 -outline-offset-1 outline-neutral-300 hover:bg-neutral-200 disabled:text-neutral-400 disabled:hover:bg-white",
        l === "accent" && "rounded-full bg-blue text-white hover:bg-[#14589e] focus-visible:outline-0 disabled:bg-neutral-100 disabled:text-neutral-400 disabled:outline disabled:outline-1 disabled:-outline-offset-1 disabled:outline-neutral-300",
        l === "text" && "bg-inherit h-min p-0 font-normal text-magenta",
        t
      ),
      ...c,
      children: [
        i && /* @__PURE__ */ a.jsx("span", { className: P("h-6 w-6 flex-shrink-0", r === "small" && "h-5 w-5"), children: i }),
        i || s ? /* @__PURE__ */ a.jsx("span", { children: e }) : e,
        s && /* @__PURE__ */ a.jsx("span", { className: P("h-6 w-6 flex-shrink-0", r === "small" && "h-5 w-5"), children: s })
      ]
    }
  )
), Be = qr, Xr = ye(({ className: e, ...t }, n) => /* @__PURE__ */ a.jsx("button", { ref: n, type: "button", "aria-label": "Close", className: P("focus-visible:outline-none", e), ...t, children: /* @__PURE__ */ a.jsx(Hr, { width: 20, height: 20 }) })), ke = Xr, Kr = ye(({ disabled: e, error: t, id: n, label: s, ...r }, i) => /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center space-x-4", children: [
  /* @__PURE__ */ a.jsxs("span", { className: "relative inline-flex h-6 w-6 p-0.5 focus-visible:outline-none", children: [
    /* @__PURE__ */ a.jsx(
      "input",
      {
        ref: i,
        type: "checkbox",
        id: n,
        "aria-describedby": `${n}-label`,
        className: "peer absolute inset-0 z-10 h-full w-full opacity-0",
        disabled: e,
        ...r
      }
    ),
    /* @__PURE__ */ a.jsx(
      "span",
      {
        "aria-hidden": "true",
        className: P(
          "h-5 w-5 rounded-xs border-2 border-transparent outline outline-1 -outline-offset-1 outline-neutral",
          e ? "peer-disabled:bg-neutral-200 peer-disabled:outline-neutral" : [
            "peer-focus-visible:border-blue-100 peer-focus-visible:outline-blue peer-focus-visible:peer-checked:border-transparent",
            t && "border-red-100 outline-red"
          ]
        )
      }
    ),
    /* @__PURE__ */ a.jsx(
      xt,
      {
        "aria-hidden": "true",
        className: "absolute left-1 top-1 hidden peer-checked:block peer-disabled:text-[#a1a1a3]"
      }
    )
  ] }),
  /* @__PURE__ */ a.jsx("label", { id: `${n}-label`, htmlFor: n, className: P(e && "text-neutral-500"), children: s })
] })), jc = Kr, Zr = ye(
  ({ className: e, icon: t, size: n = "medium", ...s }, r) => /* @__PURE__ */ a.jsx(
    Be,
    {
      className: P(
        "items-center justify-center [&>*]:h-6 [&>*]:w-6",
        n === "small" && "w-8 p-1.5 [&>*]:h-5 [&>*]:w-5",
        n === "medium" && "w-12 p-3",
        n === "large" && "w-14 p-4",
        e
      ),
      size: n,
      ...s,
      ref: r,
      children: t
    }
  )
), ct = Zr, Jr = ({ disabledAll: e, name: t, onChange: n, options: s }) => {
  var r, i;
  return /* @__PURE__ */ a.jsx(
    Nt,
    {
      className: "flex flex-col space-y-4",
      defaultValue: ((r = s.find((l) => l.defaultValue)) == null ? void 0 : r.value) ?? ((i = s[0]) == null ? void 0 : i.value),
      disabled: e,
      onChange: n,
      children: s.map(({ disabled: l, label: c, value: o }) => /* @__PURE__ */ a.jsx(
        Nt.Option,
        {
          value: o,
          disabled: l,
          className: "inline-flex items-center space-x-4 focus-visible:outline-none",
          children: ({ active: d, checked: u, disabled: f }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsxs("span", { className: P("relative inline-flex h-6 w-6 p-0.5"), children: [
              /* @__PURE__ */ a.jsx(
                "input",
                {
                  type: "radio",
                  className: "absolute inset-0 h-full w-full opacity-0",
                  name: t,
                  value: o,
                  disabled: f
                }
              ),
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  "aria-hidden": "true",
                  className: P(
                    "h-5 w-5 rounded-full border-2 border-transparent bg-transparent outline outline-1 -outline-offset-1 outline-neutral",
                    u && [
                      "border-0 bg-blue outline-none outline-transparent",
                      d && "outline-offset-0 outline-blue-400"
                    ],
                    f && "bg-neutral-200 outline-neutral"
                  )
                }
              ),
              /* @__PURE__ */ a.jsx(
                xt,
                {
                  "aria-hidden": "true",
                  className: P(
                    "absolute left-1 top-1 hidden text-white",
                    u && "block opacity-100",
                    f && "opacity-30"
                  )
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx(Nt.Label, { className: P(f && "text-neutral-500"), children: c })
          ] })
        },
        o
      ))
    }
  );
}, Sc = Jr;
function Se({
  endpoint: e,
  fetchCondition: t,
  formatError: n,
  formatResponse: s,
  ...r
}) {
  return ir(
    t === void 0 || t() ? e : null,
    (i) => zt(i, r).then(s)
  );
}
function Jt(e, t, n) {
  const s = [t].flat();
  return Se({
    endpoint: e,
    formatResponse: (r) => {
      if (typeof t == "string") {
        const i = yn(t, r);
        if (i === null)
          throw je.error(`Missing '${t}' DF config`), new Error(`Missing '${t}' DF config`);
        return i;
      }
      return s.map((i) => yn(i, r));
    },
    ...n
  });
}
function ne(e = !1) {
  const [t, n] = D(e), s = Bn(
    () => ({
      on: () => n(!0),
      off: () => n(!1),
      toggle: () => n((r) => !r)
    }),
    []
  );
  return [t, s];
}
function Qr(e) {
  const t = Q(null);
  return t.current === null && (t.current = typeof e == "function" ? e() : e), t.current;
}
function Jn(e, t) {
  return `(${t === "up" ? "min" : "max"}-width: ${typeof e == "number" ? e : {
    xs: 360,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
  }[e]}px)`;
}
function ei(e, t) {
  return typeof window === void 0 ? !1 : window.matchMedia(Jn(e, t)).matches;
}
function le(e, t = "up") {
  const [n, s] = D(!1);
  return W(() => {
    const r = window.matchMedia(Jn(e, t)), i = () => s(ei(e, t));
    return i(), r.addEventListener("change", i), () => {
      r.removeEventListener("change", i);
    };
  }, [e, t]), n;
}
function Qn(e) {
  return `(orientation: ${e})`;
}
function Sn(e) {
  return typeof window === void 0 ? !1 : window.matchMedia(Qn(e)).matches;
}
function Cc(e) {
  const [t, n] = D(Sn(e));
  return W(() => {
    const s = window.matchMedia(Qn(e)), r = () => n(Sn(e));
    return r(), s.addEventListener("change", r), () => {
      s.removeEventListener("change", r);
    };
  }, [e]), t;
}
function es(e) {
  const [t, n] = D(e);
  return W(() => {
    if (!e) {
      n(e);
      return;
    }
    try {
      const s = new URL(e), r = new URLSearchParams(window.location.search), i = {};
      r.forEach((l, c) => {
        (c.startsWith("utm_") || c.startsWith("itm_")) && (i[c] = l);
      }), Object.entries(i).forEach(([l, c]) => {
        s.searchParams.append(l, c);
      }), n(s.toString());
    } catch {
      n(e);
    }
  }, [e]), t;
}
const ti = ({ className: e, defaultChecked: t, disabled: n, onChange: s, ...r }) => {
  const [i, l] = ne(t), c = (o) => {
    l.toggle(), s == null || s(o);
  };
  return /* @__PURE__ */ a.jsx(
    lr,
    {
      checked: i,
      onChange: c,
      className: P(
        "relative inline-flex h-6 w-10 shrink-0 cursor-pointer rounded-full bg-neutral-500 transition-colors duration-200 ease-in-out before:absolute before:inset-0 before:overflow-hidden before:rounded-full before:bg-blue before:opacity-0 before:transition-colors before:content-[''] hover:bg-neutral-300 hover:before:bg-blue-300 focus:outline-none",
        i && "before:opacity-100",
        n && "pointer-events-none cursor-default select-none bg-neutral-200 before:bg-blue-100",
        e
      ),
      ...r,
      children: /* @__PURE__ */ a.jsx(
        "span",
        {
          "aria-hidden": "true",
          className: P(
            "pointer-events-none inline-block h-[22px] w-[22px] translate-y-px rounded-full bg-white shadow-[0_2px_1px_0_rgba(0,0,0,0.06),0_2px_6px_0_rgba(0,0,0,0.15)] ring-0 transition duration-200 ease-in-out",
            i ? "translate-x-[17px]" : "translate-x-px"
          )
        }
      )
    }
  );
}, Tc = ti, ni = ye(
  ({ children: e, newTab: t = !1, forwardUtm: n, href: s, ...r }, i) => {
    const l = es(s), c = t ? {
      target: "_blank",
      rel: typeof t == "boolean" ? "noreferrer" : `${t.noReferrer ? "noreferrer" : ""} ${t.noFollow ? "nofollow" : ""}`.trim()
    } : {};
    return /* @__PURE__ */ a.jsx("a", { ref: i, ...c, ...r, href: n ? l : s, children: e });
  }
), X = ni, si = ye(
  ({
    children: e,
    className: t,
    onClose: n = () => null,
    open: s,
    overlayTransitionProps: r,
    panelTransitionProps: i,
    panelClassName: l,
    wrapperClassName: c,
    ...o
  }, d) => /* @__PURE__ */ a.jsx(oe, { appear: !0, show: s, as: Te, children: /* @__PURE__ */ a.jsxs(gn, { as: "div", ref: d, className: P("acm acm-modal relative z-20", t), onClose: n, ...o, children: [
    /* @__PURE__ */ a.jsx(
      oe.Child,
      {
        as: Te,
        enter: "ease-out duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-150",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        ...r,
        children: /* @__PURE__ */ a.jsx("div", { className: "fixed inset-0 bg-black-true bg-opacity-75" })
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ a.jsx("div", { className: P("grid h-full w-full items-center justify-center", c), children: /* @__PURE__ */ a.jsx(
      oe.Child,
      {
        as: Te,
        enter: "ease-out duration-200",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-150",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        ...i,
        children: /* @__PURE__ */ a.jsx(gn.Panel, { className: P("relative w-full max-w-4xl rounded bg-white", l), children: e })
      }
    ) }) })
  ] }) })
), Xe = si, ri = ({ as: e = "div", children: t, show: n = !1 }) => {
  const s = Q(null), r = (i) => {
    s.current && (s.current.style.height = n ? `${(i == null ? void 0 : i.offsetHeight) ?? 0}px` : "0px");
  };
  return /* @__PURE__ */ a.jsx(
    oe,
    {
      show: n,
      as: e,
      className: "collapse-wrapper overflow-hidden transition-[height]",
      enter: "duration-150 ease-out",
      enterFrom: "h-0",
      enterTo: "h-full",
      leave: "duration-100 ease-in",
      leaveFrom: "h-full",
      leaveTo: "h-0",
      ref: s,
      children: /* @__PURE__ */ a.jsx("div", { className: "collapse-inner-wrapper", ref: r, children: t })
    }
  );
}, Qt = ri;
function me(...e) {
  return Kt("acm-footer", ...e);
}
const ii = ({
  app: { appStoreLinks: e, bottomDescriptionHtml: t, longTitle: n, qrCode: s, topDescriptionHtml: r },
  ...i
}) => /* @__PURE__ */ a.jsxs(
  Xe,
  {
    ...i,
    id: me("apps", "modal"),
    panelClassName: "grid max-w-screen-xs grid-cols-1 items-center gap-4 px-4 pb-8 pt-4 text-center",
    children: [
      /* @__PURE__ */ a.jsx(ke, { className: "justify-self-end focus-visible:outline-none", onClick: i.onClose }),
      /* @__PURE__ */ a.jsx("h2", { className: "text-2xl", children: n }),
      /* @__PURE__ */ a.jsx(ae, { text: r }),
      /* @__PURE__ */ a.jsx("img", { className: "justify-self-center", src: s.src, alt: s.alt, width: 156, height: 156 }),
      /* @__PURE__ */ a.jsx(ae, { text: t }),
      /* @__PURE__ */ a.jsx("ul", { className: "flex items-center justify-center space-x-1", children: e.map(({ name: l, newTab: c, src: o, url: d }) => /* @__PURE__ */ a.jsx("li", { children: /* @__PURE__ */ a.jsx(X, { href: d, newTab: c, children: /* @__PURE__ */ a.jsx("img", { src: o, alt: l, height: 30 }) }) }, l)) })
    ]
  }
), ai = ii, oi = ({ heading: e, apps: t }) => {
  const [n, s] = ne(!0), [r, i] = D(), l = le("lg"), c = Xt(
    (o) => (d) => {
      l && (d.preventDefault(), i(o), s.on());
    },
    [l]
  );
  return /* @__PURE__ */ a.jsxs("div", { id: me("apps"), children: [
    /* @__PURE__ */ a.jsx("h4", { className: "mb-4 font-extrabold", children: e }),
    /* @__PURE__ */ a.jsx("ul", { className: "space-y-4", children: t.map((o) => /* @__PURE__ */ a.jsx("li", { className: "flex", children: /* @__PURE__ */ a.jsxs(
      X,
      {
        className: "inline-flex cursor-pointer items-center",
        href: o.mobileLink,
        onClick: c(o),
        newTab: !1,
        children: [
          /* @__PURE__ */ a.jsx(
            "img",
            {
              className: "mr-2 h-6 w-6 shrink-0",
              loading: "lazy",
              src: o.icon,
              alt: o.name,
              width: 24,
              height: 24
            }
          ),
          /* @__PURE__ */ a.jsx("span", { children: o.shortTitle })
        ]
      }
    ) }, o.name)) }),
    r && /* @__PURE__ */ a.jsx(ai, { app: r, open: n, onClose: s.off })
  ] });
}, li = oi, ci = ({ className: e, heading: t }) => /* @__PURE__ */ a.jsx(
  de.Button,
  {
    as: "h4",
    className: P(
      "mb-2 flex w-full cursor-pointer items-center justify-between leading-6 lg:mb-4 lg:cursor-auto",
      e
    ),
    children: ({ open: n }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx("span", { className: "font-extrabold", children: t }),
      /* @__PURE__ */ a.jsx(
        De,
        {
          direction: n ? "down" : "up",
          className: "transition-transform duration-150 ease-in-out lg:hidden"
        }
      )
    ] })
  }
), ts = ci, di = ({ name: e, newTab: t, src: n, url: s }) => {
  const r = le("lg");
  return /* @__PURE__ */ a.jsx(de, { as: "section", id: me("complaint"), children: ({ open: i }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ts, { heading: e }),
    /* @__PURE__ */ a.jsx(Qt, { show: i || r, children: /* @__PURE__ */ a.jsx(de.Panel, { static: !0, children: /* @__PURE__ */ a.jsx(X, { href: s, newTab: t, children: /* @__PURE__ */ a.jsx("img", { className: "block pb-2 lg:pb-0", src: n, alt: e, loading: "lazy", width: 160, height: 76 }) }) }) })
  ] }) });
}, ui = di, fi = ({ heading: e, links: t }) => {
  const n = le("lg");
  return /* @__PURE__ */ a.jsx(de, { as: "nav", className: "mt-2 first-of-type:mt-0 lg:mt-0", children: ({ open: s }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ts, { heading: e, className: "px-4 lg:px-0" }),
    /* @__PURE__ */ a.jsx(Qt, { show: s || n, children: /* @__PURE__ */ a.jsx(
      de.Panel,
      {
        as: "ul",
        static: !0,
        className: "space-y-4 bg-black-true p-4 lg:space-y-1 lg:bg-transparent lg:p-0",
        children: t.map(({ name: r, newTab: i, url: l }) => /* @__PURE__ */ a.jsx("li", { className: "leading-6", children: /* @__PURE__ */ a.jsx(X, { href: l, newTab: i, children: r }) }, r))
      }
    ) })
  ] }) }, e);
}, pi = fi, mi = ({ config: e }) => /* @__PURE__ */ a.jsx("footer", { id: me(), className: "sticky top-[100vh] mt-32 bg-[#333] text-sm text-white", children: /* @__PURE__ */ a.jsxs("div", { className: "py-8 lg:container", children: [
  /* @__PURE__ */ a.jsxs("div", { id: me("top-section"), className: "grid lg:grid-cols-6 lg:gap-4", children: [
    e.groups.map((t) => /* @__PURE__ */ a.jsx(pi, { ...t }, t.heading)),
    /* @__PURE__ */ a.jsxs("section", { className: "mt-2 flex flex-col justify-between px-4 lg:col-span-3 lg:mt-0 lg:flex-row lg:px-0", children: [
      /* @__PURE__ */ a.jsx(ui, { ...e.complaint }),
      /* @__PURE__ */ a.jsxs("div", { className: "grid gap-8", children: [
        /* @__PURE__ */ a.jsxs("address", { id: me("contact-us"), className: "mt-3 not-italic lg:mt-0", children: [
          /* @__PURE__ */ a.jsx(ae, { className: "leading-6", text: e.contacts.headingHtml }),
          /* @__PURE__ */ a.jsx("div", { className: "mt-4 flex h-4 items-center space-x-6", children: e.contacts.socials.map(({ name: t, newTab: n, src: s, url: r, width: i }) => /* @__PURE__ */ a.jsx(X, { href: r, newTab: n, children: /* @__PURE__ */ a.jsx("img", { src: s, alt: t, height: 16, width: i }) }, r)) })
        ] }),
        /* @__PURE__ */ a.jsx(li, { ...e.mobileApps })
      ] })
    ] })
  ] }),
  /* @__PURE__ */ a.jsx("hr", { className: "mx-4 my-8 border-neutral lg:mx-auto" }),
  /* @__PURE__ */ a.jsxs(
    "div",
    {
      id: me("bottom-section"),
      className: "flex flex-col space-y-6 px-4 lg:flex-row lg:items-baseline lg:justify-between lg:space-y-0 lg:px-0",
      children: [
        /* @__PURE__ */ a.jsx("nav", { id: me("document-links"), className: "divide-x divide-white", children: e.documentLinks.map(({ name: t, newTab: n, url: s }) => /* @__PURE__ */ a.jsx(
          X,
          {
            href: s,
            newTab: n,
            className: "px-2 no-underline first-of-type:pl-0 last-of-type:pr-0",
            children: t
          },
          s
        )) }),
        /* @__PURE__ */ a.jsx(
          ae,
          {
            id: me("copyright"),
            text: J(e.copyrightHtml, { year: (/* @__PURE__ */ new Date()).getFullYear() })
          }
        )
      ]
    }
  )
] }) }), Ec = mi;
function G(...e) {
  return Kt("acm-header", ...e);
}
function hi(e) {
  Ne({ event: "navEvent", content_type: "ACM Header", ...e });
}
function be(e, t, n = "main") {
  return () => hi({
    content_list_type: n === "mobile" ? "Mobile Navigation" : n === "nested" ? "Consumer Navigation" : "Main Navigation",
    content_title: e,
    content_id: t || "NA"
  });
}
function xi(e, t) {
  const { data: n } = Se({
    endpoint: e,
    formatResponse: (s) => {
      const r = Date.now(), i = s.find(
        (o) => r >= new Date(o.startTime).getTime() && r < new Date(o.endTime).getTime()
      );
      return !i || !!!i.visibility.reduce((o, d) => {
        const u = t[d];
        return u && o.push(new RegExp(u, "i")), o;
      }, []).find((o) => o.test(window.location.href)) ? null : {
        titleHtml: i.title,
        descriptionHtml: i.description,
        logoImageUrl: i.logoImageURL,
        backgroundImageUrl: i.backgroundImageURL,
        showCountdownTimer: i.showCountdownTimer,
        endTime: i.endTime
      };
    },
    fetchCondition: () => !(ue(Wn) === "1")
  });
  return n ?? null;
}
function ge(e, t, n = !1) {
  const s = (/* @__PURE__ */ new Date()).getTime(), r = new Date(e).getTime() - s;
  let i;
  switch (t) {
    case "day":
      i = r / 864e5;
      break;
    case "hour":
      i = r % 864e5 / 36e5;
      break;
    case "minute":
      i = r % 36e5 / 6e4;
      break;
    case "second":
      i = r % 6e4 / 1e3;
      break;
    default:
      i = 0;
      break;
  }
  return i < 1 ? n ? null : "00" : Math.floor(i).toString().padStart(2, "0");
}
function ns(e) {
  const [t, n] = D(ge(e, "day", !0)), [s, r] = D(ge(e, "hour")), [i, l] = D(ge(e, "minute")), [c, o] = D(ge(e, "second"));
  return W(() => {
    const d = window.setInterval(() => {
      const u = ge(e, "day", !0), f = ge(e, "hour"), h = ge(e, "minute"), m = ge(e, "second");
      n(u), r(f), l(h), o(m);
    }, 1e3);
    return () => window.clearInterval(d);
  }, []), { day: t, hour: s, minute: i, second: c };
}
const gi = ({ unit: e, value: t }) => /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center", children: [
  /* @__PURE__ */ a.jsx("span", { className: "text-[2rem] font-extrabold leading-[2.125rem]", children: t }),
  /* @__PURE__ */ a.jsx("span", { className: "text-xs font-extrabold leading-[0.875rem]", children: e })
] }), st = gi, vi = ({ endTime: e, units: t }) => {
  const { day: n, hour: s, minute: r, second: i } = ns(e);
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      id: G("banner", "countdown"),
      className: "mr-8 hidden items-center space-x-4 py-4 lg:ml-auto lg:flex",
      children: [
        n && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx(st, { value: n, unit: t.day }),
          /* @__PURE__ */ a.jsx("span", { children: t.separator })
        ] }),
        /* @__PURE__ */ a.jsx(st, { value: s, unit: t.hour }),
        /* @__PURE__ */ a.jsx("span", { children: t.separator }),
        /* @__PURE__ */ a.jsx(st, { value: r, unit: t.minute }),
        /* @__PURE__ */ a.jsx("span", { children: t.separator }),
        /* @__PURE__ */ a.jsx(st, { value: i, unit: t.second })
      ]
    }
  );
}, wi = vi, bi = ({ endTime: e, units: t, ...n }) => {
  const { day: s, hour: r, minute: i, second: l } = ns(e);
  return /* @__PURE__ */ a.jsxs("p", { id: G("banner", "inline-countdown"), ...n, children: [
    s && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      s,
      t.day,
      t.separator
    ] }),
    r,
    t.hour,
    t.separator,
    i,
    t.minute,
    t.separator,
    l,
    t.second
  ] });
}, Cn = bi, yi = ({
  dismissDuration: e,
  bcpV3Endpoint: t,
  portalRegexMap: n,
  showMiniBanner: s,
  timerUnits: r
}) => {
  const i = xi(t, n), [l, c] = ne();
  if (W(() => {
    i && c.on();
  }, [i, c]), !i)
    return null;
  const { backgroundImageUrl: o, descriptionHtml: d, endTime: u, logoImageUrl: f, titleHtml: h, showCountdownTimer: m } = i, v = () => {
    ve(Wn, "1", e, !1, Ye(window.location.href)), c.off();
  }, g = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, y = (x) => {
    x.target instanceof HTMLAnchorElement && x.stopPropagation();
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    l && // TODO: animate height
    /* @__PURE__ */ a.jsx(
      "aside",
      {
        id: G("banner"),
        className: "relative bg-cover text-white",
        style: { backgroundImage: `url('${o}')` },
        children: /* @__PURE__ */ a.jsxs("div", { className: "container flex items-start py-2 lg:items-center lg:py-0", children: [
          /* @__PURE__ */ a.jsx("img", { className: "mr-4 shrink-0 self-center lg:mr-6", src: f, alt: "", loading: "lazy" }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              id: G("banner", "message"),
              className: "mr-4 lg:mr-8 lg:py-4 [&_a]:font-bold [&_a]:text-magenta [&_a]:hover:underline [&_a]:hover:decoration-current",
              children: [
                h && /* @__PURE__ */ a.jsx(
                  ae,
                  {
                    className: "font-extrabold lg:inline lg:after:inline lg:after:content-['_']",
                    text: h
                  }
                ),
                /* @__PURE__ */ a.jsx(ae, { className: "lg:inline", text: d }),
                m && /* @__PURE__ */ a.jsx(Cn, { className: "mt-1 lg:hidden", endTime: u, units: r.shortForm })
              ]
            }
          ),
          m && /* @__PURE__ */ a.jsx(wi, { endTime: u, units: r.fullForm }),
          /* @__PURE__ */ a.jsx(
            ke,
            {
              className: P("ml-auto pt-2 lg:pt-0", m && "lg:ml-0"),
              onClick: v
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a.jsx(
      oe,
      {
        as: "aside",
        show: l && s,
        id: G("mini-banner"),
        className: "fixed inset-x-0 top-0 z-20 cursor-pointer bg-cover text-base text-white transition",
        style: { backgroundImage: `url('${o}')` },
        enter: "ease-out duration-150",
        enterFrom: "-translate-y-full",
        enterTo: "translate-y-0",
        leave: "ease-in duration-100",
        leaveFrom: "translate-y-0",
        leaveTo: "-translate-y-full",
        onClick: g,
        children: /* @__PURE__ */ a.jsxs("div", { className: "container flex justify-between py-1", children: [
          /* @__PURE__ */ a.jsxs(
            "p",
            {
              id: G("mini-banner", "message"),
              role: "presentation",
              className: "overflow-hidden text-ellipsis whitespace-nowrap [&_a]:font-bold [&_a]:text-magenta [&_a]:hover:underline [&_a]:hover:decoration-current",
              onClick: y,
              children: [
                h && /* @__PURE__ */ a.jsx(
                  ae,
                  {
                    as: "strong",
                    className: "font-extrabold lg:after:inline lg:after:content-['_']",
                    text: h
                  }
                ),
                /* @__PURE__ */ a.jsx(ae, { as: "span", className: "hidden lg:inline", text: d })
              ]
            }
          ),
          m && /* @__PURE__ */ a.jsx(Cn, { className: "ml-4 shrink-0", endTime: u, units: r.shortForm })
        ] })
      }
    )
  ] });
}, ji = yi, Si = mt({
  authenticated: !1,
  isUxfPortal: !1,
  loginUrl: "",
  logoutUrl: "",
  profileUrl: "",
  isChatbotConfiguredToBeShown: !1
}), ss = Si;
function rs() {
  return zn(ss);
}
function Ci(e) {
  const t = ["chat-button-frame", "chat-prompt-frame"].reduce((i, l) => {
    const c = document.getElementById(l);
    return c instanceof HTMLElement ? [...i, c] : i;
  }, []), n = document.querySelectorAll("[data-livechat-sticky]"), s = Array.from(n).reduce((i, l) => l instanceof HTMLElement && l.offsetHeight > i ? l.offsetHeight : i, 0), r = `translateY(-${s}px)`;
  t.forEach(
    (i) => s ? i.style.setProperty("transform", r) : i.style.removeProperty("transform")
  ), e == null || e();
}
function Ti(e, t) {
  const { hiddenPortals: n } = e;
  W(() => {
    const s = () => Ci(t);
    s();
    const r = new MutationObserver(s);
    return r.observe(document, { subtree: !0, childList: !0 }), () => {
      r.disconnect();
    };
  }, [t]), W(() => {
    if (n.find((r) => r && window.location.href.match(new RegExp(r, "i")))) {
      const r = document.createElement("style");
      r.innerHTML = "#chat-button-frame,#chat-prompt-frame,#chat-window-frame{display:none}", r.dataset.chatbotOverride = "", document.head.appendChild(r);
    } else
      document.querySelectorAll("[data-chatbot-override]").forEach((r) => {
        r.remove();
      });
  }, [n]);
}
const Ei = ({
  children: e,
  loginUrlParams: t,
  onAuth: n,
  onInit: s,
  profileUrl: r,
  session: i,
  whitelistedUxfDomains: l,
  chatbotConfig: c
}) => {
  const o = Qr(dr()), [d, u] = D(!1), [f, h] = D(!1), [m, v] = D(!1), [g, y] = D(""), [x, b] = D(""), [j, C] = D(r.default), [N, M] = D(""), _ = !c.hiddenPortals.find((B) => B && window.location.href.match(new RegExp(B, "i"))), L = Xt(() => {
    const B = ue(jr);
    d && N && _ && !B && vr(N);
  }, [d, _, N]);
  Ti(c, L), W(() => {
    const B = Cr(t, o);
    y(B);
    const E = l.includes(window.location.hostname);
    u(!!(E || Kn())), v(E), C(E ? r.uxf : r.default), b(E ? r.uxf : ""), B && (s == null || s({ ulmUrl: B, isUxfPortal: E }));
    const k = (I) => {
      const H = I.detail;
      E || u(Tr(H));
    };
    return window.addEventListener(Vt, k), () => {
      window.removeEventListener(Vt, k);
    };
  }, [t, s, r.default, r.uxf, o, l]), W(() => {
    g && !f && _r(i, _, o).then((B) => {
      M((B == null ? void 0 : B.name) || ""), n == null || n(B), h(!0);
    });
  }, [f, _, g, n, i, o]);
  const S = Bn(
    () => ({ authenticated: d, isUxfPortal: m, loginUrl: g, logoutUrl: x, profileUrl: j, isChatbotConfiguredToBeShown: _ }),
    [d, m, g, x, j, _]
  );
  return /* @__PURE__ */ a.jsx(ss.Provider, { value: S, children: e });
}, Ni = Ei, Pi = ({ bold: e, boldOnHover: t, className: n, text: s, ...r }) => /* @__PURE__ */ a.jsx(
  "span",
  {
    "data-title": s,
    className: P(
      "tracking-wide antialiased outline-none before:invisible before:block before:h-0 before:overflow-hidden before:font-bold before:tracking-wide before:content-[attr(data-title)]",
      e && "font-bold tracking-normal [text-shadow:0px_0px_currentcolor]",
      t && "hover:font-bold hover:tracking-normal hover:[text-shadow:0px_0px_currentcolor] focus:font-bold focus:tracking-normal focus:[text-shadow:0px_0px_currentcolor]",
      n
    ),
    ...r,
    children: s
  }
), te = Pi, _i = ({ button: e, menuLabel: t, onLogin: n, onLogout: s, shouldOverrideLogout: r }) => {
  const { authenticated: i, loginUrl: l, logoutUrl: c, profileUrl: o, isChatbotConfiguredToBeShown: d } = rs(), u = (h) => () => {
    r || Er(), d && Ft(), s == null || s(), h();
  }, f = () => {
    be("Login")(), n == null || n(), window.location.href = J(l, { location: encodeURIComponent(window.location.href) });
  };
  return i ? /* @__PURE__ */ a.jsx(he, { as: "div", className: "relative flex h-10 items-center", children: ({ close: h, open: m }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(he.Button, { className: "flex focus-visible:outline-none", "aria-label": "Profile", children: [
      /* @__PURE__ */ a.jsx(jn, {}),
      /* @__PURE__ */ a.jsx(te, { text: e.profile, bold: m, className: "ml-2 hidden lg:block" })
    ] }),
    /* @__PURE__ */ a.jsx(
      oe,
      {
        as: Te,
        enter: "origin-top-right transition ease-out duration-100",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "origin-top-right transition ease-in duration-75",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /* @__PURE__ */ a.jsxs(
          he.Items,
          {
            id: G("profile-menu"),
            className: "absolute right-0 top-full z-10 space-y-4 rounded-sm bg-black p-4 text-right text-base shadow-lg outline-none lg:top-[calc(100%_+_8px)]",
            children: [
              /* @__PURE__ */ a.jsx(he.Item, { as: X, href: o, onClick: h, className: "inline-block whitespace-nowrap", children: /* @__PURE__ */ a.jsx(te, { text: t.manage, boldOnHover: !0 }) }),
              /* @__PURE__ */ a.jsx(
                he.Item,
                {
                  as: X,
                  href: c || void 0,
                  onClick: u(h),
                  className: "inline-block cursor-pointer whitespace-nowrap",
                  children: /* @__PURE__ */ a.jsx(te, { text: t.logout, boldOnHover: !0 })
                }
              )
            ]
          }
        )
      }
    )
  ] }) }) : /* @__PURE__ */ a.jsxs("button", { type: "button", onClick: f, className: "flex h-10 items-center", "aria-label": "Login", children: [
    /* @__PURE__ */ a.jsx(jn, {}),
    /* @__PURE__ */ a.jsx(te, { text: e.login, className: "ml-2 hidden lg:block" })
  ] });
}, ki = _i, Mi = mt(qe), is = Mi;
function as() {
  return zn(is);
}
const Oi = ({ children: e, locale: t }) => /* @__PURE__ */ a.jsx(is.Provider, { value: t, children: e }), Ii = Oi, Li = ({ onChange: e, options: t }) => {
  const n = as(), s = t.find((i) => i.locale === n) ?? {
    locale: n,
    name: "",
    shortName: n.toUpperCase()
  }, r = (i, l) => () => {
    const c = qn(i.locale);
    c !== null && (e == null || e(c)), l();
  };
  return /* @__PURE__ */ a.jsx(he, { as: "div", className: "relative flex h-10 items-center", children: ({ close: i, open: l }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(he.Button, { className: "flex focus-visible:outline-none", "aria-label": "Language", children: [
      /* @__PURE__ */ a.jsx(Dr, {}),
      /* @__PURE__ */ a.jsx(te, { text: s.shortName, bold: l, className: "ml-2 hidden lg:block" })
    ] }),
    /* @__PURE__ */ a.jsx(
      oe,
      {
        as: Te,
        enter: "origin-top-right transition ease-out duration-100",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "origin-top-right transition ease-in duration-75",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /* @__PURE__ */ a.jsx(
          he.Items,
          {
            id: G("language-switcher"),
            className: "absolute right-0 top-full z-10 space-y-4 rounded-sm bg-black p-4 text-base shadow-lg outline-none lg:top-[calc(100%_+_8px)]",
            children: t.map((c) => /* @__PURE__ */ a.jsxs(
              he.Item,
              {
                as: "div",
                className: "flex cursor-pointer items-center justify-between",
                onClick: r(c, i),
                children: [
                  /* @__PURE__ */ a.jsx(
                    te,
                    {
                      text: c.name,
                      bold: s.locale === c.locale,
                      boldOnHover: !0,
                      className: P(
                        "inline-block whitespace-nowrap",
                        s.locale === c.locale && "text-magenta"
                      )
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    xt,
                    {
                      className: P(
                        "invisible ml-16 shrink-0 text-magenta",
                        s.locale === c.locale && "visible"
                      )
                    }
                  )
                ]
              },
              c.locale
            ))
          }
        )
      }
    )
  ] }) });
}, Ai = Li, $i = (e) => /* @__PURE__ */ a.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "20", height: "20", ...e, children: [
  /* @__PURE__ */ a.jsx(
    "path",
    {
      d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
      fill: "currentcolor",
      opacity: "0.4"
    }
  ),
  /* @__PURE__ */ a.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m13.831 13.016-3.014-3.018 3.014 3.018ZM7.337 14.19l2.666-2.669 2.66 2.665a1.075 1.075 0 1 0 1.522-1.522l-2.662-2.665 2.662-2.665.003-.003a1.074 1.074 0 0 0 .003-1.504 1.063 1.063 0 0 0-1.53-.002l-2.658 2.661-2.658-2.66a1.063 1.063 0 0 0-1.524-.005 1.053 1.053 0 0 0 .004 1.517l2.657 2.66-2.658 2.662a1.063 1.063 0 0 0 .003 1.532 1.083 1.083 0 0 0 1.51-.002Z",
      fill: "#fff"
    }
  )
] }), Ri = $i, Di = ({ className: e, endpoint: t, placeholder: n, queryKey: s }) => {
  const r = Q(null), [i, l] = D(""), c = () => {
    var d;
    l(""), (d = r.current) == null || d.focus();
  }, o = (d) => {
    const f = new FormData(d.currentTarget).get(s);
    typeof f == "string" && f.trim();
  };
  return /* @__PURE__ */ a.jsxs("form", { id: G("search"), className: "relative", action: t, onSubmit: o, children: [
    /* @__PURE__ */ a.jsx(
      "input",
      {
        ref: r,
        className: P(
          "h-14 appearance-none rounded-sm bg-white p-4 pr-[52px] text-base placeholder-current caret-blue outline-none placeholder:opacity-40 [&::-webkit-search-cancel-button]:appearance-none",
          e
        ),
        name: s,
        type: "search",
        placeholder: n,
        autoComplete: "off",
        value: i,
        onChange: (d) => l(d.target.value)
      }
    ),
    i.length ? /* @__PURE__ */ a.jsx(Ri, { className: "absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer", onClick: c }) : /* @__PURE__ */ a.jsx(Zn, { className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-neutral-400 lg:hidden" }),
    /* @__PURE__ */ a.jsx("input", { type: "submit", hidden: !0, className: "hidden" })
  ] });
}, os = Di, Bi = ({ button: e, form: t }) => /* @__PURE__ */ a.jsx(Re, { as: "div", className: "hidden h-10 items-center lg:flex", children: ({ open: n }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
  /* @__PURE__ */ a.jsxs(
    Re.Button,
    {
      className: "flex focus-visible:outline-none",
      onClick: be(n ? "Close Search" : "Search"),
      children: [
        /* @__PURE__ */ a.jsx(Zn, {}),
        /* @__PURE__ */ a.jsx(te, { text: e, bold: n, className: "ml-2 hidden lg:block" })
      ]
    }
  ),
  /* @__PURE__ */ a.jsx(
    oe,
    {
      as: Te,
      enter: "origin-top-right transition ease-out duration-100",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "origin-top-right transition ease-in duration-75",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      children: /* @__PURE__ */ a.jsx(Re.Panel, { className: "absolute right-18 top-full z-10 shadow-lg lg:top-[calc(100%_+_8px)]", focus: !0, children: /* @__PURE__ */ a.jsx(os, { ...t, className: "w-[368px] bg-black outline-none" }) })
    }
  )
] }) }), zi = Bi, Fi = ({
  account: e,
  className: t,
  hideLanguageSwitcher: n,
  languageOptions: s,
  onLocaleChange: r,
  onLogin: i,
  onLogout: l,
  search: c,
  shouldOverrideLogout: o
}) => /* @__PURE__ */ a.jsxs("nav", { id: G("utilities"), className: P("flex items-center space-x-6 text-sm", t), children: [
  /* @__PURE__ */ a.jsx(zi, { ...c }),
  !n && /* @__PURE__ */ a.jsx(Ai, { options: s, onChange: r }),
  /* @__PURE__ */ a.jsx(ki, { ...e, shouldOverrideLogout: o, onLogin: i, onLogout: l })
] }), ls = Fi, Hi = ({ links: e, name: t, newTab: n, url: s, regex: r }) => {
  const [i, l] = ne(), c = !!r && RegExp(r, "i").test(window.location.href);
  return e ? /* @__PURE__ */ a.jsxs(Re, { as: "div", className: "relative hidden h-20 items-center lg:flex", "data-nav": "nested", children: [
    s ? /* @__PURE__ */ a.jsx(
      X,
      {
        onMouseEnter: l.on,
        onMouseLeave: l.off,
        href: s,
        newTab: n,
        onClick: be(t, s),
        className: "hidden h-full items-center lg:flex",
        "data-nav": "link",
        forwardUtm: !0,
        children: /* @__PURE__ */ a.jsx(te, { text: t, bold: c, boldOnHover: !0 })
      }
    ) : /* @__PURE__ */ a.jsx(
      Re.Button,
      {
        className: "h-full focus-visible:outline-none",
        onMouseEnter: l.on,
        onMouseLeave: l.off,
        children: /* @__PURE__ */ a.jsx(te, { text: t, bold: c, boldOnHover: !0 })
      }
    ),
    /* @__PURE__ */ a.jsx(
      oe,
      {
        as: Te,
        show: i,
        enter: "transition ease-out duration-100",
        enterFrom: "opacity-0 -translate-y-1",
        enterTo: "opacity-100 translate-y-0",
        leave: "transition ease-in duration-75",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 -translate-y-1",
        children: /* @__PURE__ */ a.jsx(
          Re.Panel,
          {
            as: "nav",
            static: !0,
            className: "absolute -left-4 top-[calc(100%_-_8px)] z-10 flex flex-col space-y-4 whitespace-nowrap rounded-sm border-neutral bg-white p-4 text-black shadow",
            onMouseEnter: l.on,
            onMouseLeave: l.off,
            children: e.map((o) => /* @__PURE__ */ a.jsx(
              X,
              {
                href: o.url,
                newTab: o.newTab,
                onClick: be(o.name, o.url, "nested"),
                forwardUtm: !0,
                children: /* @__PURE__ */ a.jsx(
                  te,
                  {
                    text: o.name,
                    bold: !!o.regex && RegExp(o.regex, "i").test(window.location.href),
                    boldOnHover: !0
                  }
                )
              },
              o.url
            ))
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ a.jsx(
    X,
    {
      href: s,
      newTab: n,
      onClick: be(t, s),
      className: "hidden lg:block",
      "data-nav": "link",
      forwardUtm: !0,
      children: /* @__PURE__ */ a.jsx(te, { text: t, bold: c, boldOnHover: !0 })
    }
  );
}, Vi = Hi, Gi = ({
  background: e = "magenta",
  centerMobileLogo: t,
  items: n,
  logo: s,
  logoSize: r,
  onMenuClick: i,
  utilityNavProps: l
}) => {
  const c = le("lg");
  return /* @__PURE__ */ a.jsx("div", { id: G("global-nav"), className: P(e === "magenta" && "bg-gradient-magenta1"), children: /* @__PURE__ */ a.jsxs("div", { className: "container relative flex h-14 items-center lg:h-20", children: [
    /* @__PURE__ */ a.jsx("button", { type: "button", "aria-label": "Menu", className: "mr-5 block lg:hidden", onClick: i, children: /* @__PURE__ */ a.jsx($r, {}) }),
    /* @__PURE__ */ a.jsxs("nav", { className: P("flex grow items-center space-x-6", t && "justify-evenly lg:justify-start"), children: [
      /* @__PURE__ */ a.jsx(
        X,
        {
          href: s.url,
          newTab: s.newTab,
          forwardUtm: !0,
          onClick: be("Astro Logo", s.url),
          className: P(
            "shrink-0 lg:mr-4",
            t && "absolute left-1/2 -translate-x-1/2 lg:static lg:left-0 lg:translate-x-0"
          ),
          children: /* @__PURE__ */ a.jsx(
            "img",
            {
              src: s.src,
              alt: s.name,
              className: "h-6 lg:h-8",
              height: r && (c ? r.desktop.height : r.mobile.height),
              width: r && (c ? r.desktop.width : r.mobile.width)
            }
          )
        }
      ),
      n.map((o) => /* @__PURE__ */ a.jsx(Vi, { ...o }, o.name))
    ] }),
    /* @__PURE__ */ a.jsx(ls, { ...l, className: "lg:hidden" })
  ] }) });
}, Ui = Gi;
function Wi(e, t, n) {
  const { data: s, isLoading: r } = Jt(e, "cross_promotion", {
    fetchCondition: () => !!n
  });
  if (!s)
    return {
      config: {
        title: "Explore websites in Astro",
        logo: { src: "", alt: "" },
        products: []
      },
      isLoading: !0
    };
  const i = {
    en: "en",
    bm: "ms"
  };
  return {
    config: {
      title: s.titleLocales[i[t]],
      logo: { src: s.titleLogoUrl, alt: "Astro" },
      products: s.products.map((l) => ({
        image: l.thumbnail,
        name: l.title,
        description: l.description,
        url: l.external_link
      }))
    },
    isLoading: r
  };
}
const Yi = ({ endpoint: e, onClose: t, open: n }) => {
  const s = as(), {
    config: { title: r, logo: i, products: l },
    isLoading: c
  } = Wi(e, s, n);
  return /* @__PURE__ */ a.jsx(
    Xe,
    {
      open: n,
      id: G("brands"),
      panelClassName: "h-full max-w-full overflow-auto rounded-none bg-neutral-50",
      children: /* @__PURE__ */ a.jsxs("div", { className: "container flex flex-col py-8", children: [
        /* @__PURE__ */ a.jsx(ke, { className: "mb-4 self-end", onClick: t }),
        /* @__PURE__ */ a.jsxs("header", { id: G("brands", "header"), className: "mb-8 flex items-center", children: [
          /* @__PURE__ */ a.jsx("h1", { className: "text-[22px] font-bold", children: r }),
          /* @__PURE__ */ a.jsx("img", { src: i.src, alt: i.alt, className: "ml-2 h-6" })
        ] }),
        c ? /* @__PURE__ */ a.jsx("p", { children: "Loading..." }) : /* @__PURE__ */ a.jsx("div", { id: G("brands", "grid"), className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: l.map(({ description: o, image: d, name: u, url: f }) => /* @__PURE__ */ a.jsxs(X, { href: f, newTab: !0, className: "flex rounded-sm bg-white p-2 shadow", children: [
          /* @__PURE__ */ a.jsx("img", { className: "row-span-3 rounded-xs", src: d, alt: u, width: 120, height: 120, loading: "lazy" }),
          /* @__PURE__ */ a.jsxs("div", { className: "ml-2 flex flex-col", children: [
            /* @__PURE__ */ a.jsx("h2", { className: "mb-1 font-extrabold leading-none", children: u }),
            /* @__PURE__ */ a.jsx("p", { className: "text-[13px]", children: o }),
            /* @__PURE__ */ a.jsx("p", { className: "mt-auto text-[13px]", children: f })
          ] })
        ] }, u)) })
      ] })
    }
  );
}, qi = Yi, Xi = ({ crossPromo: e, utilityNavProps: t, sites: n, variant: s }) => {
  const [r, i] = ne(), [l, c] = D(0), o = n.filter((u, f) => s === "mobile" ? f !== l : !0), d = () => {
    i.on(), be(e.name, "", s === "mobile" ? "mobile" : "main")();
  };
  return W(() => {
    const u = o.findIndex(({ regex: f }) => f && RegExp(f, "i").test(window.location.href));
    u >= 0 && c(u);
  }, [o]), /* @__PURE__ */ a.jsx(
    "div",
    {
      id: G("universal-nav"),
      className: P("h-10 bg-black", s === "desktop" && "hidden lg:block"),
      children: /* @__PURE__ */ a.jsxs("div", { className: "container relative flex h-full justify-center lg:justify-between", children: [
        /* @__PURE__ */ a.jsxs("nav", { className: "flex items-center justify-center space-x-6 text-sm text-white lg:justify-start lg:space-x-7", children: [
          o.map(({ name: u, newTab: f, url: h }, m) => /* @__PURE__ */ a.jsx(
            X,
            {
              href: h,
              newTab: f,
              onClick: be(u, h, s === "mobile" ? "mobile" : "main"),
              children: /* @__PURE__ */ a.jsx(te, { text: u, bold: s === "desktop" && m === l, boldOnHover: !0 })
            },
            u
          )),
          /* @__PURE__ */ a.jsx(
            te,
            {
              className: "cursor-pointer align-baseline",
              text: e.name,
              bold: r,
              boldOnHover: !0,
              onClick: d
            }
          ),
          /* @__PURE__ */ a.jsx(qi, { endpoint: e.endpoint, open: r, onClose: i.off })
        ] }),
        t && /* @__PURE__ */ a.jsx(ls, { ...t })
      ] })
    }
  );
}, cs = Xi, Ki = ({ links: e, name: t, newTab: n, url: s }) => e ? /* @__PURE__ */ a.jsx(de, { as: "nav", children: ({ open: r }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
  /* @__PURE__ */ a.jsxs(de.Button, { className: "flex w-full items-center justify-between py-4", children: [
    /* @__PURE__ */ a.jsx("span", { className: "text-xl font-extrabold", children: t }),
    /* @__PURE__ */ a.jsx(De, { direction: r ? "up" : "down", className: "h-5 w-5 text-magenta transition-transform" })
  ] }),
  /* @__PURE__ */ a.jsx(Qt, { show: r, children: /* @__PURE__ */ a.jsx(de.Panel, { as: "ul", static: !0, className: "space-y-6 pb-4 pt-2", children: e.map((i) => /* @__PURE__ */ a.jsx("li", { children: /* @__PURE__ */ a.jsx(X, { href: i.url, newTab: i.newTab, forwardUtm: !0, children: i.name }) }, i.name)) }) })
] }) }) : /* @__PURE__ */ a.jsx(X, { href: s, newTab: n, className: "inline-block w-full py-4 text-xl font-extrabold", forwardUtm: !0, children: t }), Zi = Ki, Ji = ({ config: { global: e, universal: t, utility: n }, onClose: s, open: r }) => /* @__PURE__ */ a.jsxs(
  Xe,
  {
    open: r,
    onClose: s,
    id: G("mobile-drawer"),
    className: "z-30",
    panelClassName: "fixed inset-0 flex max-w-full flex-col rounded-none",
    panelTransitionProps: {
      enterFrom: "-translate-x-full",
      enterTo: "translate-x-0",
      leaveFrom: "translate-x-0",
      leaveTo: "-translate-x-full"
    },
    children: [
      /* @__PURE__ */ a.jsxs("header", { id: G("mobile-drawer", "header"), className: "sticky top-0 z-10 h-[82px] bg-gradient-magenta1", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "relative flex h-14 justify-center text-white", children: [
          /* @__PURE__ */ a.jsx(ke, { className: "absolute left-4 top-1/2 -translate-y-1/2", onClick: s }),
          /* @__PURE__ */ a.jsx("h1", { className: "place-self-center text-xl", children: e.menu })
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "container", children: /* @__PURE__ */ a.jsx(
          os,
          {
            ...n.search.form,
            className: "w-full border border-neutral shadow focus:border focus:border-blue"
          }
        ) })
      ] }),
      /* @__PURE__ */ a.jsx(
        "section",
        {
          id: G("mobile-drawer", "menu"),
          className: "container grow divide-y divide-neutral overflow-auto pb-12 pt-10",
          children: e.items.map((i) => /* @__PURE__ */ a.jsx(Zi, { ...i }, i.name))
        }
      ),
      /* @__PURE__ */ a.jsx("footer", { className: "sticky top-[100vh]", children: /* @__PURE__ */ a.jsx(cs, { variant: "mobile", ...t }) })
    ]
  }
), Qi = Ji;
function ea(e, t) {
  const { authenticated: n } = rs(), { data: s } = Se({
    endpoint: e,
    formatResponse: (r) => {
      const i = Date.now(), l = r.find(
        (f) => i >= new Date(f.startTime).getTime() && i < new Date(f.endTime).getTime()
      );
      if (!l || !l.visibility.map((f) => t[f]).some((f) => window.location.href.match(new RegExp(f, "i"))) || !l.userSegment.length)
        return null;
      const d = !!l.userSegment.find((f) => f === "loggedIn"), u = !!l.userSegment.find((f) => f === "nonLoggedIn");
      return !d && !u || d && !u && !n || !d && u && n ? null : {
        dismissDuration: l.cookiesExpiry,
        mobileImage: {
          name: l.mobileImage.altText,
          url: l.url,
          src: l.mobileImage.image
        },
        desktopImage: {
          name: l.desktopImage.altText,
          url: l.url,
          src: l.desktopImage.image
        }
      };
    },
    fetchCondition: () => !(ue(Yn) === "1")
  });
  return s ?? null;
}
const ta = ({ endpoint: e, portalRegexMap: t }) => {
  const n = ea(e, t), [s, r] = ne();
  if (W(() => {
    n && r.on();
  }, [n, r]), !n)
    return null;
  const { dismissDuration: i, desktopImage: l, mobileImage: c } = n, o = () => {
    r.off(), ve(Yn, "1", i, !1, Ye(window.location.href));
  };
  return /* @__PURE__ */ a.jsxs(
    Xe,
    {
      open: s,
      id: G("modal-banner"),
      panelClassName: "h-[480px] max-h-screen w-80 max-w-full overscroll-contain rounded lg:h-[1200px] lg:w-[800px]",
      children: [
        /* @__PURE__ */ a.jsx(ke, { className: "absolute right-4 top-4", onClick: o }),
        /* @__PURE__ */ a.jsx(X, { href: c.url, id: G("modal-banner", "mobile"), className: "block lg:hidden", children: /* @__PURE__ */ a.jsx("img", { src: c.src, alt: c.name, className: "rounded", loading: "lazy" }) }),
        /* @__PURE__ */ a.jsx(X, { href: l.url, id: G("modal-banner", "desktop"), className: "hidden lg:block", children: /* @__PURE__ */ a.jsx("img", { src: l.src, alt: l.name, className: "rounded", loading: "lazy" }) })
      ]
    }
  );
}, na = ta, sa = ({
  background: e = "magenta",
  centerMobileLogo: t,
  config: n,
  hideLanguageSwitcher: s,
  locale: r = qe,
  onAuth: i,
  onInit: l,
  onLocaleChange: c,
  onLogin: o,
  onLogout: d,
  shouldOverrideLogout: u
}) => {
  const f = {
    ...n.utility,
    hideLanguageSwitcher: s,
    shouldOverrideLogout: u,
    onLogin: o,
    onLogout: d,
    onLocaleChange: c
  }, [h, m] = ne(), { ref: v, inView: g } = cr();
  return /* @__PURE__ */ a.jsx(Ni, { ...n.auth, chatbotConfig: n.chatbot, onInit: l, onAuth: i, children: /* @__PURE__ */ a.jsxs(Ii, { locale: r, children: [
    /* @__PURE__ */ a.jsx(ji, { ...n.banner, showMiniBanner: !g }),
    /* @__PURE__ */ a.jsxs("header", { id: G(), ref: v, className: "relative text-white", children: [
      /* @__PURE__ */ a.jsx(cs, { variant: "desktop", ...n.universal, utilityNavProps: f }),
      /* @__PURE__ */ a.jsx(
        Ui,
        {
          ...n.global,
          background: e,
          centerMobileLogo: t,
          utilityNavProps: f,
          onMenuClick: m.on
        }
      ),
      /* @__PURE__ */ a.jsx(Qi, { config: n, open: h, onClose: m.off })
    ] }),
    /* @__PURE__ */ a.jsx(na, { endpoint: n.banner.modal.bcpV3Endpoint, portalRegexMap: n.banner.portalRegexMap })
  ] }) });
}, Nc = sa, ra = (e) => /* @__PURE__ */ a.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 13", ...e, children: /* @__PURE__ */ a.jsx("path", { d: "M0 0v13h7.006c.919 0 1.344-1.522.649-2.325z" }) }), ia = ra;
function aa(e, t, n) {
  const [s, r] = D(""), i = Xt(() => {
    const l = t.find(({ regex: c }) => RegExp(c).test(window.location.href));
    r(l ? J(e, { code: l.code }) : "");
  }, [t, e]);
  return W(() => (window.addEventListener("popstate", i), () => {
    window.removeEventListener("popstate", i);
  }), [i]), W(() => {
    i();
  }, [n, i]), s;
}
function oa() {
  const [e, t] = D(0);
  return W(() => {
    const n = () => {
      let r = 0;
      document.querySelectorAll("[data-livechat-sticky]").forEach((l) => {
        l instanceof HTMLElement && l.offsetHeight > r && (r = l.offsetHeight);
      }), t(r);
    }, s = new MutationObserver(n);
    return n(), s.observe(document, { subtree: !0, childList: !0 }), () => {
      s.disconnect();
    };
  }, []), e;
}
function Pt(...e) {
  return `acm-live-chat${e.length ? `__${e.join("__")}` : ""}`;
}
const la = ({
  config: {
    bubbleDescription: e,
    bubbleTitle: t,
    chatCodes: n,
    chatEndpoint: s,
    helpText: r,
    icon: i,
    idleSecondsToShowBubble: l,
    scrollHeightToShowBubble: c
  },
  path: o
}) => {
  const d = aa(s, n, o), u = oa(), [f, h] = D(!1), [m, v] = D(!1);
  return ur({
    element: document,
    debounce: 250,
    timeout: l * 1e3,
    onIdle: () => window.scrollY > c && h(!0)
  }), Fn(() => {
    const g = () => {
      window.scrollY > 0 && requestAnimationFrame(() => {
        v(!0), h(!1);
      });
    };
    return window.addEventListener("scroll", g, { once: !0 }), () => {
      window.removeEventListener("scroll", g);
    };
  }, []), /* @__PURE__ */ a.jsxs(
    oe,
    {
      id: Pt(),
      show: !!d,
      appear: !0,
      enter: "ease-out duration-200",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "ease-in duration-150",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      className: "fixed bottom-4 right-4 z-10 text-black transition-all",
      style: { bottom: u + 16 },
      children: [
        /* @__PURE__ */ a.jsxs(
          X,
          {
            id: Pt("fab"),
            href: d,
            newTab: !0,
            className: P(
              "relative flex h-12 max-w-xs items-center overflow-hidden rounded-full bg-[#333] p-3 transition-[max-width] duration-300",
              m && "max-w-[48px]"
            ),
            children: [
              /* @__PURE__ */ a.jsx("img", { className: "shrink-0", src: i.src, alt: i.alt, width: 24, height: 24, loading: "lazy" }),
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: P(
                    "ml-2 min-w-max font-bold text-white transition-colors duration-200",
                    m && "text-transparent"
                  ),
                  children: r
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          oe,
          {
            show: f,
            as: X,
            href: d,
            newTab: !0,
            id: Pt("bubble"),
            className: "absolute bottom-0 right-[calc(100%_+_16px)] flex w-[calc(100vw_-_96px)] items-start justify-between rounded-sm rounded-br-none bg-[#e1fec6] p-4 drop-shadow sm:w-[272px]",
            enter: "transition origin-bottom-right duration-150 ease-out",
            enterFrom: "opacity-0 scale-90",
            enterTo: "opacity-1 scale-100",
            leave: "transition origin-bottom-right duration-100 ease-in",
            leaveFrom: "opacity-1 scale-100",
            leaveTo: "opacity-0 scale-90",
            children: [
              /* @__PURE__ */ a.jsxs("div", { children: [
                /* @__PURE__ */ a.jsx("p", { className: "mb-1 font-bold", children: t }),
                /* @__PURE__ */ a.jsx("p", { children: e })
              ] }),
              /* @__PURE__ */ a.jsx(
                ke,
                {
                  className: "ml-4",
                  onClick: (g) => {
                    g.preventDefault(), g.stopPropagation(), h(!1);
                  }
                }
              ),
              /* @__PURE__ */ a.jsx(ia, { className: "height-[13px] absolute -right-2 bottom-0 w-2 fill-[#e1fec6]" })
            ]
          }
        )
      ]
    }
  );
}, Pc = la, ca = {
  acm: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/K5OjDOxv2Z/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json"
  },
  myastro: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/ZKpywDPB3M/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/VZYyoAzvN5/config.json"
  },
  store: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/K5OjDOxv2Z/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json"
  }
}, da = (e) => ({
  header: {
    universal: {
      sites: [
        { name: "Consumer", url: "" },
        { name: "Business", url: "" },
        { name: "Corporate", url: "" }
      ],
      crossPromo: {
        endpoint: "",
        name: "Our Brands"
      }
    },
    global: {
      logo: e === "acm" ? {
        src: "https://acm-assets.eco.astro.com.my/images/astro-logo-white.svg",
        name: "Astro",
        url: ""
      } : {
        src: "https://acm-assets.eco.astro.com.my/images/myastro/logo_transparent_bg_15082022.svg",
        name: "MyAstro",
        url: ""
      },
      menu: "Menu",
      items: e === "acm" ? [
        { name: "Astro TV Packs", url: "" },
        { name: "Astro Fibre", url: "" },
        { name: "Products & Services", url: "" },
        { name: "TV Guide", url: "" },
        { name: "Promotions", url: "" },
        { name: "My Account", url: "" },
        { name: "Support", url: "" }
      ] : [
        { name: "Account", url: "" },
        { name: "Astro Store", url: "" },
        { name: "Content", url: "" },
        { name: "Rewards", url: "" },
        { name: "Support", url: "" }
      ]
    },
    utility: {
      languageOptions: [],
      account: {
        button: {
          login: "Login",
          profile: "Profile"
        },
        menuLabel: {
          manage: "",
          logout: ""
        }
      },
      search: {
        button: "Search",
        form: {
          endpoint: "",
          queryKey: "",
          placeholder: ""
        }
      }
    },
    auth: {
      loginUrlParams: {
        endpoint: "",
        queryParams: {}
      },
      profileUrl: {
        default: "",
        uxf: ""
      },
      session: {
        endpoints: {
          refresh: "",
          getUser: ""
        },
        client: "",
        payload: "",
        startSessionExpiry: 1440,
        refreshSessionExpiry: 10080
      },
      whitelistedUxfDomains: []
    },
    banner: {
      endpoint: "",
      bcpV3Endpoint: "",
      portalRegexMap: {
        homepage: "astro\\.com\\.my\\/?(bm)?(\\?.*?)?$",
        fibre: "astro\\.com\\.my\\/fibre",
        shop: "shop\\.astro\\.com\\.my",
        product: "products?\\.astro\\.com\\.my",
        support: "support\\.astro\\.com\\.my",
        promotions: "promotions\\.astro\\.com\\.my",
        uxf: "",
        contentGuide: "content\\.com\\.my",
        legacy: "astro\\.com\\.my\\/(?!fibre|bm)."
      },
      enabledPortals: [],
      dismissDuration: 1440,
      timerUnits: {
        fullForm: { day: "", hour: "", minute: "", second: "", separator: "" },
        shortForm: { day: "", hour: "", minute: "", second: "", separator: "" }
      },
      modal: {
        endpoint: "",
        bcpV3Endpoint: "https://contenthub-api.eco.astro.com.my/bcp/v3/entry-modal-en.json"
      }
    },
    chatbot: {
      hiddenPortals: []
    }
  },
  footer: {
    groups: [],
    complaint: { name: "", url: "", src: "" },
    contacts: {
      headingHtml: "",
      socials: []
    },
    mobileApps: {
      heading: "",
      apps: []
    },
    documentLinks: [],
    copyrightHtml: ""
  },
  liveChat: {
    chatEndpoint: "",
    chatCodes: [],
    scrollHeightToShowBubble: 400,
    idleSecondsToShowBubble: 30,
    icon: { src: "", alt: "" },
    helpText: "",
    bubbleTitle: "",
    bubbleDescription: ""
  }
});
function ua({
  endpoint: e,
  environment: t = "production",
  locale: n = qe,
  portal: s = "acm"
}) {
  var i;
  const { data: r } = Jt(e || ((i = ca[s]) == null ? void 0 : i[t]), [
    "header",
    "footer",
    "live_chat"
  ]);
  if (r) {
    const { locales: l = {}, ...c } = r[0], o = at(c, l[n]), d = { ...o };
    d.utility.languageOptions = o.utility.languageOptions.reduce((x, { locale: b, ...j }) => (Zt(b) && x.push({ locale: b, ...j }), x), []);
    const { locales: u = {}, ...f } = r[1], h = at(f, u[n]), { locales: m = {}, ...v } = r[2], g = at(v, m[n]), y = { ...g };
    return y.chatCodes = g.chatCodes.map(({ code: x, regex: b }) => ({
      code: x ?? g.defaultChatCode,
      regex: b
    })), {
      header: d,
      footer: h,
      liveChat: y
    };
  }
  return da(s);
}
const fa = ({ children: e, dfEndpoint: t, environment: n, onLocaleChange: s, portal: r }) => {
  const [i, l] = D(qe), c = ua({ portal: r, environment: n, endpoint: t, locale: i });
  return W(() => {
    const o = (d) => {
      const u = d.detail;
      u && Zt(u) && (l(u), s == null || s(u));
    };
    return window.addEventListener(Gt, o), () => {
      window.removeEventListener(Gt, o);
    };
  }, []), W(() => {
    let o = ue(Gn);
    if (!o) {
      const [d] = window.location.pathname.split("/").slice(1);
      o = d;
    }
    qn(o);
  }, []), typeof e == "function" ? e({ config: c, locale: i }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: e });
}, _c = fa;
function ce(...e) {
  return Kt("product-card", ...e);
}
function _t(e) {
  const t = document.querySelectorAll(e);
  return Math.max(...Array.from(t).map((s) => s.clientHeight));
}
function Tn(e, t = "") {
  const n = t ? `[data-product-card-group="${t}"]` : "", s = document.getElementById(e), r = s == null ? void 0 : s.querySelector(
    `${n} .product-card__ribbon`
  ), i = s == null ? void 0 : s.querySelector(
    `${n} .product-card__badges`
  ), l = s == null ? void 0 : s.querySelectorAll(`${n}.product-card`), c = _t(`${n} .product-card__description`), o = _t(`${n} .product-card__header`), d = _t(`${n} .product-card__panels-wrapper`);
  l == null || l.forEach((u) => {
    if (!t && u.dataset.productCardGroup)
      return;
    if (!u.querySelector(".product-card__ribbon") && r) {
      const y = u.querySelector(".product-card__ribbon-wrapper");
      y && (y.style.height = "36px");
    }
    if (!u.querySelector(".product-card__badges") && i) {
      const y = u.querySelector(".product-card__badges-wrapper");
      y && (y.style.height = "20px");
    }
    const m = u.querySelector(".product-card__description");
    m && (m.style.height = `${c}px`);
    const v = u.querySelector(".product-card__header");
    v && (v.style.height = `${o}px`);
    const g = u.querySelector(".product-card__panels-wrapper");
    g && (g.style.height = `${d}px`);
  });
}
const pa = ({ backgroundImageUrl: e, text: t, shouldReduceOpacity: n }) => /* @__PURE__ */ a.jsx(
  "div",
  {
    style: { backgroundImage: `url(${e})` },
    className: P(
      ce("ribbon"),
      "relative -mb-7 line-clamp-1 h-16 w-full rounded-t duration-75 lg:rounded-t-lg",
      n && "opacity-75"
    ),
    children: /* @__PURE__ */ a.jsx(ae, { className: "pt-2 text-center text-sm", text: t })
  }
), ma = pa, ha = ({ selected: e, children: t, className: n, onChange: s, type: r, ...i }) => {
  const l = r === "info", c = (o) => {
    l || (o.stopPropagation(), s == null || s());
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      onClick: c,
      className: P("relative overflow-hidden rounded bg-white shadow lg:rounded-lg", n),
      "aria-hidden": "true",
      role: l ? "" : "button",
      ...i,
      children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: P(
              "absolute  right-0 top-0 h-0 w-0 border-b-[48px] border-l-0 border-r-[48px] border-t-0 border-solid border-transparent border-r-neutral-200 duration-75",
              e && "border-r-blue-500",
              l && "hidden"
            )
          }
        ),
        /* @__PURE__ */ a.jsxs("div", { children: [
          /* @__PURE__ */ a.jsxs("svg", { viewBox: "0 0 16 16", className: "pointer-events-none absolute right-2 top-2 h-4 w-4 text-white opacity-100", children: [
            /* @__PURE__ */ a.jsx("path", { fill: "none", d: "M0 0h16v16H0z" }),
            /* @__PURE__ */ a.jsx(
              "path",
              {
                d: "M5.615 14.746a2 2 0 01-1.508-.685l-2.913-3.249A2 2 0 014.21 8.184l1.385 1.5 6.2-6.975a2 2 0 013.049 2.59l-7.709 8.746a2 2 0 01-1.512.7z",
                fill: "currentColor"
              }
            )
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "px-4 py-6 lg:px-6", children: [
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: P(
                  "pointer-events-none absolute left-0 top-0 z-[1] h-full w-full rounded border border-neutral-300 bg-transparent duration-75 lg:rounded-lg",
                  // The z-index is set to 1 to ensure that the wisepop modal, which has a fixed position and a z-index of 1, appears in front of the product card. This is because the DOM node of the wisepop modal is rendered after the DOM node of the product card.
                  e && "border-2 border-blue-500",
                  l && "border-neutral-200"
                )
              }
            ),
            t
          ] })
        ] })
      ]
    }
  );
}, xa = ha, ga = ({
  showCtaButton: e,
  ctaButtonText: t,
  ctaButtonUrl: n,
  onCtaButtonClick: s,
  icon: r,
  title: i,
  price: l,
  originalPrice: c,
  perMonthText: o,
  description: d,
  image: u,
  badges: f,
  ribbon: h,
  panels: m,
  forwardUtm: v,
  grouping: g,
  gaEventsConfig: y,
  ...x
}) => {
  const b = es(n), j = () => {
    if (n) {
      const C = v && b ? b : n;
      window.location.href = C, Ne({
        event: "select_item",
        content_type: "ACM Product",
        content_list_type: (y == null ? void 0 : y.contentListType) || "",
        content_title: i,
        content_id: C,
        item_name: t
      });
    }
    s == null || s();
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      ...g ? { "data-product-card-group": g } : {},
      className: P(ce(), "relative w-full max-w-[328px]"),
      children: [
        /* @__PURE__ */ a.jsx("div", { className: P(ce("ribbon-wrapper")), children: h && /* @__PURE__ */ a.jsx(
          ma,
          {
            ...h,
            shouldReduceOpacity: x.type === "selection" && !x.selected
          }
        ) }),
        /* @__PURE__ */ a.jsxs(xa, { ...x, children: [
          /* @__PURE__ */ a.jsxs("div", { className: P(ce("header"), "flex items-center"), children: [
            /* @__PURE__ */ a.jsx("img", { width: 32, height: 32, alt: r.alt, src: r.src, loading: "lazy" }),
            /* @__PURE__ */ a.jsx("p", { className: "ml-2 text-lg font-bold text-neutral-800", children: i })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "mt-2 font-extrabold", children: [
            /* @__PURE__ */ a.jsx("span", { className: "text-2xl", children: l }),
            /* @__PURE__ */ a.jsx("span", { children: o }),
            c && /* @__PURE__ */ a.jsx("span", { className: "ml-1.5 text-sm font-normal text-neutral-400", children: /* @__PURE__ */ a.jsx("s", { children: c }) })
          ] }),
          /* @__PURE__ */ a.jsx("div", { className: P(ce("badges-wrapper"), "mt-2"), children: f && f.length > 0 && /* @__PURE__ */ a.jsx("div", { className: P(ce("badges"), "flex space-x-2"), children: f.map((C) => /* @__PURE__ */ a.jsx(ht, { variant: "gray", children: C })) }) }),
          u ? /* @__PURE__ */ a.jsx("div", { className: P(ce("banner"), "-mx-6 mt-4"), children: /* @__PURE__ */ a.jsx("div", { className: "relative block w-full pb-[56.25%]", children: /* @__PURE__ */ a.jsx("img", { className: "absolute left-0 top-0 h-full w-full object-cover", src: u.src, alt: u.alt }) }) }) : /* @__PURE__ */ a.jsx("hr", { className: "my-4 text-neutral-200" }),
          /* @__PURE__ */ a.jsx("p", { className: P(ce("description"), "mt-4 line-clamp-3 text-neutral-800"), children: d }),
          /* @__PURE__ */ a.jsx("div", { className: P(ce("panels-wrapper"), "mt-4 space-y-4"), children: !!m && m }),
          e && /* @__PURE__ */ a.jsx(Be, { className: "mt-6 block w-full text-center", onClick: j, children: t })
        ] })
      ]
    }
  );
}, ds = ga, va = ({
  title: e,
  icon: t,
  ctaLinkText: n,
  onCtaLinkClick: s,
  panelClassName: r,
  children: i,
  panelSelected: l,
  className: c,
  gaEventsConfig: o,
  packTitle: d
}) => /* @__PURE__ */ a.jsxs("div", { className: c, children: [
  /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
      /* @__PURE__ */ a.jsx("img", { src: t.src, alt: t.alt, loading: "lazy", width: 24, height: 24 }),
      /* @__PURE__ */ a.jsx("p", { className: P("ml-2 line-clamp-1 font-bold", l && "text-green"), children: e })
    ] }),
    n && /* @__PURE__ */ a.jsx(
      Be,
      {
        variant: "text",
        className: "ml-2 whitespace-nowrap",
        onClick: (u) => {
          u.stopPropagation(), Ne({
            event: "view_item",
            content_type: "ACM Product",
            content_list_type: (o == null ? void 0 : o.contentListType) || "",
            content_title: d,
            item_name: n
          }), s == null || s();
        },
        children: n
      }
    )
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: P("mt-2 rounded-md bg-neutral-50 p-4", r), children: i })
] }), dt = va, wa = ({ list: e, ...t }) => /* @__PURE__ */ a.jsx(dt, { className: P(ce("base-panel")), ...t, children: /* @__PURE__ */ a.jsx("ul", { className: "grid gap-y-4", children: e.map(({ icon: { src: n, alt: s }, description: r }) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
  /* @__PURE__ */ a.jsx("img", { width: 32, height: 32, src: n, alt: s, loading: "lazy" }),
  /* @__PURE__ */ a.jsx("p", { className: "ml-2", children: r })
] }, n)) }) }), ba = wa, ya = ({ onClick: e, selected: t }) => /* @__PURE__ */ a.jsx(
  "button",
  {
    type: "button",
    className: P(
      "grid h-6 w-6 place-items-center rounded-sm bg-white",
      t ? "bg-blue text-white" : "border border-neutral-300 bg-white"
    ),
    onClick: e,
    children: t ? /* @__PURE__ */ a.jsx(xt, { width: 12, height: 12 }) : /* @__PURE__ */ a.jsx(Gr, { width: 12, height: 12 })
  }
), En = ya, kt = 5, ja = ({
  type: e,
  selected: t,
  panelIcon: n,
  description: s,
  onIconButtonClick: r,
  selectedPanelContent: i,
  ...l
}) => {
  if (e === "addon" && t && i) {
    const { addOns: c, price: o, panelTitle: d } = i, u = kt < c.length, f = u ? c.length - kt + 1 : null;
    return /* @__PURE__ */ a.jsxs(dt, { ...l, panelClassName: "bg-lime-200 h-24", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ a.jsx("p", { className: "line-clamp-1 font-bold", children: d }),
        /* @__PURE__ */ a.jsx(En, { selected: t, onClick: r })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "mt-1.5 flex items-end justify-between", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center -space-x-1", children: [
          c.filter((h, m) => u ? m < kt - 1 : !0).map(({ src: h, alt: m }) => /* @__PURE__ */ a.jsx("div", { className: "h-8 w-8 overflow-hidden rounded-sm ring-2 ring-lime-200", children: /* @__PURE__ */ a.jsx("img", { loading: "lazy", src: h, alt: m, className: "h-full w-full" }, h) })),
          u && /* @__PURE__ */ a.jsxs("p", { className: "flex h-8 w-8 items-center justify-center rounded-sm bg-lime-300 text-sm font-bold text-neutral-800 ring-2 ring-lime-200", children: [
            "+",
            f
          ] })
        ] }),
        /* @__PURE__ */ a.jsx(ht, { className: "bg-lime-300 text-neutral-800", children: o })
      ] })
    ] });
  }
  return /* @__PURE__ */ a.jsx(dt, { ...l, panelClassName: "bg-lime-200 h-24", panelSelected: t, children: /* @__PURE__ */ a.jsxs("div", { className: "flex h-16 items-start justify-between", children: [
    /* @__PURE__ */ a.jsx("img", { width: 32, height: 32, src: n.src, alt: n.alt }),
    /* @__PURE__ */ a.jsx(ae, { className: "mx-2 line-clamp-3 flex-1 text-sm", text: s }),
    /* @__PURE__ */ a.jsx(
      En,
      {
        selected: t,
        onClick: (c) => {
          c.stopPropagation(), r();
        }
      }
    )
  ] }) });
}, us = ja, Sa = (e) => {
  const { type: t } = e;
  let n;
  if (t === "selection") {
    const { selected: o, onChange: d } = e;
    n = {
      type: t,
      selected: o,
      onChange: d
    };
  } else {
    const { ctaButtonUrl: o, ctaButtonText: d, onCtaButtonClick: u } = e;
    n = {
      type: t,
      ctaButtonUrl: o,
      ctaButtonText: d,
      onCtaButtonClick: u
    };
  }
  const { upsellDetail: s, baseDetail: r, ...i } = e;
  ({ ...r });
  let l = null;
  s && (l = {
    type: s.type,
    title: s.title,
    panelIcon: s.panelIcon,
    icon: s.icon,
    onIconButtonClick: s.onIconButtonClick,
    description: s.description,
    ctaLinkText: s.ctaLinkText,
    onCtaLinkClick: s.onCtaLinkClick,
    selected: s.selected,
    selectedPanelContent: {
      panelTitle: s.panelTitle,
      addOns: s.addOns,
      price: s.price
    }
  });
  const c = [/* @__PURE__ */ a.jsx(ba, { ...r }), l && /* @__PURE__ */ a.jsx(us, { ...l })];
  return /* @__PURE__ */ a.jsx(ds, { ...i, ...n, showCtaButton: n.type === "info", panels: c });
}, kc = Sa, Mt = 6, Ca = ({ channelDescription: e, bundledAddOns: t, ...n }) => {
  const s = Mt < t.length, r = s ? t.length - Mt + 1 : null;
  return /* @__PURE__ */ a.jsxs(dt, { className: P(ce("base-panel")), ...n, children: [
    /* @__PURE__ */ a.jsx("p", { className: "font-bold", children: e }),
    /* @__PURE__ */ a.jsxs("div", { className: "mt-2 flex items-center -space-x-1", children: [
      t.filter((i, l) => s ? l < Mt - 1 : !0).map(({ src: i, alt: l }) => /* @__PURE__ */ a.jsx("div", { className: "h-10 w-10 overflow-hidden rounded-sm bg-white ring-2 ring-neutral-50", children: /* @__PURE__ */ a.jsx("img", { loading: "lazy", src: i, alt: l, className: "h-full w-full" }, i) })),
      s && /* @__PURE__ */ a.jsxs("p", { className: "flex h-10 w-10 items-center justify-center rounded-sm bg-magenta-50 text-sm font-bold text-magenta ring-2 ring-neutral-50", children: [
        "+",
        r
      ] })
    ] })
  ] });
}, Ta = Ca, Ea = (e) => {
  const { type: t } = e, { grouping: n } = e;
  let s;
  if (t === "selection") {
    const { selected: h, onChange: m } = e;
    s = {
      type: t,
      selected: h,
      onChange: m
    };
  } else {
    const { ctaButtonUrl: h, ctaButtonText: m, onCtaButtonClick: v } = e;
    s = {
      type: t,
      ctaButtonUrl: h,
      ctaButtonText: m,
      onCtaButtonClick: v
    };
  }
  const { upsellDetail: r, baseDetail: i, gaEventsConfig: l, ...c } = e;
  let o = null, d = {};
  r && (r.type === "upgrade" ? (o = {
    type: r.type,
    title: r.selected ? r.upgradeTitle : r.title,
    panelIcon: r.panelIcon,
    icon: r.selected ? r.selectedIcon : r.icon,
    onIconButtonClick: r.onIconButtonClick,
    description: r.description,
    ctaLinkText: r.ctaLinkText,
    onCtaLinkClick: r.onCtaLinkClick,
    selected: r.selected
  }, o.selected && (d = r.upgradePack)) : o = {
    type: r.type,
    title: r.title,
    panelIcon: r.panelIcon,
    icon: r.icon,
    onIconButtonClick: r.onIconButtonClick,
    description: r.description,
    ctaLinkText: r.ctaLinkText,
    onCtaLinkClick: r.onCtaLinkClick,
    selected: r.selected,
    selectedPanelContent: {
      panelTitle: r.panelTitle,
      addOns: r.addOns,
      price: r.price
    }
  });
  const u = d.title || c.title, f = [
    /* @__PURE__ */ a.jsx(
      Ta,
      {
        packTitle: u,
        gaEventsConfig: l,
        ...i,
        ...d == null ? void 0 : d.baseDetail
      }
    ),
    o && /* @__PURE__ */ a.jsx(us, { ...o })
  ];
  return /* @__PURE__ */ a.jsx(
    ds,
    {
      gaEventsConfig: l,
      ...c,
      ...d,
      ...s,
      grouping: n,
      showCtaButton: s.type === "info",
      panels: f
    }
  );
}, Mc = Ea, Na = ({ id: e, ...t }) => (W(() => {
  if (!e)
    return;
  const n = document == null ? void 0 : document.querySelectorAll("[data-product-card-group]"), s = [...new Set([...Array.from(n)].map((r) => r.dataset.productCardGroup))];
  Tn(e), s.forEach((r) => Tn(e, r));
}, []), /* @__PURE__ */ a.jsx("div", { id: e, ...t })), Oc = Na, Pe = {
  popupDf: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/6rPy3LqBn0/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/lE2v1p2BxY/config.json"
  },
  productPopup: {
    production: "https://cassandra-api.eco.astro.com.my/cassandra/api/v1/product-card/popup",
    staging: "https://cassandra-api-stg.eco.astro.com.my/cassandra/api/v1/product-card/popup"
  },
  channelListing: {
    production: "https://contenthub-api.eco.astro.com.my/channel/min.json",
    staging: "https://contenthub-api-stg.eco.astro.com.my/channel/min.json"
  }
}, ut = "ACM Product Pop-up";
function fs(e, t) {
  return e.reduce((n, s) => {
    const r = s.toString();
    return t[r] ? [...n, t[r]] : n;
  }, []);
}
function gt(e = qe) {
  return {
    en: "eng",
    bm: "may"
  }[e];
}
function Pa(e) {
  return {
    categories: e.map((t) => ({
      title: t.categoryTitle,
      categoryContent: t.tvPacks.map((n) => ({
        id: n.id,
        title: n.name,
        icon: { src: n.icon, alt: n.name },
        badge: n.tag
      }))
    }))
  };
}
function _a(e, t, n) {
  return {
    packConfig: {
      title: e.baseDetails.name,
      icon: { src: e.baseDetails.icon, alt: e.baseDetails.name },
      description: e.baseDetails.description,
      discountPrice: n ? e.bfDetails.discountedPrice : e.gfDetails.discountedPrice,
      originalPrice: n ? e.bfDetails.originalPrice : e.gfDetails.originalPrice,
      badge: e.baseDetails.tag,
      packImage: { src: e.baseDetails.image.image, alt: e.baseDetails.image.altText }
    },
    addOnConfig: {
      title: J(t.bundledContentTextConfig.addOnsSectionTitle, {
        noOfChannels: e.bundledContent.noOfChannels
      }),
      content: e.bundledContent.addOns.map((s) => ({
        id: s.id,
        title: s.name,
        description: J(
          s.type === "asianFav" ? s.noOfApps > 1 ? t.bundledContentTextConfig.groupedSecondaryContentAddOnItemDescription.multiApp : t.bundledContentTextConfig.groupedSecondaryContentAddOnItemDescription.singleApp : s.noOfChannels > 1 ? t.bundledContentTextConfig.addOnItemDescription.multiChannel : t.bundledContentTextConfig.addOnItemDescription.singleChannel,
          { noOfApps: s.noOfApps, noOfChannels: s.noOfChannels }
        ),
        icon: { src: s.icon, alt: s.name },
        type: s.type
      }))
    },
    appConfig: {
      title: J(
        e.bundledContent.noOfApps > 1 ? t.bundledContentTextConfig.appSectionTitle.multiApp : t.bundledContentTextConfig.appSectionTitle.singleApp,
        { noOfApps: e.bundledContent.noOfApps }
      ),
      content: e.bundledContent.apps.map((s) => ({
        id: s.id,
        type: s.type,
        title: s.name,
        description: J(
          s.noOfScreens > 1 ? t.bundledContentTextConfig.appItemDescription.multiScreen : t.bundledContentTextConfig.appItemDescription.singleScreen,
          { noOfScreens: s.noOfScreens, resolution: s.resolution }
        ),
        icon: { src: s.icon, alt: s.name }
      }))
    },
    backgroundImage: e.baseDetails.backgroundBanner,
    contentsTitle: t.contentsTitle,
    subsectionCollapseText: t.subsectionCollapseText,
    subsectionExpandText: t.subsectionExpandText,
    perMonthText: t.perMonthText,
    pricePrefix: t.pricePrefix,
    ctaLink: e.baseDetails.ctaLinkWeb
  };
}
function ka(e, t, n, s) {
  return {
    featureShowTitle: t.featureShowTitle,
    channelTitle: t.channelSectionTitle,
    icon: { src: e.icon, alt: e.name },
    packName: e.name,
    packSubtitle: J(
      e.channels.length > 1 ? t.packSubtitle.multiChannel : t.packSubtitle.singleChannel,
      {
        noOfChannels: e.channels.length
      }
    ),
    description: e.description,
    featureShows: e.images.map((r) => ({
      image: {
        src: r.image,
        alt: r.altText
      },
      title: r.title,
      description: r.description
    })),
    channels: fs(e.channels, n).map((r) => ({
      title: s === "bm" ? r.subtitle_my : r.subtitle,
      image: {
        src: r.imageUrl,
        alt: r.title
      },
      subtitle: r.title
    }))
  };
}
function Ma(e, t, n, s) {
  return {
    appAccordionText: t.appAccordionText,
    channelAccordionText: t.channelAccordionText,
    subsectionContentsTitle: t.subsectionContentsTitle,
    icon: { src: e.icon, alt: e.name },
    packTitle: e.name,
    packSubtitle: J(e.noOfApps > 1 ? t.packSubtitle.multiApp : t.packSubtitle.singleApp, {
      noOfApps: e.noOfApps,
      noOfChannels: e.noOfChannels
    }),
    description: e.description,
    type: e.type,
    subSections: [
      ...e.apps.map((r) => ({
        featuresConfig: {
          featureShows: r.apps.flatMap(
            (i) => i.images.map((l) => ({
              image: {
                src: l.image,
                alt: l.altText
              },
              title: l.title,
              description: l.description
            }))
          ),
          featureShowTitle: r.name,
          featureShowIcon: {
            src: r.icon,
            alt: r.name
          }
        },
        // type app will never return channels
        channelsConfig: {
          secondaryBundledContent: [],
          title: ""
        },
        appsConfig: {
          secondaryBundledContent: r.apps.map((i) => ({
            title: i.name,
            image: {
              src: i.icon,
              alt: i.name
            },
            subtitle: J(
              i.noOfScreens > 1 ? t.appItemDescription.multiScreen : t.appItemDescription.singleScreen,
              { noOfScreens: i.noOfScreens, resolution: i.resolution }
            )
          })),
          title: r.id === "aChinese" ? t.tvbAnywhereTitle : J(r.apps.length > 1 ? t.appSectionTitle.multiApp : t.appSectionTitle.singleApp, {
            noOfApps: r.apps.length
          })
        }
      })),
      ...e.addOns.map((r) => ({
        featuresConfig: {
          featureShows: r.images.map((i) => ({
            image: {
              src: i.image,
              alt: i.altText
            },
            title: i.title,
            description: i.description
          })),
          featureShowTitle: r.name,
          featureShowIcon: {
            src: r.icon,
            alt: r.name
          }
        },
        channelsConfig: {
          secondaryBundledContent: fs(r.channels, n).map((i) => ({
            title: s === "bm" ? i.subtitle_my : i.subtitle,
            image: {
              src: i.imageUrl,
              alt: i.title
            },
            subtitle: i.title
          })),
          title: J(
            r.channels.length > 1 ? t.channelsSectionTitle.multiChannel : t.channelsSectionTitle.singleChannel,
            { noOfChannels: r.channels.length }
          )
        },
        appsConfig: {
          secondaryBundledContent: r.apps.map((i) => ({
            title: i.name,
            image: {
              src: i.icon,
              alt: i.name
            },
            subtitle: J(
              i.noOfScreens > 1 ? t.appItemDescription.multiScreen : t.appItemDescription.singleScreen,
              { noOfScreens: i.noOfScreens, resolution: i.resolution }
            )
          })),
          title: r.id === "aChinese" ? t.tvbAnywhereTitle : J(r.apps.length > 1 ? t.appSectionTitle.multiApp : t.appSectionTitle.singleApp, {
            noOfApps: r.apps.length
          })
        }
      }))
    ]
  };
}
function vt(e, t) {
  const { data: n } = Jt(Pe.popupDf[e], "product_popup");
  if (n) {
    const { locales: s = {}, ...r } = n, i = at(r, s[t]);
    return {
      layoutTextConfig: i.layout,
      mainContentTextConfig: i.mainContent,
      singleSecondaryContentTextConfig: i.singleSecondaryContent,
      groupedSecondaryContentTextConfig: i.groupedSecondaryContent
    };
  }
  return null;
}
function ps(e) {
  const { data: t, error: n } = Se({
    endpoint: e,
    formatResponse: (s) => s
  });
  return n ? (je.error(n), null) : t;
}
function Oa(e, t, n, s) {
  var u;
  const r = gt(t), { data: i, error: l } = Se({
    endpoint: `${Pe.productPopup[n]}?platform=${e}&language=${r}&addOnId=aAsianFavourites&explore=${s}`,
    formatResponse: (f) => f
  }), c = (u = vt(n, t)) == null ? void 0 : u.groupedSecondaryContentTextConfig, o = ps(Pe.channelListing[n]);
  return l ? (je.error(l), null) : !c || !i || !o ? null : Ma(i, c, o, t);
}
function Ia(e, t, n, s, r) {
  var f;
  const i = gt(t), { data: l, error: c } = Se({
    endpoint: `${Pe.productPopup[s]}?platform=${e}&language=${i}&addOnId=${encodeURIComponent(n)}&explore=${r}`,
    formatResponse: (h) => h
  }), o = (f = vt(s, t)) == null ? void 0 : f.singleSecondaryContentTextConfig, d = ps(Pe.channelListing[s]);
  return c ? (je.error(c), null) : !o || !l || !d ? null : ka(l, o, d, t);
}
function La(e, t, n, s, r) {
  const i = gt(t), { data: l, error: c } = Se({
    endpoint: (
      // eslint-disable-next-line prefer-template
      `${Pe.productPopup[s]}?platform=${e}&language=${i}&explore=${n}` + (r ? `&categoryId=${r}` : "")
    ),
    formatResponse: (d) => d
  });
  return c ? (je.error(c), null) : l ? Pa(l) : null;
}
function Aa(e, t, n, s, r, i) {
  var f;
  const l = gt(n), { data: c, error: o } = Se({
    endpoint: (
      // eslint-disable-next-line prefer-template
      Pe.productPopup[s] + `?platform=${t}&language=${l}&packId=${encodeURIComponent(e)}&explore=${r}`
    ),
    formatResponse: (h) => h
  }), d = (f = vt(s, n)) == null ? void 0 : f.mainContentTextConfig;
  return o ? (je.error(o), null) : !d || !c ? null : _a(c, d, !!i);
}
const $a = ({ buttonText: e, onClick: t }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
  /* @__PURE__ */ a.jsx(ct, { icon: /* @__PURE__ */ a.jsx(De, { direction: "left" }), variant: "accent", size: "small", onClick: t }),
  /* @__PURE__ */ a.jsx("span", { className: "ml-2", children: e })
] }), ms = $a, Ra = ({
  ctaButtonText: e,
  showExploreButton: t,
  showCtaButton: n,
  onExploreButtonClick: s,
  onReturnButtonClick: r,
  onCtaButtonClick: i,
  exploreButtonText: l,
  returnButtonText: c,
  showReturnButton: o,
  broadbandCtaButtonText: d,
  broadbandExploreButtonText: u,
  isBroadband: f
}) => /* @__PURE__ */ a.jsxs("div", { className: "mt-auto flex h-16 items-center px-4 py-2 md:pl-8", children: [
  t && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ct, { variant: "accent", size: "small", onClick: s, icon: /* @__PURE__ */ a.jsx(Yr, {}) }),
    /* @__PURE__ */ a.jsx("span", { className: "ml-2.5", children: f ? u : l })
  ] }),
  o && /* @__PURE__ */ a.jsx(ms, { onClick: r, buttonText: c }),
  n && /* @__PURE__ */ a.jsx(Be, { className: "ml-auto flex-shrink-0 px-4 md:mr-6 xl:px-10", onClick: i, children: f ? d : e })
] }), Da = Ra, Ba = ({ boldOnHover: e, bold: t, className: n, text: s, ...r }) => /* @__PURE__ */ a.jsx(
  "span",
  {
    "data-title": s,
    className: P(
      "mt-0.5 tracking-wide antialiased outline-none before:invisible before:block before:h-0 before:overflow-hidden before:font-bold before:tracking-wide before:content-[attr(data-title)]",
      e && "focus:font-bold group-hover:font-bold group-hover:tracking-normal group-hover:text-magenta",
      t && "font-bold tracking-normal text-magenta",
      n
    ),
    ...r,
    children: s
  }
), za = Ba, Fa = ({
  title: e,
  icon: t,
  badge: n,
  onCategoryItemClick: s,
  id: r,
  isSelected: i
}) => /* @__PURE__ */ a.jsxs(
  "div",
  {
    className: P(
      "group flex cursor-pointer rounded-sm px-2 py-4 text-base text-neutral-800",
      i ? "bg-neutral-200" : "hover:bg-neutral-100"
    ),
    onClick: () => s(r, e),
    onKeyDown: () => s(r, e),
    role: "button",
    tabIndex: 0,
    children: [
      /* @__PURE__ */ a.jsx("img", { height: 24, width: 24, alt: t.alt, src: t.src, loading: "lazy", className: "mr-2 shrink-0 self-start" }),
      /* @__PURE__ */ a.jsx(za, { text: e, bold: i }),
      n && /* @__PURE__ */ a.jsx(ht, { className: "ml-auto self-center", children: n })
    ]
  }
), Ha = Fa, Va = ({ title: e, categoryContent: t, onCategoryItemClick: n }) => /* @__PURE__ */ a.jsxs("div", { className: "mb-4", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "align-center flex items-center", children: [
    /* @__PURE__ */ a.jsx("span", { className: "text-sm font-bold text-neutral-800", children: e }),
    /* @__PURE__ */ a.jsx("hr", { className: "ml-2 inline-block flex-grow text-neutral-200" })
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "space-y-1 pt-4", children: t.map((s) => /* @__PURE__ */ Dt(Ha, { onCategoryItemClick: n, ...s, key: s.id })) })
] }), Ga = Va;
function $({ className: e, ...t }) {
  return /* @__PURE__ */ a.jsx("div", { className: P("animate-pulse rounded-md bg-neutral-300", e), ...t });
}
const Ua = () => /* @__PURE__ */ a.jsx(a.Fragment, { children: [...Array(2).keys()].map((n) => /* @__PURE__ */ a.jsxs("div", { className: "mb-4", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "align-center flex items-center", children: [
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex h-5 items-center", children: /* @__PURE__ */ a.jsx($, { className: "h-3.5 w-24" }) }),
    /* @__PURE__ */ a.jsx("hr", { className: "ml-2 inline-block flex-grow text-neutral-200" })
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "space-y-1 pt-4", children: [...Array(3).keys()].map((s) => /* @__PURE__ */ a.jsxs("div", { className: "flex rounded-sm px-2 py-4", children: [
    /* @__PURE__ */ a.jsx($, { className: "mr-2 h-6 w-6 shrink-0 self-start" }),
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-36" }) })
  ] }, s)) })
] }, n)) }), Wa = Ua, Ya = ({ categories: e, onCategoryItemClick: t, activePack: n }) => /* @__PURE__ */ a.jsx("aside", { className: "w-[296px] px-4 pt-4 lg:w-[256px] xl:w-[272px]", children: e.length === 0 ? /* @__PURE__ */ a.jsx(Wa, {}) : e.map((s) => /* @__PURE__ */ a.jsx(
  Ga,
  {
    onCategoryItemClick: t,
    title: s.title,
    categoryContent: s.categoryContent.map((r) => ({ ...r, isSelected: r.id === n }))
  },
  s.title
)) }), Nn = Ya, qa = ({
  exploreButtonText: e,
  children: t,
  isSecondaryContentVisible: n,
  childContainerClassName: s,
  ctaButtonText: r,
  broadbandCtaButtonText: i,
  broadbandExploreButtonText: l,
  sidebarCategories: c,
  secondaryContentReturnButtonText: o,
  sidebarReturnButtonText: d,
  onCategoryItemClick: u,
  showBottomBar: f,
  defaultActivePack: h,
  onSecondaryContentReturnButtonClick: m,
  onCloseButtonClick: v,
  onCtaButtonClick: g,
  showCtaButton: y,
  isBroadband: x
}) => {
  const b = le("lg"), j = le("md"), [C, N] = ne(), [M, _] = D(h), L = (S, B) => {
    u(S, B), _(S), N.off();
  };
  return /* @__PURE__ */ a.jsxs("div", { className: "relative flex h-full overflow-hidden bg-white md:rounded", children: [
    !C && /* @__PURE__ */ a.jsx(
      "div",
      {
        className: P(
          "absolute right-4 top-4 z-10 flex rounded-lg bg-white",
          n && "hidden md:block"
        ),
        children: /* @__PURE__ */ a.jsx(
          ke,
          {
            className: P(
              "rounded-lg p-1.5 shadow-[0px_4px_20px_0px_rgba(77,79,90,0.1)]",
              n && "lg:shadow-none"
            ),
            onClick: v
          }
        )
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: "overflow-y-auto overflow-x-hidden", children: b ? /* @__PURE__ */ a.jsx(
      Nn,
      {
        categories: c,
        onCategoryItemClick: L,
        activePack: M
      }
    ) : /* @__PURE__ */ a.jsx(
      oe,
      {
        show: C,
        enter: "duration-150 ease-out",
        enterFrom: "w-0",
        enterTo: "w-[296px]",
        leave: "duration-100 ease-in",
        leaveFrom: "w-[296px]",
        leaveTo: "w-0",
        children: /* @__PURE__ */ a.jsx(
          Nn,
          {
            categories: c,
            onCategoryItemClick: L,
            activePack: M
          }
        )
      }
    ) }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex h-full flex-1 flex-col overflow-hidden", children: [
      n && /* @__PURE__ */ a.jsx("div", { className: "hidden h-16 items-center px-4 lg:flex", children: /* @__PURE__ */ a.jsx(ms, { buttonText: o, onClick: m }) }),
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: P(
            "col-span-1 row-span-1 grid flex-1 overflow-y-auto rounded-bl-sm lg:rounded-bl",
            n && "lg:rounded-tl",
            C && "overflow-hidden lg:overflow-y-auto",
            s
          ),
          children: [
            /* @__PURE__ */ a.jsx("div", { className: "col-start-1 row-start-1 w-screen overflow-x-hidden md:w-[calc(100vw_-_80px)] lg:w-full", children: t }),
            C && /* @__PURE__ */ a.jsx(
              "div",
              {
                className: "z-10 col-start-1 row-start-1 h-full w-full bg-black opacity-20 lg:hidden",
                onClick: N.off,
                onKeyDown: N.off,
                tabIndex: 0,
                role: "button",
                "aria-label": "Hide sidebar"
              }
            )
          ]
        }
      ),
      f && /* @__PURE__ */ a.jsx(
        Da,
        {
          onExploreButtonClick: N.on,
          ctaButtonText: r,
          returnButtonText: n ? o : j ? d : "",
          showCtaButton: !(C && !b) && !(n && !b) && y,
          showExploreButton: !C && !b && !n,
          showReturnButton: (C || !!n) && !b,
          onReturnButtonClick: n ? m : N.off,
          exploreButtonText: e,
          broadbandCtaButtonText: i,
          broadbandExploreButtonText: l,
          isBroadband: x,
          onCtaButtonClick: g
        }
      )
    ] })
  ] });
}, Xa = qa, Ka = ({
  title: e,
  children: t,
  isExpanded: n,
  onExpand: s,
  showCollapseIcon: r
}) => /* @__PURE__ */ a.jsx("div", { className: "mb-4 rounded-md bg-white shadow", children: /* @__PURE__ */ a.jsxs(de, { children: [
  /* @__PURE__ */ a.jsxs(
    de.Button,
    {
      className: "flex h-12 w-full items-center justify-between border-b border-b-neutral-200 px-4",
      onClick: s,
      children: [
        /* @__PURE__ */ a.jsx("h3", { className: "text-lg font-bold", children: e }),
        r && /* @__PURE__ */ a.jsx(
          "div",
          {
            className: P(
              "items-center justify-center rounded bg-transparent p-1.5 text-black transition-colors hover:bg-neutral-200",
              n && "bg-neutral-200"
            ),
            children: /* @__PURE__ */ a.jsx(De, { direction: n ? "up" : "down", className: "h-5 w-5 transition-all" })
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ a.jsx(de.Panel, { static: !0, className: "p-2 xl:px-4", children: t })
] }) }), Za = Ka, Ja = ({
  title: e,
  description: t,
  icon: n,
  type: s,
  id: r,
  onAddOnClick: i
}) => /* @__PURE__ */ a.jsxs(
  "div",
  {
    onClick: () => i == null ? void 0 : i(r, s),
    onKeyDown: () => i == null ? void 0 : i(r, s),
    role: "button",
    tabIndex: 0,
    className: "group flex cursor-pointer items-center overflow-hidden p-2 md:rounded-sm md:hover:bg-neutral-100",
    children: [
      /* @__PURE__ */ a.jsx("div", { className: "mr-2 flex h-10 w-10 flex-shrink-0 rounded-sm border border-neutral-200 bg-white", children: /* @__PURE__ */ a.jsx(
        "img",
        {
          className: "m-auto",
          width: s === "app" ? 40 : 32,
          height: s === "app" ? 40 : 32,
          loading: "lazy",
          src: n.src,
          alt: n.alt
        }
      ) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex min-w-0 flex-grow-0 flex-col pr-2", children: [
        /* @__PURE__ */ a.jsx("span", { className: "truncate text-base font-bold", children: e }),
        /* @__PURE__ */ a.jsx("span", { className: "truncate text-sm leading-5 text-neutral-800", children: t })
      ] }),
      i && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx("div", { className: "my-auto ml-auto flex h-8 w-8 items-center justify-end md:hidden", children: /* @__PURE__ */ a.jsx(
          ct,
          {
            icon: /* @__PURE__ */ a.jsx(De, { direction: "right" }),
            variant: "secondary",
            size: "small",
            className: "relative -right-2 p-2 text-neutral-600 outline-0 hover:bg-white [&>svg]:h-4 [&>svg]:w-4"
          }
        ) }),
        /* @__PURE__ */ a.jsx("div", { className: "my-auto ml-auto hidden md:group-hover:block", children: /* @__PURE__ */ a.jsx(ct, { icon: /* @__PURE__ */ a.jsx(De, { direction: "right" }), size: "small" }) })
      ] })
    ]
  }
), Pn = Ja, Qa = ({
  isExpanded: e,
  onExpand: t,
  title: n,
  bundledContent: s,
  onAddOnClick: r
}) => {
  const i = le("xl"), l = le("md", "down");
  return /* @__PURE__ */ a.jsxs(
    Za,
    {
      isExpanded: e,
      title: n,
      onExpand: t,
      showCollapseIcon: s.length > (i ? 3 : 2),
      children: [
        /* @__PURE__ */ a.jsx("div", { className: "flex flex-col md:grid md:grid-cols-2 xl:grid-cols-3", children: s.slice(0, i ? 3 : 2).map((c) => /* @__PURE__ */ Dt(Pn, { ...c, key: c.title, onAddOnClick: r })) }),
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: "overflow-hidden transition-[max-height] duration-150 ease-in-out",
            style: {
              maxHeight: e ? Math.ceil(s.slice(i ? 3 : 2).length / (i ? 3 : l ? 1 : 2)) * 60 : 0
            },
            children: /* @__PURE__ */ a.jsx("div", { className: "flex flex-col md:grid md:grid-cols-2 xl:grid-cols-3", children: s.slice(i ? 3 : 2).map((c) => /* @__PURE__ */ Dt(Pn, { ...c, key: c.title, onAddOnClick: r })) })
          }
        )
      ]
    }
  );
}, _n = Qa, eo = () => /* @__PURE__ */ a.jsxs("div", { className: "mb-4 rounded-md bg-white shadow", children: [
  /* @__PURE__ */ a.jsx("div", { className: "flex h-12 w-full items-center justify-between border-b border-b-neutral-200 px-4", children: /* @__PURE__ */ a.jsx($, { className: "h-5 w-28" }) }),
  /* @__PURE__ */ a.jsx("div", { className: "p-2 xl:px-4", children: /* @__PURE__ */ a.jsx("div", { className: "flex flex-col md:grid md:grid-cols-2 xl:grid-cols-3", children: [...Array(2).keys()].map((t) => /* @__PURE__ */ a.jsxs("div", { className: "group flex items-center overflow-hidden p-2 md:rounded-sm", children: [
    /* @__PURE__ */ a.jsx($, { className: "mr-2 flex h-10 w-10 flex-shrink-0 rounded-sm" }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex h-[42px] min-w-0 flex-grow-0 flex-col pr-2", children: [
      /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-36" }) }),
      /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex h-5 items-center", children: /* @__PURE__ */ a.jsx($, { className: "h-3.5 w-24" }) })
    ] })
  ] }, t)) }) })
] }), kn = eo, to = () => /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsxs("div", { className: "flex rounded-md bg-white p-2 shadow md:mt-16", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow flex-col p-2", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ a.jsx($, { className: "mr-2.5 h-6 w-6 self-start md:h-8 md:w-8" }),
      /* @__PURE__ */ a.jsx($, { className: " h-4 w-1/2" })
    ] }),
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center mt-2 flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-full" }) }),
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center mb-4 flex items-center py-px md:mb-2", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-2/3" }) }),
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center lex mt-auto items-center py-px ", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-6 w-32" }) })
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "shrink-0 md:block xl:ml-2", children: /* @__PURE__ */ a.jsx("div", { className: "rounded-sm", children: /* @__PURE__ */ a.jsx($, { className: "md:h-[166px] md:w-[296px] xl:h-[206px] xl:w-[368px]" }) }) })
] }) }), no = to, so = () => /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
  /* @__PURE__ */ a.jsx($, { className: "h-0 overflow-hidden rounded-none pb-[56.26%] md:hidden" }),
  /* @__PURE__ */ a.jsxs("div", { className: "px-4 md:px-10", children: [
    /* @__PURE__ */ a.jsx("div", { className: "mb-8 mt-4", children: /* @__PURE__ */ a.jsx(no, {}) }),
    /* @__PURE__ */ a.jsxs("div", { className: "mb-1 flex lg:mb-0.5", children: [
      /* @__PURE__ */ a.jsx($, { className: " h-5 w-44 md:h-6" }),
      /* @__PURE__ */ a.jsx($, { className: "ml-auto mr-0 h-4 w-20 self-end" })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "pb-8 pt-4", children: [
      /* @__PURE__ */ a.jsx(kn, {}),
      /* @__PURE__ */ a.jsx(kn, {})
    ] })
  ] })
] }), ro = so, io = ({
  packImage: e,
  badge: t,
  title: n,
  description: s,
  icon: r,
  discountPrice: i,
  originalPrice: l,
  perMonthText: c,
  pricePrefix: o
}) => /* @__PURE__ */ a.jsxs("div", { className: "flex rounded-md bg-white p-2 shadow md:mt-16", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow flex-col p-2", children: [
    t && /* @__PURE__ */ a.jsx(ht, { className: "mb-2 mr-auto", children: t }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ a.jsx("div", { className: "mr-2.5 h-6 w-6 self-start md:h-8 md:w-8", children: /* @__PURE__ */ a.jsx("img", { src: r.src, alt: r.alt }) }),
      /* @__PURE__ */ a.jsx("h2", { className: "text-xl font-extrabold md:text-2xl", children: n })
    ] }),
    /* @__PURE__ */ a.jsx(ae, { className: "mb-4 mt-2 line-clamp-2 text-neutral-800 md:mb-2", text: s }),
    /* @__PURE__ */ a.jsxs("div", { className: "mt-auto", children: [
      /* @__PURE__ */ a.jsxs("span", { className: "text-2xl font-extrabold", children: [
        o,
        i || l
      ] }),
      /* @__PURE__ */ a.jsx("span", { className: "font-extrabold", children: c }),
      i && /* @__PURE__ */ a.jsxs("span", { className: "ml-2 text-neutral-400 line-through", children: [
        o,
        l
      ] })
    ] })
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "hidden shrink-0 md:block xl:ml-2", children: /* @__PURE__ */ a.jsx("div", { className: "overflow-hidden rounded-sm", children: /* @__PURE__ */ a.jsx(
    "img",
    {
      src: e.src,
      alt: e.alt,
      className: "object-cover md:h-[166px] md:w-[296px] xl:h-[206px] xl:w-[368px]"
    }
  ) }) })
] }), ao = io, oo = ({ mainContentConfig: e, onAddOnClick: t, gaConfig: n }) => {
  const s = le("xl"), r = (_, L) => _ > (L ? 3 : 2), [i, l] = ne(), [c, o] = ne();
  if (W(() => {
    l.off(), o.off();
  }, [e]), !e)
    return /* @__PURE__ */ a.jsx(ro, {});
  const {
    packConfig: d,
    addOnConfig: u,
    appConfig: f,
    backgroundImage: h,
    contentsTitle: m,
    subsectionCollapseText: v,
    subsectionExpandText: g,
    perMonthText: y,
    pricePrefix: x
  } = e, b = r(u.content.length, s), j = r(f.content.length, s), C = () => {
    j && l.toggle();
  }, N = () => {
    b && o.toggle();
  }, M = () => {
    i && c ? (n && Ne({
      event: "view_item",
      content_type: ut,
      content_list_type: n.contentListType,
      content_title: d.title,
      item_name: v
    }), j && l.off(), b && o.off()) : (n && Ne({
      event: "view_item",
      content_type: ut,
      content_list_type: n.contentListType,
      content_title: d.title,
      item_name: g
    }), l.on(), o.on());
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: "-mb-52 hidden h-52 bg-cover bg-no-repeat md:block",
        style: {
          backgroundImage: `linear-gradient(180deg, rgba(246, 246, 248, 0.15) 0%, #F6F6F8 100%), url('${h}')`
        }
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ a.jsx("div", { className: "h-0 overflow-hidden pb-[56.26%] md:hidden", children: /* @__PURE__ */ a.jsx("img", { src: d.packImage.src, alt: d.packImage.alt }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "px-4 md:px-10", children: [
        /* @__PURE__ */ a.jsx("div", { className: "mb-8 mt-4", children: /* @__PURE__ */ a.jsx(ao, { ...d, pricePrefix: x, perMonthText: y }) }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ a.jsx("h2", { className: "text-lg md:text-xl", children: m }),
          /* @__PURE__ */ a.jsx(
            Be,
            {
              onClick: M,
              className: "ml-auto mr-0 cursor-pointer self-end text-magenta",
              variant: "text",
              children: !j && !b ? "" : (i || !j) && (c || !b) ? v : g
            }
          )
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "pb-8 pt-4", children: [
          /* @__PURE__ */ a.jsx(
            _n,
            {
              isExpanded: i,
              title: f.title,
              bundledContent: f.content,
              onExpand: C
            }
          ),
          /* @__PURE__ */ a.jsx(
            _n,
            {
              isExpanded: c,
              title: u.title,
              bundledContent: u.content,
              onExpand: N,
              onAddOnClick: t
            }
          )
        ] })
      ] })
    ] })
  ] });
}, lo = oo, co = ({ icon: e, packName: t, packSubtitle: n, description: s }) => /* @__PURE__ */ a.jsxs("div", { className: "rounded bg-white p-4 shadow", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "flex items-start", children: [
    /* @__PURE__ */ a.jsx("img", { src: e.src, alt: e.alt, height: 48, width: 48, loading: "lazy" }),
    /* @__PURE__ */ a.jsxs("div", { className: "ml-4", children: [
      /* @__PURE__ */ a.jsx("p", { className: "text-xl font-extrabold", children: t }),
      /* @__PURE__ */ a.jsx("p", { className: "text-neutral-800", children: n })
    ] })
  ] }),
  /* @__PURE__ */ a.jsx(ae, { className: "mt-4 text-neutral-800", text: s })
] }), hs = co, uo = ({ title: e, itemType: t, image: n, subtitle: s }) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-start", children: [
  t === "app" ? /* @__PURE__ */ a.jsx("div", { className: "rounded-sm bg-white", children: /* @__PURE__ */ a.jsx("img", { src: n.src, alt: n.alt, width: 40, height: 40, loading: "lazy" }) }) : /* @__PURE__ */ a.jsx("div", { className: "flex-shrink-0 rounded-sm bg-white px-1 py-1.5", children: /* @__PURE__ */ a.jsx("img", { src: n.src, alt: n.alt, height: 36, width: 64, loading: "lazy" }) }),
  /* @__PURE__ */ a.jsxs("div", { className: "ml-2", children: [
    /* @__PURE__ */ a.jsx("p", { className: "line-clamp-1 font-bold text-neutral-900", children: e }),
    /* @__PURE__ */ a.jsx("p", { className: "line-clamp-1 text-sm text-neutral-800 md:text-base", children: s })
  ] })
] }, e), Ut = uo, fo = ({
  contentTitle: e,
  content: t,
  isExpanded: n,
  onExpandButtonClick: s,
  expandedText: r,
  collapsedText: i,
  contentType: l
}) => {
  const c = le("xl"), o = le("md", "down");
  return /* @__PURE__ */ a.jsxs("div", { className: "mt-8", children: [
    /* @__PURE__ */ a.jsx("h3", { className: "text-lg", children: e }),
    /* @__PURE__ */ a.jsx("div", { className: "mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: t.slice(0, c ? 3 : 2).map((d) => /* @__PURE__ */ a.jsx(Ut, { ...d, itemType: l }, d.title)) }),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: "mb-4 overflow-hidden transition-[max-height] duration-150 ease-in-out",
        style: {
          maxHeight: n ? Math.ceil(t.slice(c ? 3 : 2).length / (c ? 3 : o ? 1 : 2)) * (l === "app" ? 60 : 63.5) : 0
        },
        children: /* @__PURE__ */ a.jsx("div", { className: "mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: t.slice(c ? 3 : 2).map((d) => /* @__PURE__ */ a.jsx(Ut, { ...d, itemType: l }, d.title)) })
      }
    ),
    t.length > (c ? 3 : 2) && /* @__PURE__ */ a.jsx(Be, { variant: "text", onClick: s, className: "block cursor-pointer pt-0.5 text-magenta", children: n ? r : i })
  ] });
}, Mn = fo;
function On(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function en(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), Object.keys(t).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : On(t[n]) && On(e[n]) && Object.keys(t[n]).length > 0 && en(e[n], t[n]);
  });
}
const xs = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Me() {
  const e = typeof document < "u" ? document : {};
  return en(e, xs), e;
}
const po = {
  document: xs,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function se() {
  const e = typeof window < "u" ? window : {};
  return en(e, po), e;
}
function mo(e) {
  const t = e;
  Object.keys(t).forEach((n) => {
    try {
      t[n] = null;
    } catch {
    }
    try {
      delete t[n];
    } catch {
    }
  });
}
function Wt(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function ft() {
  return Date.now();
}
function ho(e) {
  const t = se();
  let n;
  return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function xo(e, t) {
  t === void 0 && (t = "x");
  const n = se();
  let s, r, i;
  const l = ho(e);
  return n.WebKitCSSMatrix ? (r = l.transform || l.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((c) => c.replace(",", ".")).join(", ")), i = new n.WebKitCSSMatrix(r === "none" ? "" : r)) : (i = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = i.toString().split(",")), t === "x" && (n.WebKitCSSMatrix ? r = i.m41 : s.length === 16 ? r = parseFloat(s[12]) : r = parseFloat(s[4])), t === "y" && (n.WebKitCSSMatrix ? r = i.m42 : s.length === 16 ? r = parseFloat(s[13]) : r = parseFloat(s[5])), r || 0;
}
function rt(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function go(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function ee() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const s = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (s != null && !go(s)) {
      const r = Object.keys(Object(s)).filter((i) => t.indexOf(i) < 0);
      for (let i = 0, l = r.length; i < l; i += 1) {
        const c = r[i], o = Object.getOwnPropertyDescriptor(s, c);
        o !== void 0 && o.enumerable && (rt(e[c]) && rt(s[c]) ? s[c].__swiper__ ? e[c] = s[c] : ee(e[c], s[c]) : !rt(e[c]) && rt(s[c]) ? (e[c] = {}, s[c].__swiper__ ? e[c] = s[c] : ee(e[c], s[c])) : e[c] = s[c]);
      }
    }
  }
  return e;
}
function it(e, t, n) {
  e.style.setProperty(t, n);
}
function gs(e) {
  let {
    swiper: t,
    targetPosition: n,
    side: s
  } = e;
  const r = se(), i = -t.translate;
  let l = null, c;
  const o = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(t.cssModeFrameID);
  const d = n > i ? "next" : "prev", u = (h, m) => d === "next" && h >= m || d === "prev" && h <= m, f = () => {
    c = (/* @__PURE__ */ new Date()).getTime(), l === null && (l = c);
    const h = Math.max(Math.min((c - l) / o, 1), 0), m = 0.5 - Math.cos(h * Math.PI) / 2;
    let v = i + m * (n - i);
    if (u(v, n) && (v = n), t.wrapperEl.scrollTo({
      [s]: v
    }), u(v, n)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [s]: v
        });
      }), r.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = r.requestAnimationFrame(f);
  };
  f();
}
function xe(e, t) {
  return t === void 0 && (t = ""), [...e.children].filter((n) => n.matches(t));
}
function vo(e, t) {
  t === void 0 && (t = []);
  const n = document.createElement(e);
  return n.classList.add(...Array.isArray(t) ? t : [t]), n;
}
function wo(e, t) {
  const n = [];
  for (; e.previousElementSibling; ) {
    const s = e.previousElementSibling;
    t ? s.matches(t) && n.push(s) : n.push(s), e = s;
  }
  return n;
}
function bo(e, t) {
  const n = [];
  for (; e.nextElementSibling; ) {
    const s = e.nextElementSibling;
    t ? s.matches(t) && n.push(s) : n.push(s), e = s;
  }
  return n;
}
function we(e, t) {
  return se().getComputedStyle(e, null).getPropertyValue(t);
}
function In(e) {
  let t = e, n;
  if (t) {
    for (n = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (n += 1);
    return n;
  }
}
function yo(e, t) {
  const n = [];
  let s = e.parentElement;
  for (; s; )
    t ? s.matches(t) && n.push(s) : n.push(s), s = s.parentElement;
  return n;
}
function Ln(e, t, n) {
  const s = se();
  return n ? e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
let Ot;
function jo() {
  const e = se(), t = Me();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function vs() {
  return Ot || (Ot = jo()), Ot;
}
let It;
function So(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const n = vs(), s = se(), r = s.navigator.platform, i = t || s.navigator.userAgent, l = {
    ios: !1,
    android: !1
  }, c = s.screen.width, o = s.screen.height, d = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = i.match(/(iPad).*OS\s([\d_]+)/);
  const f = i.match(/(iPod)(.*OS\s([\d_]+))?/), h = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), m = r === "Win32";
  let v = r === "MacIntel";
  const g = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && v && n.touch && g.indexOf(`${c}x${o}`) >= 0 && (u = i.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), v = !1), d && !m && (l.os = "android", l.android = !0), (u || h || f) && (l.os = "ios", l.ios = !0), l;
}
function Co(e) {
  return e === void 0 && (e = {}), It || (It = So(e)), It;
}
let Lt;
function To() {
  const e = se();
  let t = !1;
  function n() {
    const s = e.navigator.userAgent.toLowerCase();
    return s.indexOf("safari") >= 0 && s.indexOf("chrome") < 0 && s.indexOf("android") < 0;
  }
  if (n()) {
    const s = String(e.navigator.userAgent);
    if (s.includes("Version/")) {
      const [r, i] = s.split("Version/")[1].split(" ")[0].split(".").map((l) => Number(l));
      t = r < 16 || r === 16 && i < 2;
    }
  }
  return {
    isSafari: t || n(),
    needPerspectiveFix: t,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function Eo() {
  return Lt || (Lt = To()), Lt;
}
function No(e) {
  let {
    swiper: t,
    on: n,
    emit: s
  } = e;
  const r = se();
  let i = null, l = null;
  const c = () => {
    !t || t.destroyed || !t.initialized || (s("beforeResize"), s("resize"));
  }, o = () => {
    !t || t.destroyed || !t.initialized || (i = new ResizeObserver((f) => {
      l = r.requestAnimationFrame(() => {
        const {
          width: h,
          height: m
        } = t;
        let v = h, g = m;
        f.forEach((y) => {
          let {
            contentBoxSize: x,
            contentRect: b,
            target: j
          } = y;
          j && j !== t.el || (v = b ? b.width : (x[0] || x).inlineSize, g = b ? b.height : (x[0] || x).blockSize);
        }), (v !== h || g !== m) && c();
      });
    }), i.observe(t.el));
  }, d = () => {
    l && r.cancelAnimationFrame(l), i && i.unobserve && t.el && (i.unobserve(t.el), i = null);
  }, u = () => {
    !t || t.destroyed || !t.initialized || s("orientationchange");
  };
  n("init", () => {
    if (t.params.resizeObserver && typeof r.ResizeObserver < "u") {
      o();
      return;
    }
    r.addEventListener("resize", c), r.addEventListener("orientationchange", u);
  }), n("destroy", () => {
    d(), r.removeEventListener("resize", c), r.removeEventListener("orientationchange", u);
  });
}
function Po(e) {
  let {
    swiper: t,
    extendParams: n,
    on: s,
    emit: r
  } = e;
  const i = [], l = se(), c = function(u, f) {
    f === void 0 && (f = {});
    const h = l.MutationObserver || l.WebkitMutationObserver, m = new h((v) => {
      if (t.__preventObserver__)
        return;
      if (v.length === 1) {
        r("observerUpdate", v[0]);
        return;
      }
      const g = function() {
        r("observerUpdate", v[0]);
      };
      l.requestAnimationFrame ? l.requestAnimationFrame(g) : l.setTimeout(g, 0);
    });
    m.observe(u, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: typeof f.childList > "u" ? !0 : f.childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), i.push(m);
  }, o = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const u = yo(t.hostEl);
        for (let f = 0; f < u.length; f += 1)
          c(u[f]);
      }
      c(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), c(t.wrapperEl, {
        attributes: !1
      });
    }
  }, d = () => {
    i.forEach((u) => {
      u.disconnect();
    }), i.splice(0, i.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", o), s("destroy", d);
}
var _o = {
  on(e, t, n) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function")
      return s;
    const r = n ? "unshift" : "push";
    return e.split(" ").forEach((i) => {
      s.eventsListeners[i] || (s.eventsListeners[i] = []), s.eventsListeners[i][r](t);
    }), s;
  },
  once(e, t, n) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function")
      return s;
    function r() {
      s.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
      for (var i = arguments.length, l = new Array(i), c = 0; c < i; c++)
        l[c] = arguments[c];
      t.apply(s, l);
    }
    return r.__emitterProxy = t, s.on(e, r, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    const s = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[s](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners)
      return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((s) => {
      typeof t > "u" ? n.eventsListeners[s] = [] : n.eventsListeners[s] && n.eventsListeners[s].forEach((r, i) => {
        (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[s].splice(i, 1);
      });
    }), n;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners)
      return e;
    let t, n, s;
    for (var r = arguments.length, i = new Array(r), l = 0; l < r; l++)
      i[l] = arguments[l];
    return typeof i[0] == "string" || Array.isArray(i[0]) ? (t = i[0], n = i.slice(1, i.length), s = e) : (t = i[0].events, n = i[0].data, s = i[0].context || e), n.unshift(s), (Array.isArray(t) ? t : t.split(" ")).forEach((o) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((d) => {
        d.apply(s, [o, ...n]);
      }), e.eventsListeners && e.eventsListeners[o] && e.eventsListeners[o].forEach((d) => {
        d.apply(s, n);
      });
    }), e;
  }
};
function ko() {
  const e = this;
  let t, n;
  const s = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = s.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? n = e.params.height : n = s.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(we(s, "padding-left") || 0, 10) - parseInt(we(s, "padding-right") || 0, 10), n = n - parseInt(we(s, "padding-top") || 0, 10) - parseInt(we(s, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
    width: t,
    height: n,
    size: e.isHorizontal() ? t : n
  }));
}
function Mo() {
  const e = this;
  function t(E) {
    return e.isHorizontal() ? E : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[E];
  }
  function n(E, k) {
    return parseFloat(E.getPropertyValue(t(k)) || 0);
  }
  const s = e.params, {
    wrapperEl: r,
    slidesEl: i,
    size: l,
    rtlTranslate: c,
    wrongRTL: o
  } = e, d = e.virtual && s.virtual.enabled, u = d ? e.virtual.slides.length : e.slides.length, f = xe(i, `.${e.params.slideClass}, swiper-slide`), h = d ? e.virtual.slides.length : f.length;
  let m = [];
  const v = [], g = [];
  let y = s.slidesOffsetBefore;
  typeof y == "function" && (y = s.slidesOffsetBefore.call(e));
  let x = s.slidesOffsetAfter;
  typeof x == "function" && (x = s.slidesOffsetAfter.call(e));
  const b = e.snapGrid.length, j = e.slidesGrid.length;
  let C = s.spaceBetween, N = -y, M = 0, _ = 0;
  if (typeof l > "u")
    return;
  typeof C == "string" && C.indexOf("%") >= 0 ? C = parseFloat(C.replace("%", "")) / 100 * l : typeof C == "string" && (C = parseFloat(C)), e.virtualSize = -C, f.forEach((E) => {
    c ? E.style.marginLeft = "" : E.style.marginRight = "", E.style.marginBottom = "", E.style.marginTop = "";
  }), s.centeredSlides && s.cssMode && (it(r, "--swiper-centered-offset-before", ""), it(r, "--swiper-centered-offset-after", ""));
  const L = s.grid && s.grid.rows > 1 && e.grid;
  L && e.grid.initSlides(h);
  let S;
  const B = s.slidesPerView === "auto" && s.breakpoints && Object.keys(s.breakpoints).filter((E) => typeof s.breakpoints[E].slidesPerView < "u").length > 0;
  for (let E = 0; E < h; E += 1) {
    S = 0;
    let k;
    if (f[E] && (k = f[E]), L && e.grid.updateSlide(E, k, h, t), !(f[E] && we(k, "display") === "none")) {
      if (s.slidesPerView === "auto") {
        B && (f[E].style[t("width")] = "");
        const I = getComputedStyle(k), H = k.style.transform, re = k.style.webkitTransform;
        if (H && (k.style.transform = "none"), re && (k.style.webkitTransform = "none"), s.roundLengths)
          S = e.isHorizontal() ? Ln(k, "width", !0) : Ln(k, "height", !0);
        else {
          const Ce = n(I, "width"), Oe = n(I, "padding-left"), Ie = n(I, "padding-right"), Y = n(I, "margin-left"), Z = n(I, "margin-right"), ze = I.getPropertyValue("box-sizing");
          if (ze && ze === "border-box")
            S = Ce + Y + Z;
          else {
            const {
              clientWidth: Ke,
              offsetWidth: Ze
            } = k;
            S = Ce + Oe + Ie + Y + Z + (Ze - Ke);
          }
        }
        H && (k.style.transform = H), re && (k.style.webkitTransform = re), s.roundLengths && (S = Math.floor(S));
      } else
        S = (l - (s.slidesPerView - 1) * C) / s.slidesPerView, s.roundLengths && (S = Math.floor(S)), f[E] && (f[E].style[t("width")] = `${S}px`);
      f[E] && (f[E].swiperSlideSize = S), g.push(S), s.centeredSlides ? (N = N + S / 2 + M / 2 + C, M === 0 && E !== 0 && (N = N - l / 2 - C), E === 0 && (N = N - l / 2 - C), Math.abs(N) < 1 / 1e3 && (N = 0), s.roundLengths && (N = Math.floor(N)), _ % s.slidesPerGroup === 0 && m.push(N), v.push(N)) : (s.roundLengths && (N = Math.floor(N)), (_ - Math.min(e.params.slidesPerGroupSkip, _)) % e.params.slidesPerGroup === 0 && m.push(N), v.push(N), N = N + S + C), e.virtualSize += S + C, M = S, _ += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, l) + x, c && o && (s.effect === "slide" || s.effect === "coverflow") && (r.style.width = `${e.virtualSize + C}px`), s.setWrapperSize && (r.style[t("width")] = `${e.virtualSize + C}px`), L && e.grid.updateWrapperSize(S, m, t), !s.centeredSlides) {
    const E = [];
    for (let k = 0; k < m.length; k += 1) {
      let I = m[k];
      s.roundLengths && (I = Math.floor(I)), m[k] <= e.virtualSize - l && E.push(I);
    }
    m = E, Math.floor(e.virtualSize - l) - Math.floor(m[m.length - 1]) > 1 && m.push(e.virtualSize - l);
  }
  if (d && s.loop) {
    const E = g[0] + C;
    if (s.slidesPerGroup > 1) {
      const k = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / s.slidesPerGroup), I = E * s.slidesPerGroup;
      for (let H = 0; H < k; H += 1)
        m.push(m[m.length - 1] + I);
    }
    for (let k = 0; k < e.virtual.slidesBefore + e.virtual.slidesAfter; k += 1)
      s.slidesPerGroup === 1 && m.push(m[m.length - 1] + E), v.push(v[v.length - 1] + E), e.virtualSize += E;
  }
  if (m.length === 0 && (m = [0]), C !== 0) {
    const E = e.isHorizontal() && c ? "marginLeft" : t("marginRight");
    f.filter((k, I) => !s.cssMode || s.loop ? !0 : I !== f.length - 1).forEach((k) => {
      k.style[E] = `${C}px`;
    });
  }
  if (s.centeredSlides && s.centeredSlidesBounds) {
    let E = 0;
    g.forEach((I) => {
      E += I + (C || 0);
    }), E -= C;
    const k = E - l;
    m = m.map((I) => I <= 0 ? -y : I > k ? k + x : I);
  }
  if (s.centerInsufficientSlides) {
    let E = 0;
    if (g.forEach((k) => {
      E += k + (C || 0);
    }), E -= C, E < l) {
      const k = (l - E) / 2;
      m.forEach((I, H) => {
        m[H] = I - k;
      }), v.forEach((I, H) => {
        v[H] = I + k;
      });
    }
  }
  if (Object.assign(e, {
    slides: f,
    snapGrid: m,
    slidesGrid: v,
    slidesSizesGrid: g
  }), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
    it(r, "--swiper-centered-offset-before", `${-m[0]}px`), it(r, "--swiper-centered-offset-after", `${e.size / 2 - g[g.length - 1] / 2}px`);
    const E = -e.snapGrid[0], k = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((I) => I + E), e.slidesGrid = e.slidesGrid.map((I) => I + k);
  }
  if (h !== u && e.emit("slidesLengthChange"), m.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), v.length !== j && e.emit("slidesGridLengthChange"), s.watchSlidesProgress && e.updateSlidesOffset(), !d && !s.cssMode && (s.effect === "slide" || s.effect === "fade")) {
    const E = `${s.containerModifierClass}backface-hidden`, k = e.el.classList.contains(E);
    h <= s.maxBackfaceHiddenSlides ? k || e.el.classList.add(E) : k && e.el.classList.remove(E);
  }
}
function Oo(e) {
  const t = this, n = [], s = t.virtual && t.params.virtual.enabled;
  let r = 0, i;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const l = (c) => s ? t.slides[t.getSlideIndexByData(c)] : t.slides[c];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((c) => {
        n.push(c);
      });
    else
      for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
        const c = t.activeIndex + i;
        if (c > t.slides.length && !s)
          break;
        n.push(l(c));
      }
  else
    n.push(l(t.activeIndex));
  for (i = 0; i < n.length; i += 1)
    if (typeof n[i] < "u") {
      const c = n[i].offsetHeight;
      r = c > r ? c : r;
    }
  (r || r === 0) && (t.wrapperEl.style.height = `${r}px`);
}
function Io() {
  const e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let s = 0; s < t.length; s += 1)
    t[s].swiperSlideOffset = (e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop) - n - e.cssOverflowAdjustment();
}
function Lo(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, n = t.params, {
    slides: s,
    rtlTranslate: r,
    snapGrid: i
  } = t;
  if (s.length === 0)
    return;
  typeof s[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let l = -e;
  r && (l = e), s.forEach((o) => {
    o.classList.remove(n.slideVisibleClass);
  }), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let c = n.spaceBetween;
  typeof c == "string" && c.indexOf("%") >= 0 ? c = parseFloat(c.replace("%", "")) / 100 * t.size : typeof c == "string" && (c = parseFloat(c));
  for (let o = 0; o < s.length; o += 1) {
    const d = s[o];
    let u = d.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (u -= s[0].swiperSlideOffset);
    const f = (l + (n.centeredSlides ? t.minTranslate() : 0) - u) / (d.swiperSlideSize + c), h = (l - i[0] + (n.centeredSlides ? t.minTranslate() : 0) - u) / (d.swiperSlideSize + c), m = -(l - u), v = m + t.slidesSizesGrid[o];
    (m >= 0 && m < t.size - 1 || v > 1 && v <= t.size || m <= 0 && v >= t.size) && (t.visibleSlides.push(d), t.visibleSlidesIndexes.push(o), s[o].classList.add(n.slideVisibleClass)), d.progress = r ? -f : f, d.originalProgress = r ? -h : h;
  }
}
function Ao(e) {
  const t = this;
  if (typeof e > "u") {
    const u = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * u || 0;
  }
  const n = t.params, s = t.maxTranslate() - t.minTranslate();
  let {
    progress: r,
    isBeginning: i,
    isEnd: l,
    progressLoop: c
  } = t;
  const o = i, d = l;
  if (s === 0)
    r = 0, i = !0, l = !0;
  else {
    r = (e - t.minTranslate()) / s;
    const u = Math.abs(e - t.minTranslate()) < 1, f = Math.abs(e - t.maxTranslate()) < 1;
    i = u || r <= 0, l = f || r >= 1, u && (r = 0), f && (r = 1);
  }
  if (n.loop) {
    const u = t.getSlideIndexByData(0), f = t.getSlideIndexByData(t.slides.length - 1), h = t.slidesGrid[u], m = t.slidesGrid[f], v = t.slidesGrid[t.slidesGrid.length - 1], g = Math.abs(e);
    g >= h ? c = (g - h) / v : c = (g + v - m) / v, c > 1 && (c -= 1);
  }
  Object.assign(t, {
    progress: r,
    progressLoop: c,
    isBeginning: i,
    isEnd: l
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), i && !o && t.emit("reachBeginning toEdge"), l && !d && t.emit("reachEnd toEdge"), (o && !i || d && !l) && t.emit("fromEdge"), t.emit("progress", r);
}
function $o() {
  const e = this, {
    slides: t,
    params: n,
    slidesEl: s,
    activeIndex: r
  } = e, i = e.virtual && n.virtual.enabled, l = (o) => xe(s, `.${n.slideClass}${o}, swiper-slide${o}`)[0];
  t.forEach((o) => {
    o.classList.remove(n.slideActiveClass, n.slideNextClass, n.slidePrevClass);
  });
  let c;
  if (i)
    if (n.loop) {
      let o = r - e.virtual.slidesBefore;
      o < 0 && (o = e.virtual.slides.length + o), o >= e.virtual.slides.length && (o -= e.virtual.slides.length), c = l(`[data-swiper-slide-index="${o}"]`);
    } else
      c = l(`[data-swiper-slide-index="${r}"]`);
  else
    c = t[r];
  if (c) {
    c.classList.add(n.slideActiveClass);
    let o = bo(c, `.${n.slideClass}, swiper-slide`)[0];
    n.loop && !o && (o = t[0]), o && o.classList.add(n.slideNextClass);
    let d = wo(c, `.${n.slideClass}, swiper-slide`)[0];
    n.loop && !d === 0 && (d = t[t.length - 1]), d && d.classList.add(n.slidePrevClass);
  }
  e.emitSlidesClasses();
}
const lt = (e, t) => {
  if (!e || e.destroyed || !e.params)
    return;
  const n = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, s = t.closest(n());
  if (s) {
    const r = s.querySelector(`.${e.params.lazyPreloaderClass}`);
    r && r.remove();
  }
}, At = (e, t) => {
  if (!e.slides[t])
    return;
  const n = e.slides[t].querySelector('[loading="lazy"]');
  n && n.removeAttribute("loading");
}, Yt = (e) => {
  if (!e || e.destroyed || !e.params)
    return;
  let t = e.params.lazyPreloadPrevNext;
  const n = e.slides.length;
  if (!n || !t || t < 0)
    return;
  t = Math.min(t, n);
  const s = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), r = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const l = r, c = [l - t];
    c.push(...Array.from({
      length: t
    }).map((o, d) => l + s + d)), e.slides.forEach((o, d) => {
      c.includes(o.column) && At(e, d);
    });
    return;
  }
  const i = r + s - 1;
  if (e.params.rewind || e.params.loop)
    for (let l = r - t; l <= i + t; l += 1) {
      const c = (l % n + n) % n;
      (c < r || c > i) && At(e, c);
    }
  else
    for (let l = Math.max(r - t, 0); l <= Math.min(i + t, n - 1); l += 1)
      l !== r && (l > i || l < r) && At(e, l);
};
function Ro(e) {
  const {
    slidesGrid: t,
    params: n
  } = e, s = e.rtlTranslate ? e.translate : -e.translate;
  let r;
  for (let i = 0; i < t.length; i += 1)
    typeof t[i + 1] < "u" ? s >= t[i] && s < t[i + 1] - (t[i + 1] - t[i]) / 2 ? r = i : s >= t[i] && s < t[i + 1] && (r = i + 1) : s >= t[i] && (r = i);
  return n.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r;
}
function Do(e) {
  const t = this, n = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: s,
    params: r,
    activeIndex: i,
    realIndex: l,
    snapIndex: c
  } = t;
  let o = e, d;
  const u = (h) => {
    let m = h - t.virtual.slidesBefore;
    return m < 0 && (m = t.virtual.slides.length + m), m >= t.virtual.slides.length && (m -= t.virtual.slides.length), m;
  };
  if (typeof o > "u" && (o = Ro(t)), s.indexOf(n) >= 0)
    d = s.indexOf(n);
  else {
    const h = Math.min(r.slidesPerGroupSkip, o);
    d = h + Math.floor((o - h) / r.slidesPerGroup);
  }
  if (d >= s.length && (d = s.length - 1), o === i) {
    d !== c && (t.snapIndex = d, t.emit("snapIndexChange")), t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = u(o));
    return;
  }
  let f;
  t.virtual && r.virtual.enabled && r.loop ? f = u(o) : t.slides[o] ? f = parseInt(t.slides[o].getAttribute("data-swiper-slide-index") || o, 10) : f = o, Object.assign(t, {
    previousSnapIndex: c,
    snapIndex: d,
    previousRealIndex: l,
    realIndex: f,
    previousIndex: i,
    activeIndex: o
  }), t.initialized && Yt(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), l !== f && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
}
function Bo(e) {
  const t = this, n = t.params, s = e.closest(`.${n.slideClass}, swiper-slide`);
  let r = !1, i;
  if (s) {
    for (let l = 0; l < t.slides.length; l += 1)
      if (t.slides[l] === s) {
        r = !0, i = l;
        break;
      }
  }
  if (s && r)
    t.clickedSlide = s, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(s.getAttribute("data-swiper-slide-index"), 10) : t.clickedIndex = i;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
var zo = {
  updateSize: ko,
  updateSlides: Mo,
  updateAutoHeight: Oo,
  updateSlidesOffset: Io,
  updateSlidesProgress: Lo,
  updateProgress: Ao,
  updateSlidesClasses: $o,
  updateActiveIndex: Do,
  updateClickedSlide: Bo
};
function Fo(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: n,
    rtlTranslate: s,
    translate: r,
    wrapperEl: i
  } = t;
  if (n.virtualTranslate)
    return s ? -r : r;
  if (n.cssMode)
    return r;
  let l = xo(i, e);
  return l += t.cssOverflowAdjustment(), s && (l = -l), l || 0;
}
function Ho(e, t) {
  const n = this, {
    rtlTranslate: s,
    params: r,
    wrapperEl: i,
    progress: l
  } = n;
  let c = 0, o = 0;
  const d = 0;
  n.isHorizontal() ? c = s ? -e : e : o = e, r.roundLengths && (c = Math.floor(c), o = Math.floor(o)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? c : o, r.cssMode ? i[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -c : -o : r.virtualTranslate || (n.isHorizontal() ? c -= n.cssOverflowAdjustment() : o -= n.cssOverflowAdjustment(), i.style.transform = `translate3d(${c}px, ${o}px, ${d}px)`);
  let u;
  const f = n.maxTranslate() - n.minTranslate();
  f === 0 ? u = 0 : u = (e - n.minTranslate()) / f, u !== l && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function Vo() {
  return -this.snapGrid[0];
}
function Go() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Uo(e, t, n, s, r) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), s === void 0 && (s = !0);
  const i = this, {
    params: l,
    wrapperEl: c
  } = i;
  if (i.animating && l.preventInteractionOnTransition)
    return !1;
  const o = i.minTranslate(), d = i.maxTranslate();
  let u;
  if (s && e > o ? u = o : s && e < d ? u = d : u = e, i.updateProgress(u), l.cssMode) {
    const f = i.isHorizontal();
    if (t === 0)
      c[f ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!i.support.smoothScroll)
        return gs({
          swiper: i,
          targetPosition: -u,
          side: f ? "left" : "top"
        }), !0;
      c.scrollTo({
        [f ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (i.setTransition(0), i.setTranslate(u), n && (i.emit("beforeTransitionStart", t, r), i.emit("transitionEnd"))) : (i.setTransition(t), i.setTranslate(u), n && (i.emit("beforeTransitionStart", t, r), i.emit("transitionStart")), i.animating || (i.animating = !0, i.onTranslateToWrapperTransitionEnd || (i.onTranslateToWrapperTransitionEnd = function(h) {
    !i || i.destroyed || h.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.onTranslateToWrapperTransitionEnd = null, delete i.onTranslateToWrapperTransitionEnd, n && i.emit("transitionEnd"));
  }), i.wrapperEl.addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd))), !0;
}
var Wo = {
  getTranslate: Fo,
  setTranslate: Ho,
  minTranslate: Vo,
  maxTranslate: Go,
  translateTo: Uo
};
function Yo(e, t) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`), n.emit("setTransition", e, t);
}
function ws(e) {
  let {
    swiper: t,
    runCallbacks: n,
    direction: s,
    step: r
  } = e;
  const {
    activeIndex: i,
    previousIndex: l
  } = t;
  let c = s;
  if (c || (i > l ? c = "next" : i < l ? c = "prev" : c = "reset"), t.emit(`transition${r}`), n && i !== l) {
    if (c === "reset") {
      t.emit(`slideResetTransition${r}`);
      return;
    }
    t.emit(`slideChangeTransition${r}`), c === "next" ? t.emit(`slideNextTransition${r}`) : t.emit(`slidePrevTransition${r}`);
  }
}
function qo(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: s
  } = n;
  s.cssMode || (s.autoHeight && n.updateAutoHeight(), ws({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function Xo(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: s
  } = n;
  n.animating = !1, !s.cssMode && (n.setTransition(0), ws({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var Ko = {
  setTransition: Yo,
  transitionStart: qo,
  transitionEnd: Xo
};
function Zo(e, t, n, s, r) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const i = this;
  let l = e;
  l < 0 && (l = 0);
  const {
    params: c,
    snapGrid: o,
    slidesGrid: d,
    previousIndex: u,
    activeIndex: f,
    rtlTranslate: h,
    wrapperEl: m,
    enabled: v
  } = i;
  if (i.animating && c.preventInteractionOnTransition || !v && !s && !r)
    return !1;
  const g = Math.min(i.params.slidesPerGroupSkip, l);
  let y = g + Math.floor((l - g) / i.params.slidesPerGroup);
  y >= o.length && (y = o.length - 1);
  const x = -o[y];
  if (c.normalizeSlideIndex)
    for (let j = 0; j < d.length; j += 1) {
      const C = -Math.floor(x * 100), N = Math.floor(d[j] * 100), M = Math.floor(d[j + 1] * 100);
      typeof d[j + 1] < "u" ? C >= N && C < M - (M - N) / 2 ? l = j : C >= N && C < M && (l = j + 1) : C >= N && (l = j);
    }
  if (i.initialized && l !== f && (!i.allowSlideNext && (h ? x > i.translate && x > i.minTranslate() : x < i.translate && x < i.minTranslate()) || !i.allowSlidePrev && x > i.translate && x > i.maxTranslate() && (f || 0) !== l))
    return !1;
  l !== (u || 0) && n && i.emit("beforeSlideChangeStart"), i.updateProgress(x);
  let b;
  if (l > f ? b = "next" : l < f ? b = "prev" : b = "reset", h && -x === i.translate || !h && x === i.translate)
    return i.updateActiveIndex(l), c.autoHeight && i.updateAutoHeight(), i.updateSlidesClasses(), c.effect !== "slide" && i.setTranslate(x), b !== "reset" && (i.transitionStart(n, b), i.transitionEnd(n, b)), !1;
  if (c.cssMode) {
    const j = i.isHorizontal(), C = h ? x : -x;
    if (t === 0) {
      const N = i.virtual && i.params.virtual.enabled;
      N && (i.wrapperEl.style.scrollSnapType = "none", i._immediateVirtual = !0), N && !i._cssModeVirtualInitialSet && i.params.initialSlide > 0 ? (i._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        m[j ? "scrollLeft" : "scrollTop"] = C;
      })) : m[j ? "scrollLeft" : "scrollTop"] = C, N && requestAnimationFrame(() => {
        i.wrapperEl.style.scrollSnapType = "", i._immediateVirtual = !1;
      });
    } else {
      if (!i.support.smoothScroll)
        return gs({
          swiper: i,
          targetPosition: C,
          side: j ? "left" : "top"
        }), !0;
      m.scrollTo({
        [j ? "left" : "top"]: C,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i.setTransition(t), i.setTranslate(x), i.updateActiveIndex(l), i.updateSlidesClasses(), i.emit("beforeTransitionStart", t, s), i.transitionStart(n, b), t === 0 ? i.transitionEnd(n, b) : i.animating || (i.animating = !0, i.onSlideToWrapperTransitionEnd || (i.onSlideToWrapperTransitionEnd = function(C) {
    !i || i.destroyed || C.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd), i.onSlideToWrapperTransitionEnd = null, delete i.onSlideToWrapperTransitionEnd, i.transitionEnd(n, b));
  }), i.wrapperEl.addEventListener("transitionend", i.onSlideToWrapperTransitionEnd)), !0;
}
function Jo(e, t, n, s) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const r = this;
  let i = e;
  return r.params.loop && (r.virtual && r.params.virtual.enabled ? i = i + r.virtual.slidesBefore : i = r.getSlideIndexByData(i)), r.slideTo(i, t, n, s);
}
function Qo(e, t, n) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
  const s = this, {
    enabled: r,
    params: i,
    animating: l
  } = s;
  if (!r)
    return s;
  let c = i.slidesPerGroup;
  i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (c = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const o = s.activeIndex < i.slidesPerGroupSkip ? 1 : c, d = s.virtual && i.virtual.enabled;
  if (i.loop) {
    if (l && !d && i.loopPreventsSliding)
      return !1;
    s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  return i.rewind && s.isEnd ? s.slideTo(0, e, t, n) : s.slideTo(s.activeIndex + o, e, t, n);
}
function el(e, t, n) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
  const s = this, {
    params: r,
    snapGrid: i,
    slidesGrid: l,
    rtlTranslate: c,
    enabled: o,
    animating: d
  } = s;
  if (!o)
    return s;
  const u = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (d && !u && r.loopPreventsSliding)
      return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const f = c ? s.translate : -s.translate;
  function h(x) {
    return x < 0 ? -Math.floor(Math.abs(x)) : Math.floor(x);
  }
  const m = h(f), v = i.map((x) => h(x));
  let g = i[v.indexOf(m) - 1];
  if (typeof g > "u" && r.cssMode) {
    let x;
    i.forEach((b, j) => {
      m >= b && (x = j);
    }), typeof x < "u" && (g = i[x > 0 ? x - 1 : x]);
  }
  let y = 0;
  if (typeof g < "u" && (y = l.indexOf(g), y < 0 && (y = s.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (y = y - s.slidesPerViewDynamic("previous", !0) + 1, y = Math.max(y, 0))), r.rewind && s.isBeginning) {
    const x = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(x, e, t, n);
  }
  return s.slideTo(y, e, t, n);
}
function tl(e, t, n) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
  const s = this;
  return s.slideTo(s.activeIndex, e, t, n);
}
function nl(e, t, n, s) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), s === void 0 && (s = 0.5);
  const r = this;
  let i = r.activeIndex;
  const l = Math.min(r.params.slidesPerGroupSkip, i), c = l + Math.floor((i - l) / r.params.slidesPerGroup), o = r.rtlTranslate ? r.translate : -r.translate;
  if (o >= r.snapGrid[c]) {
    const d = r.snapGrid[c], u = r.snapGrid[c + 1];
    o - d > (u - d) * s && (i += r.params.slidesPerGroup);
  } else {
    const d = r.snapGrid[c - 1], u = r.snapGrid[c];
    o - d <= (u - d) * s && (i -= r.params.slidesPerGroup);
  }
  return i = Math.max(i, 0), i = Math.min(i, r.slidesGrid.length - 1), r.slideTo(i, e, t, n);
}
function sl() {
  const e = this, {
    params: t,
    slidesEl: n
  } = e, s = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let r = e.clickedIndex, i;
  const l = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating)
      return;
    i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? r < e.loopedSlides - s / 2 || r > e.slides.length - e.loopedSlides + s / 2 ? (e.loopFix(), r = e.getSlideIndex(xe(n, `${l}[data-swiper-slide-index="${i}"]`)[0]), Wt(() => {
      e.slideTo(r);
    })) : e.slideTo(r) : r > e.slides.length - s ? (e.loopFix(), r = e.getSlideIndex(xe(n, `${l}[data-swiper-slide-index="${i}"]`)[0]), Wt(() => {
      e.slideTo(r);
    })) : e.slideTo(r);
  } else
    e.slideTo(r);
}
var rl = {
  slideTo: Zo,
  slideToLoop: Jo,
  slideNext: Qo,
  slidePrev: el,
  slideReset: tl,
  slideToClosest: nl,
  slideToClickedSlide: sl
};
function il(e) {
  const t = this, {
    params: n,
    slidesEl: s
  } = t;
  if (!n.loop || t.virtual && t.params.virtual.enabled)
    return;
  xe(s, `.${n.slideClass}, swiper-slide`).forEach((i, l) => {
    i.setAttribute("data-swiper-slide-index", l);
  }), t.loopFix({
    slideRealIndex: e,
    direction: n.centeredSlides ? void 0 : "next"
  });
}
function al(e) {
  let {
    slideRealIndex: t,
    slideTo: n = !0,
    direction: s,
    setTranslate: r,
    activeSlideIndex: i,
    byController: l,
    byMousewheel: c
  } = e === void 0 ? {} : e;
  const o = this;
  if (!o.params.loop)
    return;
  o.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: u,
    allowSlideNext: f,
    slidesEl: h,
    params: m
  } = o;
  if (o.allowSlidePrev = !0, o.allowSlideNext = !0, o.virtual && m.virtual.enabled) {
    n && (!m.centeredSlides && o.snapIndex === 0 ? o.slideTo(o.virtual.slides.length, 0, !1, !0) : m.centeredSlides && o.snapIndex < m.slidesPerView ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0) : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0)), o.allowSlidePrev = u, o.allowSlideNext = f, o.emit("loopFix");
    return;
  }
  const v = m.slidesPerView === "auto" ? o.slidesPerViewDynamic() : Math.ceil(parseFloat(m.slidesPerView, 10));
  let g = m.loopedSlides || v;
  g % m.slidesPerGroup !== 0 && (g += m.slidesPerGroup - g % m.slidesPerGroup), o.loopedSlides = g;
  const y = [], x = [];
  let b = o.activeIndex;
  typeof i > "u" ? i = o.getSlideIndex(o.slides.filter((_) => _.classList.contains(m.slideActiveClass))[0]) : b = i;
  const j = s === "next" || !s, C = s === "prev" || !s;
  let N = 0, M = 0;
  if (i < g) {
    N = Math.max(g - i, m.slidesPerGroup);
    for (let _ = 0; _ < g - i; _ += 1) {
      const L = _ - Math.floor(_ / d.length) * d.length;
      y.push(d.length - L - 1);
    }
  } else if (i > o.slides.length - g * 2) {
    M = Math.max(i - (o.slides.length - g * 2), m.slidesPerGroup);
    for (let _ = 0; _ < M; _ += 1) {
      const L = _ - Math.floor(_ / d.length) * d.length;
      x.push(L);
    }
  }
  if (C && y.forEach((_) => {
    o.slides[_].swiperLoopMoveDOM = !0, h.prepend(o.slides[_]), o.slides[_].swiperLoopMoveDOM = !1;
  }), j && x.forEach((_) => {
    o.slides[_].swiperLoopMoveDOM = !0, h.append(o.slides[_]), o.slides[_].swiperLoopMoveDOM = !1;
  }), o.recalcSlides(), m.slidesPerView === "auto" && o.updateSlides(), m.watchSlidesProgress && o.updateSlidesOffset(), n) {
    if (y.length > 0 && C)
      if (typeof t > "u") {
        const _ = o.slidesGrid[b], S = o.slidesGrid[b + N] - _;
        c ? o.setTranslate(o.translate - S) : (o.slideTo(b + N, 0, !1, !0), r && (o.touches[o.isHorizontal() ? "startX" : "startY"] += S, o.touchEventsData.currentTranslate = o.translate));
      } else
        r && (o.slideToLoop(t, 0, !1, !0), o.touchEventsData.currentTranslate = o.translate);
    else if (x.length > 0 && j)
      if (typeof t > "u") {
        const _ = o.slidesGrid[b], S = o.slidesGrid[b - M] - _;
        c ? o.setTranslate(o.translate - S) : (o.slideTo(b - M, 0, !1, !0), r && (o.touches[o.isHorizontal() ? "startX" : "startY"] += S, o.touchEventsData.currentTranslate = o.translate));
      } else
        o.slideToLoop(t, 0, !1, !0);
  }
  if (o.allowSlidePrev = u, o.allowSlideNext = f, o.controller && o.controller.control && !l) {
    const _ = {
      slideRealIndex: t,
      slideTo: !1,
      direction: s,
      setTranslate: r,
      activeSlideIndex: i,
      byController: !0
    };
    Array.isArray(o.controller.control) ? o.controller.control.forEach((L) => {
      !L.destroyed && L.params.loop && L.loopFix(_);
    }) : o.controller.control instanceof o.constructor && o.controller.control.params.loop && o.controller.control.loopFix(_);
  }
  o.emit("loopFix");
}
function ol() {
  const e = this, {
    params: t,
    slidesEl: n
  } = e;
  if (!t.loop || e.virtual && e.params.virtual.enabled)
    return;
  e.recalcSlides();
  const s = [];
  e.slides.forEach((r) => {
    const i = typeof r.swiperSlideIndex > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
    s[i] = r;
  }), e.slides.forEach((r) => {
    r.removeAttribute("data-swiper-slide-index");
  }), s.forEach((r) => {
    n.append(r);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var ll = {
  loopCreate: il,
  loopFix: al,
  loopDestroy: ol
};
function cl(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)
    return;
  const n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function dl() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var ul = {
  setGrabCursor: cl,
  unsetGrabCursor: dl
};
function fl(e, t) {
  t === void 0 && (t = this);
  function n(s) {
    if (!s || s === Me() || s === se())
      return null;
    s.assignedSlot && (s = s.assignedSlot);
    const r = s.closest(e);
    return !r && !s.getRootNode ? null : r || n(s.getRootNode().host);
  }
  return n(t);
}
function pl(e) {
  const t = this, n = Me(), s = se(), r = t.touchEventsData;
  r.evCache.push(e);
  const {
    params: i,
    touches: l,
    enabled: c
  } = t;
  if (!c || !i.simulateTouch && e.pointerType === "mouse" || t.animating && i.preventInteractionOnTransition)
    return;
  !t.animating && i.cssMode && i.loop && t.loopFix();
  let o = e;
  o.originalEvent && (o = o.originalEvent);
  let d = o.target;
  if (i.touchEventsTarget === "wrapper" && !t.wrapperEl.contains(d) || "which" in o && o.which === 3 || "button" in o && o.button > 0 || r.isTouched && r.isMoved)
    return;
  const u = !!i.noSwipingClass && i.noSwipingClass !== "", f = e.composedPath ? e.composedPath() : e.path;
  u && o.target && o.target.shadowRoot && f && (d = f[0]);
  const h = i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`, m = !!(o.target && o.target.shadowRoot);
  if (i.noSwiping && (m ? fl(h, d) : d.closest(h))) {
    t.allowClick = !0;
    return;
  }
  if (i.swipeHandler && !d.closest(i.swipeHandler))
    return;
  l.currentX = o.pageX, l.currentY = o.pageY;
  const v = l.currentX, g = l.currentY, y = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection, x = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
  if (y && (v <= x || v >= s.innerWidth - x))
    if (y === "prevent")
      e.preventDefault();
    else
      return;
  Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), l.startX = v, l.startY = g, r.touchStartTime = ft(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, i.threshold > 0 && (r.allowThresholdMove = !1);
  let b = !0;
  d.matches(r.focusableElements) && (b = !1, d.nodeName === "SELECT" && (r.isTouched = !1)), n.activeElement && n.activeElement.matches(r.focusableElements) && n.activeElement !== d && n.activeElement.blur();
  const j = b && t.allowTouchMove && i.touchStartPreventDefault;
  (i.touchStartForcePreventDefault || j) && !d.isContentEditable && o.preventDefault(), i.freeMode && i.freeMode.enabled && t.freeMode && t.animating && !i.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", o);
}
function ml(e) {
  const t = Me(), n = this, s = n.touchEventsData, {
    params: r,
    touches: i,
    rtlTranslate: l,
    enabled: c
  } = n;
  if (!c || !r.simulateTouch && e.pointerType === "mouse")
    return;
  let o = e;
  if (o.originalEvent && (o = o.originalEvent), !s.isTouched) {
    s.startMoving && s.isScrolling && n.emit("touchMoveOpposite", o);
    return;
  }
  const d = s.evCache.findIndex((M) => M.pointerId === o.pointerId);
  d >= 0 && (s.evCache[d] = o);
  const u = s.evCache.length > 1 ? s.evCache[0] : o, f = u.pageX, h = u.pageY;
  if (o.preventedByNestedSwiper) {
    i.startX = f, i.startY = h;
    return;
  }
  if (!n.allowTouchMove) {
    o.target.matches(s.focusableElements) || (n.allowClick = !1), s.isTouched && (Object.assign(i, {
      startX: f,
      startY: h,
      prevX: n.touches.currentX,
      prevY: n.touches.currentY,
      currentX: f,
      currentY: h
    }), s.touchStartTime = ft());
    return;
  }
  if (r.touchReleaseOnEdges && !r.loop) {
    if (n.isVertical()) {
      if (h < i.startY && n.translate <= n.maxTranslate() || h > i.startY && n.translate >= n.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else if (f < i.startX && n.translate <= n.maxTranslate() || f > i.startX && n.translate >= n.minTranslate())
      return;
  }
  if (t.activeElement && o.target === t.activeElement && o.target.matches(s.focusableElements)) {
    s.isMoved = !0, n.allowClick = !1;
    return;
  }
  if (s.allowTouchCallbacks && n.emit("touchMove", o), o.targetTouches && o.targetTouches.length > 1)
    return;
  i.currentX = f, i.currentY = h;
  const m = i.currentX - i.startX, v = i.currentY - i.startY;
  if (n.params.threshold && Math.sqrt(m ** 2 + v ** 2) < n.params.threshold)
    return;
  if (typeof s.isScrolling > "u") {
    let M;
    n.isHorizontal() && i.currentY === i.startY || n.isVertical() && i.currentX === i.startX ? s.isScrolling = !1 : m * m + v * v >= 25 && (M = Math.atan2(Math.abs(v), Math.abs(m)) * 180 / Math.PI, s.isScrolling = n.isHorizontal() ? M > r.touchAngle : 90 - M > r.touchAngle);
  }
  if (s.isScrolling && n.emit("touchMoveOpposite", o), typeof s.startMoving > "u" && (i.currentX !== i.startX || i.currentY !== i.startY) && (s.startMoving = !0), s.isScrolling || n.zoom && n.params.zoom && n.params.zoom.enabled && s.evCache.length > 1) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  n.allowClick = !1, !r.cssMode && o.cancelable && o.preventDefault(), r.touchMoveStopPropagation && !r.nested && o.stopPropagation();
  let g = n.isHorizontal() ? m : v, y = n.isHorizontal() ? i.currentX - i.previousX : i.currentY - i.previousY;
  r.oneWayMovement && (g = Math.abs(g) * (l ? 1 : -1), y = Math.abs(y) * (l ? 1 : -1)), i.diff = g, g *= r.touchRatio, l && (g = -g, y = -y);
  const x = n.touchesDirection;
  n.swipeDirection = g > 0 ? "prev" : "next", n.touchesDirection = y > 0 ? "prev" : "next";
  const b = n.params.loop && !r.cssMode;
  if (!s.isMoved) {
    if (b && n.loopFix({
      direction: n.swipeDirection
    }), s.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const M = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      n.wrapperEl.dispatchEvent(M);
    }
    s.allowMomentumBounce = !1, r.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", o);
  }
  let j;
  s.isMoved && x !== n.touchesDirection && b && Math.abs(g) >= 1 && (n.loopFix({
    direction: n.swipeDirection,
    setTranslate: !0
  }), j = !0), n.emit("sliderMove", o), s.isMoved = !0, s.currentTranslate = g + s.startTranslate;
  let C = !0, N = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (N = 0), g > 0 ? (b && !j && s.currentTranslate > (r.centeredSlides ? n.minTranslate() - n.size / 2 : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > n.minTranslate() && (C = !1, r.resistance && (s.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + s.startTranslate + g) ** N))) : g < 0 && (b && !j && s.currentTranslate < (r.centeredSlides ? n.maxTranslate() + n.size / 2 : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (r.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
  }), s.currentTranslate < n.maxTranslate() && (C = !1, r.resistance && (s.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - s.startTranslate - g) ** N))), C && (o.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (s.currentTranslate = s.startTranslate), r.threshold > 0)
    if (Math.abs(g) > r.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, i.startX = i.currentX, i.startY = i.currentY, s.currentTranslate = s.startTranslate, i.diff = n.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && n.freeMode || r.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(s.currentTranslate), n.setTranslate(s.currentTranslate));
}
function hl(e) {
  const t = this, n = t.touchEventsData, s = n.evCache.findIndex((j) => j.pointerId === e.pointerId);
  if (s >= 0 && n.evCache.splice(s, 1), ["pointercancel", "pointerout", "pointerleave"].includes(e.type) && !(e.type === "pointercancel" && (t.browser.isSafari || t.browser.isWebView)))
    return;
  const {
    params: r,
    touches: i,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: o
  } = t;
  if (!o || !r.simulateTouch && e.pointerType === "mouse")
    return;
  let d = e;
  if (d.originalEvent && (d = d.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", d), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && r.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  r.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const u = ft(), f = u - n.touchStartTime;
  if (t.allowClick) {
    const j = d.path || d.composedPath && d.composedPath();
    t.updateClickedSlide(j && j[0] || d.target), t.emit("tap click", d), f < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", d);
  }
  if (n.lastClickTime = ft(), Wt(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || i.diff === 0 || n.currentTranslate === n.startTranslate) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let h;
  if (r.followFinger ? h = l ? t.translate : -t.translate : h = -n.currentTranslate, r.cssMode)
    return;
  if (r.freeMode && r.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: h
    });
    return;
  }
  let m = 0, v = t.slidesSizesGrid[0];
  for (let j = 0; j < c.length; j += j < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
    const C = j < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
    typeof c[j + C] < "u" ? h >= c[j] && h < c[j + C] && (m = j, v = c[j + C] - c[j]) : h >= c[j] && (m = j, v = c[c.length - 1] - c[c.length - 2]);
  }
  let g = null, y = null;
  r.rewind && (t.isBeginning ? y = r.virtual && r.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (g = 0));
  const x = (h - c[m]) / v, b = m < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
  if (f > r.longSwipesMs) {
    if (!r.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (x >= r.longSwipesRatio ? t.slideTo(r.rewind && t.isEnd ? g : m + b) : t.slideTo(m)), t.swipeDirection === "prev" && (x > 1 - r.longSwipesRatio ? t.slideTo(m + b) : y !== null && x < 0 && Math.abs(x) > r.longSwipesRatio ? t.slideTo(y) : t.slideTo(m));
  } else {
    if (!r.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl) ? d.target === t.navigation.nextEl ? t.slideTo(m + b) : t.slideTo(m) : (t.swipeDirection === "next" && t.slideTo(g !== null ? g : m + b), t.swipeDirection === "prev" && t.slideTo(y !== null ? y : m));
  }
}
function An() {
  const e = this, {
    params: t,
    el: n
  } = e;
  if (n && n.offsetWidth === 0)
    return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: r,
    snapGrid: i
  } = e, l = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const c = l && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !c ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !l ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = r, e.allowSlideNext = s, e.params.watchOverflow && i !== e.snapGrid && e.checkOverflow();
}
function xl(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function gl() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: n,
    enabled: s
  } = e;
  if (!s)
    return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let r;
  const i = e.maxTranslate() - e.minTranslate();
  i === 0 ? r = 0 : r = (e.translate - e.minTranslate()) / i, r !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function vl(e) {
  const t = this;
  lt(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
let $n = !1;
function wl() {
}
const bs = (e, t) => {
  const n = Me(), {
    params: s,
    el: r,
    wrapperEl: i,
    device: l
  } = e, c = !!s.nested, o = t === "on" ? "addEventListener" : "removeEventListener", d = t;
  r[o]("pointerdown", e.onTouchStart, {
    passive: !1
  }), n[o]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: c
  }), n[o]("pointerup", e.onTouchEnd, {
    passive: !0
  }), n[o]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), n[o]("pointerout", e.onTouchEnd, {
    passive: !0
  }), n[o]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && r[o]("click", e.onClick, !0), s.cssMode && i[o]("scroll", e.onScroll), s.updateOnWindowResize ? e[d](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", An, !0) : e[d]("observerUpdate", An, !0), r[o]("load", e.onLoad, {
    capture: !0
  });
};
function bl() {
  const e = this, t = Me(), {
    params: n
  } = e;
  e.onTouchStart = pl.bind(e), e.onTouchMove = ml.bind(e), e.onTouchEnd = hl.bind(e), n.cssMode && (e.onScroll = gl.bind(e)), e.onClick = xl.bind(e), e.onLoad = vl.bind(e), $n || (t.addEventListener("touchstart", wl), $n = !0), bs(e, "on");
}
function yl() {
  bs(this, "off");
}
var jl = {
  attachEvents: bl,
  detachEvents: yl
};
const Rn = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function Sl() {
  const e = this, {
    realIndex: t,
    initialized: n,
    params: s,
    el: r
  } = e, i = s.breakpoints;
  if (!i || i && Object.keys(i).length === 0)
    return;
  const l = e.getBreakpoint(i, e.params.breakpointsBase, e.el);
  if (!l || e.currentBreakpoint === l)
    return;
  const o = (l in i ? i[l] : void 0) || e.originalParams, d = Rn(e, s), u = Rn(e, o), f = s.enabled;
  d && !u ? (r.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), e.emitContainerClasses()) : !d && u && (r.classList.add(`${s.containerModifierClass}grid`), (o.grid.fill && o.grid.fill === "column" || !o.grid.fill && s.grid.fill === "column") && r.classList.add(`${s.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((g) => {
    if (typeof o[g] > "u")
      return;
    const y = s[g] && s[g].enabled, x = o[g] && o[g].enabled;
    y && !x && e[g].disable(), !y && x && e[g].enable();
  });
  const h = o.direction && o.direction !== s.direction, m = s.loop && (o.slidesPerView !== s.slidesPerView || h);
  h && n && e.changeDirection(), ee(e.params, o);
  const v = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), f && !v ? e.disable() : !f && v && e.enable(), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", o), m && n && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()), e.emit("breakpoint", o);
}
function Cl(e, t, n) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !n)
    return;
  let s = !1;
  const r = se(), i = t === "window" ? r.innerHeight : n.clientHeight, l = Object.keys(e).map((c) => {
    if (typeof c == "string" && c.indexOf("@") === 0) {
      const o = parseFloat(c.substr(1));
      return {
        value: i * o,
        point: c
      };
    }
    return {
      value: c,
      point: c
    };
  });
  l.sort((c, o) => parseInt(c.value, 10) - parseInt(o.value, 10));
  for (let c = 0; c < l.length; c += 1) {
    const {
      point: o,
      value: d
    } = l[c];
    t === "window" ? r.matchMedia(`(min-width: ${d}px)`).matches && (s = o) : d <= n.clientWidth && (s = o);
  }
  return s || "max";
}
var Tl = {
  setBreakpoint: Sl,
  getBreakpoint: Cl
};
function El(e, t) {
  const n = [];
  return e.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((r) => {
      s[r] && n.push(t + r);
    }) : typeof s == "string" && n.push(t + s);
  }), n;
}
function Nl() {
  const e = this, {
    classNames: t,
    params: n,
    rtl: s,
    el: r,
    device: i
  } = e, l = El(["initialized", n.direction, {
    "free-mode": e.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: s
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: i.android
  }, {
    ios: i.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  t.push(...l), r.classList.add(...t), e.emitContainerClasses();
}
function Pl() {
  const e = this, {
    el: t,
    classNames: n
  } = e;
  t.classList.remove(...n), e.emitContainerClasses();
}
var _l = {
  addClasses: Nl,
  removeClasses: Pl
};
function kl() {
  const e = this, {
    isLocked: t,
    params: n
  } = e, {
    slidesOffsetBefore: s
  } = n;
  if (s) {
    const r = e.slides.length - 1, i = e.slidesGrid[r] + e.slidesSizesGrid[r] + s * 2;
    e.isLocked = e.size > i;
  } else
    e.isLocked = e.snapGrid.length === 1;
  n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var Ml = {
  checkOverflow: kl
}, qt = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopedSlides: null,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Ol(e, t) {
  return function(s) {
    s === void 0 && (s = {});
    const r = Object.keys(s)[0], i = s[r];
    if (typeof i != "object" || i === null) {
      ee(t, s);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 && e[r] === !0 && (e[r] = {
      auto: !0
    }), !(r in e && "enabled" in i)) {
      ee(t, s);
      return;
    }
    e[r] === !0 && (e[r] = {
      enabled: !0
    }), typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0), e[r] || (e[r] = {
      enabled: !1
    }), ee(t, s);
  };
}
const $t = {
  eventsEmitter: _o,
  update: zo,
  translate: Wo,
  transition: Ko,
  slide: rl,
  loop: ll,
  grabCursor: ul,
  events: jl,
  breakpoints: Tl,
  checkOverflow: Ml,
  classes: _l
}, Rt = {};
let tn = class pe {
  constructor() {
    let t, n;
    for (var s = arguments.length, r = new Array(s), i = 0; i < s; i++)
      r[i] = arguments[i];
    r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? n = r[0] : [t, n] = r, n || (n = {}), n = ee({}, n), t && !n.el && (n.el = t);
    const l = Me();
    if (n.el && typeof n.el == "string" && l.querySelectorAll(n.el).length > 1) {
      const u = [];
      return l.querySelectorAll(n.el).forEach((f) => {
        const h = ee({}, n, {
          el: f
        });
        u.push(new pe(h));
      }), u;
    }
    const c = this;
    c.__swiper__ = !0, c.support = vs(), c.device = Co({
      userAgent: n.userAgent
    }), c.browser = Eo(), c.eventsListeners = {}, c.eventsAnyListeners = [], c.modules = [...c.__modules__], n.modules && Array.isArray(n.modules) && c.modules.push(...n.modules);
    const o = {};
    c.modules.forEach((u) => {
      u({
        params: n,
        swiper: c,
        extendParams: Ol(n, o),
        on: c.on.bind(c),
        once: c.once.bind(c),
        off: c.off.bind(c),
        emit: c.emit.bind(c)
      });
    });
    const d = ee({}, qt, o);
    return c.params = ee({}, d, Rt, n), c.originalParams = ee({}, c.params), c.passedParams = ee({}, n), c.params && c.params.on && Object.keys(c.params.on).forEach((u) => {
      c.on(u, c.params.on[u]);
    }), c.params && c.params.onAny && c.onAny(c.params.onAny), Object.assign(c, {
      enabled: c.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return c.params.direction === "horizontal";
      },
      isVertical() {
        return c.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: c.params.allowSlideNext,
      allowSlidePrev: c.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: c.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: c.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), c.emit("_swiper"), c.params.init && c.init(), c;
  }
  getSlideIndex(t) {
    const {
      slidesEl: n,
      params: s
    } = this, r = xe(n, `.${s.slideClass}, swiper-slide`), i = In(r[0]);
    return In(t) - i;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.filter((n) => n.getAttribute("data-swiper-slide-index") * 1 === t)[0]);
  }
  recalcSlides() {
    const t = this, {
      slidesEl: n,
      params: s
    } = t;
    t.slides = xe(n, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, n) {
    const s = this;
    t = Math.min(Math.max(t, 0), 1);
    const r = s.minTranslate(), l = (s.maxTranslate() - r) * t + r;
    s.translateTo(l, typeof n > "u" ? 0 : n), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const n = t.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(t) {
    const n = this;
    return n.destroyed ? "" : t.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const n = [];
    t.slides.forEach((s) => {
      const r = t.getSlideClasses(s);
      n.push({
        slideEl: s,
        classNames: r
      }), t.emit("_slideClass", s, r);
    }), t.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(t, n) {
    t === void 0 && (t = "current"), n === void 0 && (n = !1);
    const s = this, {
      params: r,
      slides: i,
      slidesGrid: l,
      slidesSizesGrid: c,
      size: o,
      activeIndex: d
    } = s;
    let u = 1;
    if (r.centeredSlides) {
      let f = i[d] ? i[d].swiperSlideSize : 0, h;
      for (let m = d + 1; m < i.length; m += 1)
        i[m] && !h && (f += i[m].swiperSlideSize, u += 1, f > o && (h = !0));
      for (let m = d - 1; m >= 0; m -= 1)
        i[m] && !h && (f += i[m].swiperSlideSize, u += 1, f > o && (h = !0));
    } else if (t === "current")
      for (let f = d + 1; f < i.length; f += 1)
        (n ? l[f] + c[f] - l[d] < o : l[f] - l[d] < o) && (u += 1);
    else
      for (let f = d - 1; f >= 0; f -= 1)
        l[d] - l[f] < o && (u += 1);
    return u;
  }
  update() {
    const t = this;
    if (!t || t.destroyed)
      return;
    const {
      snapGrid: n,
      params: s
    } = t;
    s.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
      l.complete && lt(t, l);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function r() {
      const l = t.rtlTranslate ? t.translate * -1 : t.translate, c = Math.min(Math.max(l, t.maxTranslate()), t.minTranslate());
      t.setTranslate(c), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let i;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      r(), s.autoHeight && t.updateAutoHeight();
    else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && t.isEnd && !s.centeredSlides) {
        const l = t.virtual && s.virtual.enabled ? t.virtual.slides : t.slides;
        i = t.slideTo(l.length - 1, 0, !1, !0);
      } else
        i = t.slideTo(t.activeIndex, 0, !1, !0);
      i || r();
    }
    s.watchOverflow && n !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, n) {
    n === void 0 && (n = !0);
    const s = this, r = s.params.direction;
    return t || (t = r === "horizontal" ? "vertical" : "horizontal"), t === r || t !== "horizontal" && t !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${r}`), s.el.classList.add(`${s.params.containerModifierClass}${t}`), s.emitContainerClasses(), s.params.direction = t, s.slides.forEach((i) => {
      t === "vertical" ? i.style.width = "" : i.style.height = "";
    }), s.emit("changeDirection"), n && s.update()), s;
  }
  changeLanguageDirection(t) {
    const n = this;
    n.rtl && t === "rtl" || !n.rtl && t === "ltr" || (n.rtl = t === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(t) {
    const n = this;
    if (n.mounted)
      return !0;
    let s = t || n.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s)
      return !1;
    s.swiper = n, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === "SWIPER-CONTAINER" && (n.isElement = !0);
    const r = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let l = (() => s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(r()) : xe(s, r())[0])();
    return !l && n.params.createElements && (l = vo("div", n.params.wrapperClass), s.append(l), xe(s, `.${n.params.slideClass}`).forEach((c) => {
      l.append(c);
    })), Object.assign(n, {
      el: s,
      wrapperEl: l,
      slidesEl: n.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : l,
      hostEl: n.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || we(s, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || we(s, "direction") === "rtl"),
      wrongRTL: we(l, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const n = this;
    return n.initialized || n.mount(t) === !1 || (n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(), n.attachEvents(), [...n.el.querySelectorAll('[loading="lazy"]')].forEach((r) => {
      r.complete ? lt(n, r) : r.addEventListener("load", (i) => {
        lt(n, i.target);
      });
    }), Yt(n), n.initialized = !0, Yt(n), n.emit("init"), n.emit("afterInit")), n;
  }
  destroy(t, n) {
    t === void 0 && (t = !0), n === void 0 && (n = !0);
    const s = this, {
      params: r,
      el: i,
      wrapperEl: l,
      slides: c
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), r.loop && s.loopDestroy(), n && (s.removeClasses(), i.removeAttribute("style"), l.removeAttribute("style"), c && c.length && c.forEach((o) => {
      o.classList.remove(r.slideVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), o.removeAttribute("style"), o.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((o) => {
      s.off(o);
    }), t !== !1 && (s.el.swiper = null, mo(s)), s.destroyed = !0), null;
  }
  static extendDefaults(t) {
    ee(Rt, t);
  }
  static get extendedDefaults() {
    return Rt;
  }
  static get defaults() {
    return qt;
  }
  static installModule(t) {
    pe.prototype.__modules__ || (pe.prototype.__modules__ = []);
    const n = pe.prototype.__modules__;
    typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((n) => pe.installModule(n)), pe) : (pe.installModule(t), pe);
  }
};
Object.keys($t).forEach((e) => {
  Object.keys($t[e]).forEach((t) => {
    tn.prototype[t] = $t[e][t];
  });
});
tn.use([No, Po]);
const ys = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function _e(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function Ee(e, t) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((s) => n.indexOf(s) < 0).forEach((s) => {
    typeof e[s] > "u" ? e[s] = t[s] : _e(t[s]) && _e(e[s]) && Object.keys(t[s]).length > 0 ? t[s].__swiper__ ? e[s] = t[s] : Ee(e[s], t[s]) : e[s] = t[s];
  });
}
function js(e) {
  return e === void 0 && (e = {}), e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function Ss(e) {
  return e === void 0 && (e = {}), e.pagination && typeof e.pagination.el > "u";
}
function Cs(e) {
  return e === void 0 && (e = {}), e.scrollbar && typeof e.scrollbar.el > "u";
}
function Ts(e) {
  e === void 0 && (e = "");
  const t = e.split(" ").map((s) => s.trim()).filter((s) => !!s), n = [];
  return t.forEach((s) => {
    n.indexOf(s) < 0 && n.push(s);
  }), n.join(" ");
}
function Il(e) {
  return e === void 0 && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function Ll(e) {
  let {
    swiper: t,
    slides: n,
    passedParams: s,
    changedParams: r,
    nextEl: i,
    prevEl: l,
    scrollbarEl: c,
    paginationEl: o
  } = e;
  const d = r.filter((S) => S !== "children" && S !== "direction" && S !== "wrapperClass"), {
    params: u,
    pagination: f,
    navigation: h,
    scrollbar: m,
    virtual: v,
    thumbs: g
  } = t;
  let y, x, b, j, C, N, M, _;
  r.includes("thumbs") && s.thumbs && s.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (y = !0), r.includes("controller") && s.controller && s.controller.control && u.controller && !u.controller.control && (x = !0), r.includes("pagination") && s.pagination && (s.pagination.el || o) && (u.pagination || u.pagination === !1) && f && !f.el && (b = !0), r.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || c) && (u.scrollbar || u.scrollbar === !1) && m && !m.el && (j = !0), r.includes("navigation") && s.navigation && (s.navigation.prevEl || l) && (s.navigation.nextEl || i) && (u.navigation || u.navigation === !1) && h && !h.prevEl && !h.nextEl && (C = !0);
  const L = (S) => {
    t[S] && (t[S].destroy(), S === "navigation" ? (t.isElement && (t[S].prevEl.remove(), t[S].nextEl.remove()), u[S].prevEl = void 0, u[S].nextEl = void 0, t[S].prevEl = void 0, t[S].nextEl = void 0) : (t.isElement && t[S].el.remove(), u[S].el = void 0, t[S].el = void 0));
  };
  r.includes("loop") && t.isElement && (u.loop && !s.loop ? N = !0 : !u.loop && s.loop ? M = !0 : _ = !0), d.forEach((S) => {
    if (_e(u[S]) && _e(s[S]))
      Ee(u[S], s[S]), (S === "navigation" || S === "pagination" || S === "scrollbar") && "enabled" in s[S] && !s[S].enabled && L(S);
    else {
      const B = s[S];
      (B === !0 || B === !1) && (S === "navigation" || S === "pagination" || S === "scrollbar") ? B === !1 && L(S) : u[S] = s[S];
    }
  }), d.includes("controller") && !x && t.controller && t.controller.control && u.controller && u.controller.control && (t.controller.control = u.controller.control), r.includes("children") && n && v && u.virtual.enabled && (v.slides = n, v.update(!0)), r.includes("children") && n && u.loop && (_ = !0), y && g.init() && g.update(!0), x && (t.controller.control = u.controller.control), b && (t.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-pagination"), t.el.appendChild(o)), o && (u.pagination.el = o), f.init(), f.render(), f.update()), j && (t.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-scrollbar"), t.el.appendChild(c)), c && (u.scrollbar.el = c), m.init(), m.updateSize(), m.setTranslate()), C && (t.isElement && ((!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-next"), i.innerHTML = t.hostEl.nextButtonSvg, t.el.appendChild(i)), (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-button-prev"), i.innerHTML = t.hostEl.prevButtonSvg, t.el.appendChild(l))), i && (u.navigation.nextEl = i), l && (u.navigation.prevEl = l), h.init(), h.update()), r.includes("allowSlideNext") && (t.allowSlideNext = s.allowSlideNext), r.includes("allowSlidePrev") && (t.allowSlidePrev = s.allowSlidePrev), r.includes("direction") && t.changeDirection(s.direction, !1), (N || _) && t.loopDestroy(), (M || _) && t.loopCreate(), t.update();
}
function Al(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = !0);
  const n = {
    on: {}
  }, s = {}, r = {};
  Ee(n, qt), n._emitClasses = !0, n.init = !1;
  const i = {}, l = ys.map((o) => o.replace(/_/, "")), c = Object.assign({}, e);
  return Object.keys(c).forEach((o) => {
    typeof e[o] > "u" || (l.indexOf(o) >= 0 ? _e(e[o]) ? (n[o] = {}, r[o] = {}, Ee(n[o], e[o]), Ee(r[o], e[o])) : (n[o] = e[o], r[o] = e[o]) : o.search(/on[A-Z]/) === 0 && typeof e[o] == "function" ? t ? s[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : n.on[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : i[o] = e[o]);
  }), ["navigation", "pagination", "scrollbar"].forEach((o) => {
    n[o] === !0 && (n[o] = {}), n[o] === !1 && delete n[o];
  }), {
    params: n,
    passedParams: r,
    rest: i,
    events: s
  };
}
function $l(e, t) {
  let {
    el: n,
    nextEl: s,
    prevEl: r,
    paginationEl: i,
    scrollbarEl: l,
    swiper: c
  } = e;
  js(t) && s && r && (c.params.navigation.nextEl = s, c.originalParams.navigation.nextEl = s, c.params.navigation.prevEl = r, c.originalParams.navigation.prevEl = r), Ss(t) && i && (c.params.pagination.el = i, c.originalParams.pagination.el = i), Cs(t) && l && (c.params.scrollbar.el = l, c.originalParams.scrollbar.el = l), c.init(n);
}
function Rl(e, t, n, s, r) {
  const i = [];
  if (!t)
    return i;
  const l = (o) => {
    i.indexOf(o) < 0 && i.push(o);
  };
  if (n && s) {
    const o = s.map(r), d = n.map(r);
    o.join("") !== d.join("") && l("children"), s.length !== n.length && l("children");
  }
  return ys.filter((o) => o[0] === "_").map((o) => o.replace(/_/, "")).forEach((o) => {
    if (o in e && o in t)
      if (_e(e[o]) && _e(t[o])) {
        const d = Object.keys(e[o]), u = Object.keys(t[o]);
        d.length !== u.length ? l(o) : (d.forEach((f) => {
          e[o][f] !== t[o][f] && l(o);
        }), u.forEach((f) => {
          e[o][f] !== t[o][f] && l(o);
        }));
      } else
        e[o] !== t[o] && l(o);
  }), i;
}
const Dl = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};
function pt() {
  return pt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, pt.apply(this, arguments);
}
function Es(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function Ns(e) {
  const t = [];
  return V.Children.toArray(e).forEach((n) => {
    Es(n) ? t.push(n) : n.props && n.props.children && Ns(n.props.children).forEach((s) => t.push(s));
  }), t;
}
function Bl(e) {
  const t = [], n = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return V.Children.toArray(e).forEach((s) => {
    if (Es(s))
      t.push(s);
    else if (s.props && s.props.slot && n[s.props.slot])
      n[s.props.slot].push(s);
    else if (s.props && s.props.children) {
      const r = Ns(s.props.children);
      r.length > 0 ? r.forEach((i) => t.push(i)) : n["container-end"].push(s);
    } else
      n["container-end"].push(s);
  }), {
    slides: t,
    slots: n
  };
}
function zl(e, t, n) {
  if (!n)
    return null;
  const s = (u) => {
    let f = u;
    return u < 0 ? f = t.length + u : f >= t.length && (f = f - t.length), f;
  }, r = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${n.offset}px`
  } : {
    top: `${n.offset}px`
  }, {
    from: i,
    to: l
  } = n, c = e.params.loop ? -t.length : 0, o = e.params.loop ? t.length * 2 : t.length, d = [];
  for (let u = c; u < o; u += 1)
    u >= i && u <= l && d.push(t[s(u)]);
  return d.map((u, f) => /* @__PURE__ */ V.cloneElement(u, {
    swiper: e,
    style: r,
    key: `slide-${f}`
  }));
}
function We(e, t) {
  return typeof window > "u" ? W(e, t) : Fn(e, t);
}
const Dn = /* @__PURE__ */ mt(null), Fl = /* @__PURE__ */ mt(null), Ps = /* @__PURE__ */ ye(function(e, t) {
  let {
    className: n,
    tag: s = "div",
    wrapperTag: r = "div",
    children: i,
    onSwiper: l,
    ...c
  } = e === void 0 ? {} : e, o = !1;
  const [d, u] = D("swiper"), [f, h] = D(null), [m, v] = D(!1), g = Q(!1), y = Q(null), x = Q(null), b = Q(null), j = Q(null), C = Q(null), N = Q(null), M = Q(null), _ = Q(null), {
    params: L,
    passedParams: S,
    rest: B,
    events: E
  } = Al(c), {
    slides: k,
    slots: I
  } = Bl(i), H = () => {
    v(!m);
  };
  Object.assign(L.on, {
    _containerClasses(Y, Z) {
      u(Z);
    }
  });
  const re = () => {
    Object.assign(L.on, E), o = !0;
    const Y = {
      ...L
    };
    if (delete Y.wrapperClass, x.current = new tn(Y), x.current.virtual && x.current.params.virtual.enabled) {
      x.current.virtual.slides = k;
      const Z = {
        cache: !1,
        slides: k,
        renderExternal: h,
        renderExternalUpdate: !1
      };
      Ee(x.current.params.virtual, Z), Ee(x.current.originalParams.virtual, Z);
    }
  };
  y.current || re(), x.current && x.current.on("_beforeBreakpoint", H);
  const Ce = () => {
    o || !E || !x.current || Object.keys(E).forEach((Y) => {
      x.current.on(Y, E[Y]);
    });
  }, Oe = () => {
    !E || !x.current || Object.keys(E).forEach((Y) => {
      x.current.off(Y, E[Y]);
    });
  };
  W(() => () => {
    x.current && x.current.off("_beforeBreakpoint", H);
  }), W(() => {
    !g.current && x.current && (x.current.emitSlidesClasses(), g.current = !0);
  }), We(() => {
    if (t && (t.current = y.current), !!y.current)
      return x.current.destroyed && re(), $l({
        el: y.current,
        nextEl: C.current,
        prevEl: N.current,
        paginationEl: M.current,
        scrollbarEl: _.current,
        swiper: x.current
      }, L), l && l(x.current), () => {
        x.current && !x.current.destroyed && x.current.destroy(!0, !1);
      };
  }, []), We(() => {
    Ce();
    const Y = Rl(S, b.current, k, j.current, (Z) => Z.key);
    return b.current = S, j.current = k, Y.length && x.current && !x.current.destroyed && Ll({
      swiper: x.current,
      slides: k,
      passedParams: S,
      changedParams: Y,
      nextEl: C.current,
      prevEl: N.current,
      scrollbarEl: _.current,
      paginationEl: M.current
    }), () => {
      Oe();
    };
  }), We(() => {
    Dl(x.current);
  }, [f]);
  function Ie() {
    return L.virtual ? zl(x.current, k, f) : k.map((Y, Z) => /* @__PURE__ */ V.cloneElement(Y, {
      swiper: x.current,
      swiperSlideIndex: Z
    }));
  }
  return /* @__PURE__ */ V.createElement(s, pt({
    ref: y,
    className: Ts(`${d}${n ? ` ${n}` : ""}`)
  }, B), /* @__PURE__ */ V.createElement(Fl.Provider, {
    value: x.current
  }, I["container-start"], /* @__PURE__ */ V.createElement(r, {
    className: Il(L.wrapperClass)
  }, I["wrapper-start"], Ie(), I["wrapper-end"]), js(L) && /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement("div", {
    ref: N,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ V.createElement("div", {
    ref: C,
    className: "swiper-button-next"
  })), Cs(L) && /* @__PURE__ */ V.createElement("div", {
    ref: _,
    className: "swiper-scrollbar"
  }), Ss(L) && /* @__PURE__ */ V.createElement("div", {
    ref: M,
    className: "swiper-pagination"
  }), I["container-end"]));
});
Ps.displayName = "Swiper";
const _s = /* @__PURE__ */ ye(function(e, t) {
  let {
    tag: n = "div",
    children: s,
    className: r = "",
    swiper: i,
    zoom: l,
    lazy: c,
    virtualIndex: o,
    swiperSlideIndex: d,
    ...u
  } = e === void 0 ? {} : e;
  const f = Q(null), [h, m] = D("swiper-slide"), [v, g] = D(!1);
  function y(C, N, M) {
    N === f.current && m(M);
  }
  We(() => {
    if (typeof d < "u" && (f.current.swiperSlideIndex = d), t && (t.current = f.current), !(!f.current || !i)) {
      if (i.destroyed) {
        h !== "swiper-slide" && m("swiper-slide");
        return;
      }
      return i.on("_slideClass", y), () => {
        i && i.off("_slideClass", y);
      };
    }
  }), We(() => {
    i && f.current && !i.destroyed && m(i.getSlideClasses(f.current));
  }, [i]);
  const x = {
    isActive: h.indexOf("swiper-slide-active") >= 0,
    isVisible: h.indexOf("swiper-slide-visible") >= 0,
    isPrev: h.indexOf("swiper-slide-prev") >= 0,
    isNext: h.indexOf("swiper-slide-next") >= 0
  }, b = () => typeof s == "function" ? s(x) : s, j = () => {
    g(!0);
  };
  return /* @__PURE__ */ V.createElement(n, pt({
    ref: f,
    className: Ts(`${h}${r ? ` ${r}` : ""}`),
    "data-swiper-slide-index": o,
    onLoad: j
  }, u), l && /* @__PURE__ */ V.createElement(Dn.Provider, {
    value: x
  }, /* @__PURE__ */ V.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof l == "number" ? l : void 0
  }, b(), c && !v && /* @__PURE__ */ V.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !l && /* @__PURE__ */ V.createElement(Dn.Provider, {
    value: x
  }, b(), c && !v && /* @__PURE__ */ V.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
_s.displayName = "SwiperSlide";
const Hl = ({ featureShows: e, featureShowTitle: t, featureShowIcon: n }) => /* @__PURE__ */ a.jsxs("div", { className: "mt-8", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "mb-4 flex items-center", children: [
    n && /* @__PURE__ */ a.jsx(
      "img",
      {
        src: n.src,
        alt: n.alt,
        loading: "lazy",
        className: "mr-2",
        height: 32,
        width: 32
      }
    ),
    /* @__PURE__ */ a.jsx("h3", { className: "text-lg font-bold", children: t })
  ] }),
  /* @__PURE__ */ a.jsx(
    Ps,
    {
      spaceBetween: 8,
      slidesPerView: 2.1,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 16
        }
      },
      className: "mb-0 overflow-visible",
      children: e.map(({ image: s, title: r, description: i }) => /* @__PURE__ */ a.jsxs(_s, { children: [
        /* @__PURE__ */ a.jsx("div", { className: "relative block w-full overflow-hidden rounded-sm pb-[56.25%]", children: /* @__PURE__ */ a.jsx("img", { className: "absolute left-0 top-0 h-full w-full object-cover", src: s.src, alt: s.alt }) }),
        /* @__PURE__ */ a.jsx("p", { className: "mt-2 line-clamp-1 font-bold", children: r }),
        /* @__PURE__ */ a.jsx("p", { className: "mt-1 line-clamp-1 text-sm text-neutral-800 md:text-base", children: i })
      ] }, r))
    }
  )
] }), ks = Hl, Vl = ({
  featuresConfig: e,
  channelsConfig: t,
  appsConfig: n,
  channelAccordionText: s,
  appAccordionText: r
}) => {
  const [i, l] = ne(), [c, o] = ne(), { channelCollapsedText: d, channelExpandedText: u } = s, { appCollapsedText: f, appExpandedText: h } = r;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ks, { ...e }),
    n.secondaryBundledContent.length > 0 && /* @__PURE__ */ a.jsx(
      Mn,
      {
        contentTitle: n.title,
        content: n.secondaryBundledContent,
        isExpanded: i,
        onExpandButtonClick: l.toggle,
        expandedText: h,
        collapsedText: f,
        contentType: "app"
      }
    ),
    t.secondaryBundledContent.length > 0 && /* @__PURE__ */ a.jsx(
      Mn,
      {
        contentTitle: t.title,
        content: t.secondaryBundledContent,
        isExpanded: c,
        onExpandButtonClick: o.toggle,
        expandedText: u,
        collapsedText: d,
        contentType: "channel"
      }
    )
  ] });
}, Gl = Vl, Ul = () => /* @__PURE__ */ a.jsxs("div", { className: "rounded bg-white p-4 shadow", children: [
  /* @__PURE__ */ a.jsxs("div", { className: "flex items-start", children: [
    /* @__PURE__ */ a.jsx($, { className: "h-12 w-12" }),
    /* @__PURE__ */ a.jsxs("div", { className: "ml-4", children: [
      /* @__PURE__ */ a.jsx("div", { className: "jusify-centerflex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-5 w-36" }) }),
      /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-48" }) })
    ] })
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "jusify-center mt-4 flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-full" }) }),
  /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex items-center py-px md:hidden", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-1/3" }) })
] }), Ms = Ul, Wl = ({
  hasIcon: e,
  showSlideDescriptionSkeleton: t
}) => /* @__PURE__ */ a.jsxs("div", { children: [
  /* @__PURE__ */ a.jsxs("div", { className: "mb-4 flex items-center", children: [
    e && /* @__PURE__ */ a.jsx($, { className: "mr-2 h-8 w-8" }),
    /* @__PURE__ */ a.jsx($, { className: "mb-1 h-5 w-44" })
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "mb-0 flex pr-2", children: [...Array(2).keys()].map((s) => /* @__PURE__ */ a.jsxs("div", { className: "relative mr-2 w-2/4 xl:w-1/3", children: [
    /* @__PURE__ */ a.jsx($, { className: "box-border w-full rounded-sm pb-[56.25%]" }),
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center mt-2 flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-36" }) }),
    t && /* @__PURE__ */ a.jsx("div", { className: "jusify-center mt-1 flex h-5 items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "h-3.5 w-20 md:h-4" }) })
  ] }, s)) })
] }), Os = Wl, Yl = () => /* @__PURE__ */ a.jsxs("div", { className: "pb-2", children: [
  /* @__PURE__ */ a.jsx(Ms, {}),
  /* @__PURE__ */ a.jsx($, { className: "mt-8 block h-[26px] w-80" }),
  [...Array(2).keys()].map((n) => /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx("div", { className: "mt-4", children: /* @__PURE__ */ a.jsx(Os, { hasIcon: !0, showSlideDescriptionSkeleton: !0 }) }),
    /* @__PURE__ */ a.jsxs("div", { className: "mt-8", children: [
      /* @__PURE__ */ a.jsx("div", { className: "jusify-center mt-2 flex h-6 items-center", children: /* @__PURE__ */ a.jsx($, { className: "h-[18px] w-52" }) }),
      /* @__PURE__ */ a.jsx("div", { className: "mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: [...Array(2).keys()].map((s) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-start", children: [
        /* @__PURE__ */ a.jsx($, { className: "h-12 w-18 flex-shrink-0 rounded-sm px-1 py-1.5" }),
        /* @__PURE__ */ a.jsxs("div", { className: "ml-2", children: [
          /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-36" }) }),
          /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex h-5 items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-3.5 w-20 md:h-4" }) })
        ] })
      ] }, s)) })
    ] }),
    /* @__PURE__ */ a.jsx("hr", { className: "my-8 -mr-4 border-neutral-300 last-of-type:hidden md:-mr-8 xl:-mr-10" })
  ] }, n))
] }), ql = Yl, Xl = () => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
  /* @__PURE__ */ a.jsx(Ms, {}),
  /* @__PURE__ */ a.jsx("div", { className: "mt-8", children: /* @__PURE__ */ a.jsx(Os, {}) }),
  /* @__PURE__ */ a.jsxs("div", { className: "mt-7 md:mt-9", children: [
    /* @__PURE__ */ a.jsx("div", { className: "jusify-center mb-2 flex h-6 items-center md:mb-4", children: /* @__PURE__ */ a.jsx($, { className: "h-[18px] w-52" }) }),
    /* @__PURE__ */ a.jsx("div", { className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: [...Array(5).keys()].map((t) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-start", children: [
      /* @__PURE__ */ a.jsx($, { className: "h-12 w-18 flex-shrink-0 rounded-sm px-1 py-1.5" }),
      /* @__PURE__ */ a.jsxs("div", { className: "ml-2", children: [
        /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-4 w-36" }) }),
        /* @__PURE__ */ a.jsx("div", { className: "jusify-center flex h-5 items-center py-px", children: /* @__PURE__ */ a.jsx($, { className: "my-0.5 h-3.5 w-20 md:h-4" }) })
      ] })
    ] }, t)) })
  ] })
] }), Kl = Xl, Zl = ({ type: e }) => /* @__PURE__ */ a.jsx(a.Fragment, { children: e === "Grouped" ? /* @__PURE__ */ a.jsx(ql, {}) : /* @__PURE__ */ a.jsx(Kl, {}) }), Is = Zl, Jl = ({ environment: e, locale: t, platform: n, exploreType: s }) => {
  const r = Oa(n, t, e, s);
  if (!r)
    return /* @__PURE__ */ a.jsx(Is, { type: "Grouped" });
  const {
    icon: i,
    packTitle: l,
    packSubtitle: c,
    description: o,
    subSections: d,
    channelAccordionText: u,
    appAccordionText: f,
    subsectionContentsTitle: h
  } = r;
  return /* @__PURE__ */ a.jsxs("div", { className: "pb-2", children: [
    /* @__PURE__ */ a.jsx(hs, { icon: i, packName: l, packSubtitle: c, description: o }),
    /* @__PURE__ */ a.jsx("span", { className: "-mb-4 mt-8 block text-xl font-extrabold", children: h }),
    d.map((m) => (
      // fragment instead of div so last-of-type's parent/wrapper would be based on the proper container
      /* @__PURE__ */ a.jsxs(V.Fragment, { children: [
        /* @__PURE__ */ a.jsx(Gl, { ...m, channelAccordionText: u, appAccordionText: f }),
        /* @__PURE__ */ a.jsx("hr", { className: "my-8 -mr-4 border-neutral-300 last-of-type:hidden md:-mr-8 xl:-mr-10" })
      ] }, m.featuresConfig.featureShowTitle)
    ))
  ] });
}, Ql = Jl, ec = ({ channelTitle: e, channels: t }) => /* @__PURE__ */ a.jsxs("div", { className: "mt-6 md:mt-8", children: [
  /* @__PURE__ */ a.jsx("h3", { className: "mb-2 text-lg md:mb-4", children: e }),
  /* @__PURE__ */ a.jsx("div", { className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: t.map(({ image: n, title: s, subtitle: r }) => /* @__PURE__ */ a.jsx(Ut, { title: s, subtitle: r, image: n, itemType: "channel" }, s)) })
] }), tc = ec, nc = ({
  platform: e,
  locale: t,
  secondaryContentId: n,
  environment: s,
  exploreType: r
}) => {
  const i = Ia(e, t, n, s, r);
  if (!i)
    return /* @__PURE__ */ a.jsx(Is, { type: "Single" });
  const { icon: l, packName: c, packSubtitle: o, description: d, channels: u, featureShows: f, channelTitle: h, featureShowTitle: m } = i;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(hs, { icon: l, packName: c, packSubtitle: o, description: d }),
    /* @__PURE__ */ a.jsx(ks, { featureShows: f, featureShowTitle: m }),
    /* @__PURE__ */ a.jsx(tc, { channelTitle: h, channels: u })
  ] });
}, sc = nc, rc = ({ ...e }) => /* @__PURE__ */ a.jsx("div", { className: "h-full flex-1 overflow-y-auto overflow-x-hidden rounded bg-neutral-50", children: /* @__PURE__ */ a.jsx("div", { className: "p-4 pb-6 md:px-8 md:pb-6 md:pt-16 lg:py-6 xl:px-10 xl:py-8", children: e.secondaryContentType === "asianFav" ? /* @__PURE__ */ a.jsx(Ql, { ...e }) : /* @__PURE__ */ a.jsx(sc, { ...e }) }) }), ic = rc, ac = ({
  layoutTextConfig: e,
  initialPackId: t,
  locale: n,
  platform: s,
  popupType: r,
  environment: i,
  categoryId: l,
  onCloseButtonClick: c,
  onCtaButtonClick: o,
  gaEventsConfig: d,
  viewOnly: u
}) => {
  const f = Kn(), [h, m] = D(t), [v, g] = ne(), y = La(s, n, r, i, l), [x, b] = D(""), [j, C] = D("app"), N = le("lg"), M = Aa(h, s, n, i, r, f), _ = (S, B) => {
    d && h !== S && Ne({
      event: "view_item",
      content_type: ut,
      content_list_type: d.contentListType,
      content_title: B,
      content_list: "Side panel",
      item_name: e.ctaButtonText
    }), g.off(), m(S);
  }, L = (S, B) => {
    g.on(), C(S), b(B);
  };
  return /* @__PURE__ */ a.jsx(
    Xa,
    {
      sidebarCategories: (y == null ? void 0 : y.categories) || [],
      defaultActivePack: t,
      childContainerClassName: "bg-neutral-50 border-b lg:border-l border-neutral-200",
      ...e,
      sidebarReturnButtonText: e.sidebarReturnButtonText,
      secondaryContentReturnButtonText: (M == null ? void 0 : M.packConfig.title) || "",
      showBottomBar: u ? !N : !0,
      isSecondaryContentVisible: v,
      onCategoryItemClick: _,
      onSecondaryContentReturnButtonClick: () => {
        g.off();
      },
      onCloseButtonClick: c,
      showCtaButton: !!M && !(u && !N),
      isBroadband: r === "broadband",
      onCtaButtonClick: () => {
        M && (d && M.ctaLink && Ne({
          event: "view_item",
          content_type: ut,
          content_list_type: d.contentListType,
          content_title: M.packConfig.title,
          content_id: M.ctaLink,
          item_name: e.ctaButtonText
        }), o ? o(h) : window.location.href = M.ctaLink);
      },
      children: v ? /* @__PURE__ */ a.jsx(
        ic,
        {
          exploreType: r,
          platform: s,
          locale: n,
          secondaryContentId: x,
          secondaryContentType: j,
          environment: i
        }
      ) : /* @__PURE__ */ a.jsx(
        lo,
        {
          onAddOnClick: (S, B) => L(B, S),
          isSecondaryContentVisible: v,
          mainContentConfig: M,
          gaConfig: d
        }
      )
    }
  );
}, oc = ac, lc = ({
  popupConfig: e,
  isOpen: t,
  onCloseButtonClick: n,
  onCtaButtonClick: s,
  gaEventsConfig: r,
  viewOnly: i
}) => {
  const l = vt(e.environment, e.locale);
  return l ? /* @__PURE__ */ a.jsx(
    Xe,
    {
      open: t,
      wrapperClassName: "flex",
      panelClassName: "max-w-full h-full md:p-10 lg:py-8 xl:px-18 xl:max-w-7xl bg-transparent ",
      children: /* @__PURE__ */ a.jsx(
        oc,
        {
          layoutTextConfig: l.layoutTextConfig,
          ...e,
          viewOnly: i,
          onCloseButtonClick: n,
          onCtaButtonClick: s,
          gaEventsConfig: r
        }
      )
    }
  ) : null;
}, Ic = lc;
export {
  $e as ACCESS_TOKEN_COOKIE,
  jn as AccountIcon,
  De as ArrowIcon,
  Wn as BANNER_DISMISSED_COOKIE,
  ht as Badge,
  kc as BroadbandCard,
  $r as BurgerMenuIcon,
  Be as Button,
  jr as CHATBOT_USER_INFO,
  bc as Callout,
  jc as Checkbox,
  ke as CloseButton,
  Hr as CloseIcon,
  Qt as Collapse,
  qe as DEFAULT_LOCALE,
  Yr as ExploreIcon,
  Ec as Footer,
  Nc as Header,
  ae as HtmlText,
  ct as IconButton,
  Gn as LOCALE_COOKIE,
  Gt as LOCALE_EVENT,
  Sr as LOGIN_URL_EVENT,
  Dr as LanguageIcon,
  X as Link,
  Pc as LiveChat,
  Yn as MODAL_BANNER_DISMISSED_COOKIE,
  Xe as Modal,
  _c as NavProvider,
  Oc as Normalizer,
  Mc as PackCard,
  Gr as PlusIcon,
  ds as ProductCard,
  Ic as ProductPopup,
  Ge as REFRESH_TOKEN_COOKIE,
  Sc as RadioGroup,
  yr as SUPPORTED_LOCALES,
  Zn as SearchIcon,
  yc as Status,
  Tc as Switch,
  xt as TickIcon,
  Un as ULM_EPUID_COOKIE,
  vc as ULM_HANDLER_TRIGGERED_COOKIE,
  ot as ULM_PAYLOAD_COOKIE,
  Vt as ULM_PROFILE_EVENT,
  Ue as ULM_UUID_COOKIE,
  P as cn,
  Kt as createBemName,
  Xn as dispatchUlmProfileEvent,
  Ft as endChatbotSession,
  yn as extractConfig,
  zt as fetcher,
  ue as getCookie,
  Ye as getCookieDomain,
  gr as getErrorResponse,
  Ne as gtmPush,
  Kn as hasExistingSession,
  Cr as initLoginUrl,
  J as interpolate,
  hr as isApiResponse,
  xr as isErrorResponse,
  Zt as isSupportedLocale,
  Tr as isUlmProfile,
  je as logger,
  Er as logout,
  at as mergeLocale,
  _r as refreshSession,
  bn as removeCookie,
  Ht as removeCookies,
  wc as resizeImage,
  wr as satayCase,
  ve as setCookie,
  vr as startChatbotSession,
  qn as toggleLocale,
  Se as useAsync,
  ne as useBoolean,
  le as useBreakpoint,
  Qr as useConst,
  Jt as useDfConfig,
  ua as useNavConfig,
  Cc as useOrientation,
  es as useUrlWithUtmQuery
};
